var PROXY_TYPE;
(function (PROXY_TYPE) {
  PROXY_TYPE["RESIDENTIAL"] = "residential_proxies";
  PROXY_TYPE["MOBILE"] = "mobile_proxies";
  PROXY_TYPE["STATIC_ISP"] = "static_isp_proxies";
  PROXY_TYPE["SHARED_ISP"] = "shared_isp_ip_proxies";
  PROXY_TYPE["DEDICATED_ISP"] = "dedicated_isp_proxies";
  PROXY_TYPE["SHARED"] = "shared_proxies";
  PROXY_TYPE["SHARED_DC"] = "shared_dc_proxies";
  PROXY_TYPE["SHARED_DC_GB"] = "shared_dc_gb_proxies";
  PROXY_TYPE["DDC"] = "dedicated_dc_proxies";
  PROXY_TYPE["SITE_UNBLOCKER"] = "rtc_site_unblocker_proxies";
  PROXY_TYPE["SITE_UNBLOCKER_REQ"] = "rtc_site_unblocker_req_proxies";
  PROXY_TYPE["SERP"] = "rtc_proxies";
  PROXY_TYPE["ECOMMERCE"] = "rtc_ecommerce_proxies";
  PROXY_TYPE["UNIVERSAL"] = "rtc_universal_proxies";
  PROXY_TYPE["SOCIAL_MEDIA"] = "rtc_social_media_proxies";
})(PROXY_TYPE || (PROXY_TYPE = {}));
var SCRAPING_PRODUCT;
(function (SCRAPING_PRODUCT) {
  SCRAPING_PRODUCT["SERP"] = "rtc_proxies";
  SCRAPING_PRODUCT["ECOMMERCE"] = "rtc_ecommerce_proxies";
  SCRAPING_PRODUCT["UNIVERSAL"] = "rtc_universal_proxies";
  SCRAPING_PRODUCT["SOCIAL_MEDIA"] = "rtc_social_media_proxies";
  SCRAPING_PRODUCT["SITE_UNBLOCKER"] = "rtc_site_unblocker_proxies";
  SCRAPING_PRODUCT["SITE_UNBLOCKER_REQ"] = "rtc_site_unblocker_req_proxies";
})(SCRAPING_PRODUCT || (SCRAPING_PRODUCT = {}));
const globalDocs = 'https://help.smartproxy.com/docs';
const chinaDocs = 'https://help.smartdaili.cn/docs';

const getLocaleOptions = localeOptions => {
  return localeOptions.map(locale => ({
    label: localeDetails[locale]?.description ?? '',
    value: locale
  })).sort((a, b) => {
    const descA = a.label.toLowerCase();
    const descB = b.label.toLowerCase();
    if (descA < descB) {
      return -1;
    }
    if (descA > descB) {
      return 1;
    }
    return 0;
  });
};

const NO_SELECTION = '';
const resultLocaleOptions = ['af', 'ar', 'hy', 'be', 'bg', 'ca', 'zh-CN', 'zh-TW', 'hr', 'cs', 'da', 'nl', 'en', 'eo', 'et', 'tl', 'fi', 'fr', 'de', 'el', 'ie', 'hi', 'hu', 'is', 'id', 'it', 'ja', 'ko', 'lv', 'lt', 'no', 'fa', 'pl', 'pt', 'ro', 'ru', 'sr', 'sk', 'sl', 'es', 'sw', 'sv', 'th', 'tr', 'uk', 'vi'];
const localeDetails = {
  '': {
    description: 'No selection',
    domain: 'com'
  },
  'en-ai': {
    description: 'Anguilla - English',
    domain: 'com.ai'
  },
  'es-pr': {
    description: 'Puerto Rico - Spanish',
    domain: 'com.pr'
  },
  'nl-sr': {
    description: 'Suriname - Dutch',
    domain: 'sr'
  },
  'fr-ml': {
    description: 'Mali - French',
    domain: 'ml'
  },
  'en-lb': {
    description: 'Lebanon - English',
    domain: 'com.lb'
  },
  'fr-bf': {
    description: 'Burkina Faso - French',
    domain: 'bf'
  },
  'en-fm': {
    description: 'Federated States of Micronesia - English',
    domain: 'fm'
  },
  'es-mx': {
    description: 'Mexico - Spanish',
    domain: 'com.mx'
  },
  'fr-bj': {
    description: 'Benin - French',
    domain: 'bj'
  },
  'ru-ee': {
    description: 'Estonia - Russian',
    domain: 'ee'
  },
  'en-mv': {
    description: 'Maldives - English',
    domain: 'mv'
  },
  'fr-ne': {
    description: 'Niger - French',
    domain: 'ne'
  },
  'de-at': {
    description: 'Austria - German',
    domain: 'at'
  },
  'en-gg': {
    description: 'Guernsey - English',
    domain: 'gg'
  },
  'ar-ae': {
    description: 'United Arab Emirates - Arabic',
    domain: 'ae'
  },
  'ru-uz': {
    description: 'Uzbekistan - Russian',
    domain: 'co.uz'
  },
  'ru-am': {
    description: 'Armenia - Russian',
    domain: 'am'
  },
  'en-sa': {
    description: 'Saudi Arabia - English',
    domain: 'com.sa'
  },
  'pt-tl': {
    description: 'Timor-Leste - Portuguese',
    domain: 'tl'
  },
  'en-na': {
    description: 'Namibia - English',
    domain: 'com.na'
  },
  'ar-bh': {
    description: 'Bahrain - Arabic',
    domain: 'com.bh'
  },
  'da-dk': {
    description: 'Denmark - Danish',
    domain: 'dk'
  },
  'en-sb': {
    description: 'Solomon Islands - English',
    domain: 'com.sb'
  },
  'ro-ro': {
    description: 'Romania - Romanian',
    domain: 'ro'
  },
  'ru-by': {
    description: 'Belarus - Russian',
    domain: 'by'
  },
  'es-co': {
    description: 'Colombia - Spanish',
    domain: 'com.co'
  },
  'en-gi': {
    description: 'Gibraltar - English',
    domain: 'com.gi'
  },
  'en-id': {
    description: 'Indonesia - English',
    domain: 'co.id'
  },
  'en-ms': {
    description: 'Montserrat - English',
    domain: 'ms'
  },
  'en-ng': {
    description: 'Nigeria - English',
    domain: 'com.ng'
  },
  'is-is': {
    description: 'Iceland - Icelandic',
    domain: 'is'
  },
  'ar-eg': {
    description: 'Egypt - Arabic',
    domain: 'com.eg'
  },
  'so-et': {
    description: 'Ethiopia - Somali',
    domain: 'com.et'
  },
  'ps-af': {
    description: 'Afghanistan - Pashto',
    domain: 'com.af'
  },
  'de-ch': {
    description: 'Switzerland - German',
    domain: 'ch'
  },
  'kg-ao': {
    description: 'Angola - Kikongo',
    domain: 'co.ao'
  },
  'es-cl': {
    description: 'Chile - Spanish',
    domain: 'cl'
  },
  'af-za': {
    description: 'South Africa - Afrikaans',
    domain: 'co.za'
  },
  'en-nf': {
    description: 'Norfolk Island - English',
    domain: 'com.nf'
  },
  'de-ro': {
    description: 'Romania - German',
    domain: 'ro'
  },
  'fo-dk': {
    description: 'Denmark - Faroese',
    domain: 'dk'
  },
  'mo-md': {
    description: 'Moldova - Moldovan',
    domain: 'md'
  },
  'ca-es': {
    description: 'Spain - Catalan',
    domain: 'es'
  },
  'en-et': {
    description: 'Ethiopia - English',
    domain: 'com.et'
  },
  'yo-bj': {
    description: 'Benin - Yoruba',
    domain: 'bj'
  },
  'hu-hu': {
    description: 'Hungary - Hungarian',
    domain: 'hu'
  },
  'so-dj': {
    description: 'Djibouti - Somali',
    domain: 'dj'
  },
  'mt-mt': {
    description: 'Malta - Maltese',
    domain: 'com.mt'
  },
  'es-ec': {
    description: 'Ecuador - Spanish',
    domain: 'com.ec'
  },
  'bn-in': {
    description: 'India - Bengali',
    domain: 'co.in'
  },
  'si-lk': {
    description: 'Sri Lanka - Sinhala',
    domain: 'lk'
  },
  'sw-ke': {
    description: 'Kenya - Swahili',
    domain: 'co.ke'
  },
  'en-gy': {
    description: 'Guyana - English',
    domain: 'gy'
  },
  'fr-be': {
    description: 'Belgium - French',
    domain: 'be'
  },
  'en-vg': {
    description: 'British Virgin Islands - English',
    domain: 'vg'
  },
  'en-bw': {
    description: 'Botswana - English',
    domain: 'co.bw'
  },
  'zh-vn': {
    description: 'Vietnam - Taiwanese',
    domain: 'com.vn'
  },
  'en-tz': {
    description: 'Tanzania - English',
    domain: 'co.tz'
  },
  'ha-ne': {
    description: 'Niger - Hausa',
    domain: 'ne'
  },
  'zu-zw': {
    description: 'Zimbabwe - Ndebele',
    domain: 'co.zw'
  },
  'to-to': {
    description: 'Tonga - Tongan',
    domain: 'to'
  },
  'kk-kz': {
    description: 'Kazakhstan - Kazakh',
    domain: 'kz'
  },
  'es-uy': {
    description: 'Uruguay - Spanish',
    domain: 'com.uy'
  },
  'ar-iq': {
    description: 'Iraq - Arabic',
    domain: 'iq'
  },
  'zh-tw': {
    description: 'Taiwan - Chinese',
    domain: 'com.tw'
  },
  'en-za': {
    description: 'South Africa - English',
    domain: 'co.za'
  },
  'de-na': {
    description: 'Namibia - German',
    domain: 'com.na'
  },
  'zh-cn-hk': {
    description: 'Hong Kong - Chinese (Simplified Han)',
    domain: 'com.hk'
  },
  'rw-rw': {
    description: 'Rwanda - Kinyarwanda',
    domain: 'rw'
  },
  'ca-ad': {
    description: 'Andorra - Catalan',
    domain: 'ad'
  },
  'en-ly': {
    description: 'Libya - English',
    domain: 'com.ly'
  },
  'sq-al': {
    description: 'Albania - Albanian',
    domain: 'al'
  },
  'en-il': {
    description: 'Israel - English',
    domain: 'co.il'
  },
  'en-ki': {
    description: 'Kiribati - English',
    domain: 'ki'
  },
  'fr-lb': {
    description: 'Lebanon - French',
    domain: 'com.lb'
  },
  'fr-bi': {
    description: 'Burundi - French',
    domain: 'bi'
  },
  'en-us': {
    description: 'United States - English',
    domain: 'com'
  },
  'fr-mu': {
    description: 'Mauritius - French',
    domain: 'mu'
  },
  'en-sc': {
    description: 'Seychelles - English',
    domain: 'sc'
  },
  'zh-hk-hk': {
    description: 'Hong Kong - Chinese (Traditional Han)',
    domain: 'com.hk'
  },
  'en-pa': {
    description: 'Panama - English',
    domain: 'com.pa'
  },
  'en-ca': {
    description: 'Canada - English',
    domain: 'ca'
  },
  'ka-ge': {
    description: 'Georgia - Kartuli',
    domain: 'ge'
  },
  'pt-gi': {
    description: 'Gibraltar - Portuguese',
    domain: 'com.gi'
  },
  'fr-rw': {
    description: 'Rwanda - French',
    domain: 'rw'
  },
  'ta-in': {
    description: 'India - Tamil',
    domain: 'co.in'
  },
  'en-qa': {
    description: 'Qatar - English',
    domain: 'com.qa'
  },
  'es-gt': {
    description: 'Guatemala - Spanish',
    domain: 'com.gt'
  },
  'de-li': {
    description: 'Liechtenstein - German',
    domain: 'li'
  },
  'fr-vn': {
    description: 'Vietnam - French',
    domain: 'com.vn'
  },
  'km-kh': {
    description: 'Cambodia - Kmher',
    domain: 'com.kh'
  },
  'ka-in': {
    description: 'India - Kannada',
    domain: 'co.in'
  },
  'ar-lb': {
    description: 'Lebanon - Arabic',
    domain: 'com.lb'
  },
  'en-cr': {
    description: 'Costa Rica - English',
    domain: 'co.cr'
  },
  'qu-bo': {
    description: 'Bolivia - Quechua',
    domain: 'com.bo'
  },
  'es-ve': {
    description: 'Venezuela - Spanish',
    domain: 'co.ve'
  },
  'es-ni': {
    description: 'Nicaragua - Spanish',
    domain: 'com.ni'
  },
  'en-pr': {
    description: 'Puerto Rico - English',
    domain: 'com.pr'
  },
  'ar-td': {
    description: 'Chad - Arabic',
    domain: 'td'
  },
  'fr-cf': {
    description: 'Central African Republic - French',
    domain: 'cf'
  },
  'en-tk': {
    description: 'Tokelau - English',
    domain: 'tk'
  },
  'en-ni': {
    description: 'Nicaragua - English',
    domain: 'com.ni'
  },
  'sw-bi': {
    description: 'Burundi - Swahili',
    domain: 'bi'
  },
  'es-cr': {
    description: 'Costa Rica - Spanish',
    domain: 'co.cr'
  },
  'mg-mg': {
    description: 'Madagascar - Malagasy',
    domain: 'mg'
  },
  'bn-bd': {
    description: 'Bangladesh - Bengali',
    domain: 'com.bd'
  },
  'en-bz': {
    description: 'Belize - English',
    domain: 'com.bz'
  },
  'ar-sa': {
    description: 'Saudi Arabia - Arabic',
    domain: 'com.sa'
  },
  'en-gm': {
    description: 'Gambia - English',
    domain: 'gm'
  },
  'lo-la': {
    description: 'Laos - Lao',
    domain: 'la'
  },
  'yo-ng': {
    description: 'Nigeria - Yoruba',
    domain: 'com.ng'
  },
  'zu-za': {
    description: 'South Africa - IsiZulu',
    domain: 'co.za'
  },
  'jw-id': {
    description: 'Indonesia - Javanese',
    domain: 'co.id'
  },
  'en-kw': {
    description: 'Kuwait - English',
    domain: 'com.kw'
  },
  'fr-ch': {
    description: 'Switzerland - French',
    domain: 'ch'
  },
  'en-la': {
    description: 'Laos - English',
    domain: 'la'
  },
  'fr-cm': {
    description: 'Cameroon - French',
    domain: 'cm'
  },
  'ht-ht': {
    description: 'Haiti - Haitian Creole',
    domain: 'ht'
  },
  'en-is': {
    description: 'Iceland - English',
    domain: 'is'
  },
  'no-no': {
    description: 'Norway - Norwegian',
    domain: 'no'
  },
  'en-fj': {
    description: 'Fiji - English',
    domain: 'com.fj'
  },
  'tk-tm': {
    description: 'Turkmenistan - Turkmen',
    domain: 'tm'
  },
  'en-sl': {
    description: 'Siera Leone - English',
    domain: 'com.sl'
  },
  'en-mm': {
    description: 'Myanmar - English',
    domain: 'com.mm'
  },
  'en-im': {
    description: 'Isle of Man - English',
    domain: 'im'
  },
  'sl-si': {
    description: 'Slovenia - Slovenian',
    domain: 'si'
  },
  'ar-qa': {
    description: 'Qatar - Arabic',
    domain: 'com.qa'
  },
  'es-gi': {
    description: 'Gibraltar - Spanish',
    domain: 'com.gi'
  },
  'my-mm': {
    description: 'Myanmar - Burmese',
    domain: 'com.mm'
  },
  'es-pe': {
    description: 'Peru - Spanish',
    domain: 'com.pe'
  },
  'fr-cd': {
    description: 'The Democratic Republic of the Congo - French',
    domain: 'cd'
  },
  'fr-tt': {
    description: 'Trinidad and Tobago - French',
    domain: 'tt'
  },
  'sw-tz': {
    description: 'Tanzania - Swahili',
    domain: 'co.tz'
  },
  'es-bz': {
    description: 'Belize - Spanish',
    domain: 'com.bz'
  },
  'es-bo': {
    description: 'Bolivia - Spanish',
    domain: 'com.bo'
  },
  'tr-tr': {
    description: 'Turkey - Turkish',
    domain: 'com.tr'
  },
  'uz-uz': {
    description: 'Uzbekistan - Uzbek',
    domain: 'co.uz'
  },
  'en-mt': {
    description: 'Malta - English',
    domain: 'com.mt'
  },
  'fr-tg': {
    description: 'Togo - French',
    domain: 'tg'
  },
  'en-ls': {
    description: 'Lesotho - English',
    domain: 'co.ls'
  },
  'el-gr': {
    description: 'Greece - Greek',
    domain: 'gr'
  },
  'be-by': {
    description: 'Belarus - Belarusian',
    domain: 'by'
  },
  'pa-in': {
    description: 'India - Punjabi',
    domain: 'co.in'
  },
  'en-gl': {
    description: 'Greenland - English',
    domain: 'gl'
  },
  'mk-mk': {
    description: 'Macedonia - Macedonian',
    domain: 'mk'
  },
  'en-cm': {
    description: 'Cameroon - English',
    domain: 'cm'
  },
  'en-zm': {
    description: 'Zambia - English',
    domain: 'co.zm'
  },
  'fil-ph': {
    description: 'Philippines - Filipino',
    domain: 'com.ph'
  },
  'fr-dj': {
    description: 'Djibouti - French',
    domain: 'dj'
  },
  'it-it': {
    description: 'Italy - Italian',
    domain: 'it'
  },
  'ja-jp': {
    description: 'Japan - Japanese',
    domain: 'co.jp'
  },
  'en-ws': {
    description: 'Samoa - English',
    domain: 'ws'
  },
  'en-lk': {
    description: 'Sri Lanka - English',
    domain: 'lk'
  },
  'en-bh': {
    description: 'Bahrain - English',
    domain: 'com.bh'
  },
  'es-ar': {
    description: 'Argentina - Spanish',
    domain: 'com.ar'
  },
  'pt-mz': {
    description: 'Mozambique - Portuguese',
    domain: 'co.mz'
  },
  'crs-sc': {
    description: 'Seychelles - Seychellois Creole',
    domain: 'sc'
  },
  'az-az': {
    description: 'Azerbaijan - Azerbaijani',
    domain: 'az'
  },
  'en-ck': {
    description: 'Cook Islands - English',
    domain: 'co.ck'
  },
  'fi-fi': {
    description: 'Finland - Finnish',
    domain: 'fi'
  },
  'ms-bn': {
    description: 'Brunei - Malay',
    domain: 'com.bn'
  },
  'pt-pt': {
    description: 'Portugal - Portuguese',
    domain: 'pt'
  },
  'fr-td': {
    description: 'Chad - French',
    domain: 'td'
  },
  'ar-dj': {
    description: 'Djibouti - Arabic',
    domain: 'dj'
  },
  'sn-zw': {
    description: 'Zimbabwe - Shona',
    domain: 'co.zw'
  },
  'hi-in': {
    description: 'India - Hindi',
    domain: 'co.in'
  },
  'ru-tj': {
    description: 'Tajikistan - Russian',
    domain: 'com.tj'
  },
  'zh-cn': {
    description: 'China - Chinese (Simplified)',
    domain: 'com.hk'
  },
  'en-bn': {
    description: 'Brunei - English',
    domain: 'com.bn'
  },
  'ig-ng': {
    description: 'Nigeria - Igbo',
    domain: 'com.ng'
  },
  'ta-lk': {
    description: 'Sri Lanka - Tamil',
    domain: 'lk'
  },
  'en-cy': {
    description: 'Cyprus - English',
    domain: 'com.cy'
  },
  'pt-cv': {
    description: 'Cape Verde - Portuguese',
    domain: 'cv'
  },
  'en-my': {
    description: 'Malaysia - English',
    domain: 'com.my'
  },
  'en-ie': {
    description: 'Ireland - English',
    domain: 'ie'
  },
  'ha-ng': {
    description: 'Nigeria - Hausa',
    domain: 'com.ng'
  },
  'en-al': {
    description: 'Albania - English',
    domain: 'al'
  },
  'en-sg': {
    description: 'Singapore - English',
    domain: 'com.sg'
  },
  'de-de': {
    description: 'Germany - German',
    domain: 'de'
  },
  'ms-sg': {
    description: 'Singapore - Malay',
    domain: 'com.sg'
  },
  'af-na': {
    description: 'Namibia - Afrikaans',
    domain: 'com.na'
  },
  'ml-in': {
    description: 'India - Malayalam',
    domain: 'co.in'
  },
  'sr-ba': {
    description: 'Bosnia and Herzegovina - Serbian',
    domain: 'ba'
  },
  'de-lu': {
    description: 'Luxembourg - German',
    domain: 'lu'
  },
  'bg-bg': {
    description: 'Bulgaria - Bulgarian',
    domain: 'bg'
  },
  'en-vi': {
    description: 'United States Virgin Islands - English',
    domain: 'co.vi'
  },
  'ar-om': {
    description: 'Oman - Arabic',
    domain: 'com.om'
  },
  'id-id': {
    description: 'Indonesia - Indonesian',
    domain: 'co.id'
  },
  'en-as': {
    description: 'American Samoa - English',
    domain: 'as'
  },
  'sv-fi': {
    description: 'Finland - Swedish',
    domain: 'fi'
  },
  'bs-ba': {
    description: 'Bosnia and Herzegovina - Bosnian',
    domain: 'ba'
  },
  'es-tt': {
    description: 'Trinidad and Tobago - Spanish',
    domain: 'tt'
  },
  'te-in': {
    description: 'India - Telugu',
    domain: 'co.in'
  },
  'en-to': {
    description: 'Tonga - English',
    domain: 'to'
  },
  'ru-az': {
    description: 'Azerbaijan - Russian',
    domain: 'az'
  },
  'fr-dz': {
    description: 'Algeria - French',
    domain: 'dz'
  },
  'fr-fr': {
    description: 'France - French',
    domain: 'fr'
  },
  'tn-bw': {
    description: 'Botswana - Tswana',
    domain: 'co.bw'
  },
  'ru-lv': {
    description: 'Latvia - Russian',
    domain: 'lv'
  },
  'lt-lt': {
    description: 'Lithuania - Lithuanian',
    domain: 'lt'
  },
  'en-ps': {
    description: 'Palestinian territories - English',
    domain: 'ps'
  },
  'sv-se': {
    description: 'Sweden - Swedish',
    domain: 'se'
  },
  'it-ch': {
    description: 'Switzerland - Italian',
    domain: 'ch'
  },
  'el-cy': {
    description: 'Cyprus - Greek',
    domain: 'com.cy'
  },
  'sw-rw': {
    description: 'Rwanda - Swahili',
    domain: 'rw'
  },
  'fr-cg': {
    description: 'Republic of the Congo - French',
    domain: 'cg'
  },
  'fa-af': {
    description: 'Afghanistan - Persian',
    domain: 'com.af'
  },
  'en-nr': {
    description: 'Nauru - English',
    domain: 'nr'
  },
  'zh-bn': {
    description: 'Brunei - Chinese',
    domain: 'com.bn'
  },
  'sw-ug': {
    description: 'Uganda - Kiswahili',
    domain: 'co.ug'
  },
  'en-ht': {
    description: 'Haiti - English',
    domain: 'ht'
  },
  'en-vc': {
    description: 'Saint Vincent and the Grenadines - English',
    domain: 'com.vc'
  },
  'gu-in': {
    description: 'India - Gujarati',
    domain: 'co.in'
  },
  'hr-ba': {
    description: 'Bosnia and Herzegovina - Croatian',
    domain: 'ba'
  },
  'en-jo': {
    description: 'Jordan - English',
    domain: 'jo'
  },
  'en-th': {
    description: 'Thailand - English',
    domain: 'co.th'
  },
  'en-ch': {
    description: 'Switzerland - English',
    domain: 'ch'
  },
  'sr-rs': {
    description: 'Serbia - Serbian',
    domain: 'rs'
  },
  'ar-dz': {
    description: 'Algeria - Arabic',
    domain: 'dz'
  },
  'rm-ch': {
    description: 'Switzerland - Rumantsch',
    domain: 'ch'
  },
  'en-bs': {
    description: 'Bahamas - English',
    domain: 'bs'
  },
  'en-pk': {
    description: 'Pakistan - English',
    domain: 'com.pk'
  },
  'en-eg': {
    description: 'Egypt - English',
    domain: 'com.eg'
  },
  'tg-tj': {
    description: 'Tajikistan - Tajik',
    domain: 'com.tj'
  },
  'es-pa': {
    description: 'Panama - Spanish',
    domain: 'com.pa'
  },
  'en-gb': {
    description: 'United Kingdom - English',
    domain: 'co.uk'
  },
  'fr-gg': {
    description: 'Guernsey - French',
    domain: 'gg'
  },
  'nso-za': {
    description: 'South Africa - Nothern Sotho',
    domain: 'co.za'
  },
  'so-so': {
    description: 'Somalia - Somali',
    domain: 'so'
  },
  'fr-ga': {
    description: 'Gabon - French',
    domain: 'ga'
  },
  'ru-ua': {
    description: 'Ukraine - Russian',
    domain: 'com.ua'
  },
  'hr-hr': {
    description: 'Croatia - Croatian',
    domain: 'hr'
  },
  'es-cu': {
    description: 'Cuba - Spanish',
    domain: 'com.cu'
  },
  'ar-il': {
    description: 'Israel - Arabic',
    domain: 'co.il'
  },
  'sk-sk': {
    description: 'Slovakia - Slovak',
    domain: 'sk'
  },
  'en-np': {
    description: 'Nepal - English',
    domain: 'com.np'
  },
  'iw-il': {
    description: 'Israel - Hebrew',
    domain: 'co.il'
  },
  'en-nu': {
    description: 'Niue - English',
    domain: 'nu'
  },
  'mn-mn': {
    description: 'Mongolia - Mongolian',
    domain: 'mn'
  },
  'en-vu': {
    description: 'Vanuatu - English',
    domain: 'vu'
  },
  'ga-ie': {
    description: 'Ireland - Irish',
    domain: 'ie'
  },
  'wo-gm': {
    description: 'Gambia - Wolof',
    domain: 'gm'
  },
  'uk-ua': {
    description: 'Ukraine - Ukranian',
    domain: 'com.ua'
  },
  'nl-nl': {
    description: 'Netherlands - Dutch',
    domain: 'nl'
  },
  'pt-st': {
    description: 'S\u00e3o Tom\u00e9 and Pr\u00edncipe - Portuguese',
    domain: 'st'
  },
  'tn-za': {
    description: 'South Africa - Setswana',
    domain: 'co.za'
  },
  'en-om': {
    description: 'Oman - English',
    domain: 'com.om'
  },
  'pt-br': {
    description: 'Brazil - Portuguese',
    domain: 'com.br'
  },
  'ru-tm': {
    description: 'Turkmenistan - Russian',
    domain: 'tm'
  },
  'en-ph': {
    description: 'Philippines - English',
    domain: 'com.ph'
  },
  'th-th': {
    description: 'Thailand - Thai',
    domain: 'co.th'
  },
  'ny-mw': {
    description: 'Malawi - Chichewa',
    domain: 'mw'
  },
  'en-iq': {
    description: 'Iraq - English',
    domain: 'iq'
  },
  'en-pg': {
    description: 'Papua New Guinea - English',
    domain: 'com.pg'
  },
  'et-ee': {
    description: 'Estonia - Estonian',
    domain: 'ee'
  },
  'pl-pl': {
    description: 'Poland - Polish',
    domain: 'pl'
  },
  'en-nz': {
    description: 'New Zealand - English',
    domain: 'co.nz'
  },
  'en-ug': {
    description: 'Uganda - English',
    domain: 'co.ug'
  },
  'ne-np': {
    description: 'Nepal - Nepali',
    domain: 'com.np'
  },
  'da-gl': {
    description: 'Greenland - Danish',
    domain: 'gl'
  },
  'en-sr': {
    description: 'Suriname - English',
    domain: 'sr'
  },
  'en-rw': {
    description: 'Rwanda - English',
    domain: 'rw'
  },
  'it-ly': {
    description: 'Libya - Italian',
    domain: 'com.ly'
  },
  'fr-vu': {
    description: 'Vanuatu - French',
    domain: 'vu'
  },
  'hy-am': {
    description: 'Armenia - Armenian',
    domain: 'am'
  },
  'ky-kg': {
    description: 'Kurgyzstan - Kyrgyz',
    domain: 'kg'
  },
  'fr-ci': {
    description: 'Ivory Coast - French',
    domain: 'ci'
  },
  'en-sh': {
    description: 'Saint Helena, Ascension and Tristan da Cunha - English',
    domain: 'sh'
  },
  'es-do': {
    description: 'Dominican Republic - Spanish',
    domain: 'com.do'
  },
  'fr-sc': {
    description: 'Seychelles - French',
    domain: 'sc'
  },
  'fr-sn': {
    description: 'Senegal - French',
    domain: 'sn'
  },
  'en-mw': {
    description: 'Malawi - English',
    domain: 'mw'
  },
  'en-jm': {
    description: 'Jamaica - English',
    domain: 'com.jm'
  },
  'ar-ma': {
    description: 'Morocco - Arabic',
    domain: 'co.ma'
  },
  'en-bd': {
    description: 'Bangladesh - English',
    domain: 'com.bd'
  },
  'ur-pk': {
    description: 'Pakistan - Urdu',
    domain: 'com.pk'
  },
  'rn-bi': {
    description: 'Burundi - Kirundi',
    domain: 'bi'
  },
  'ar-ly': {
    description: 'Libya - Arabic',
    domain: 'com.ly'
  },
  'en-be': {
    description: 'Belgium - English',
    domain: 'be'
  },
  'tr-cy': {
    description: 'Cyprus - Turkish',
    domain: 'com.cy'
  },
  'en-tn': {
    description: 'Tunisia - English',
    domain: 'com.tn'
  },
  'ru-ru': {
    description: 'Russia - Russian',
    domain: 'ru'
  },
  'en-dm': {
    description: 'Dominica - English',
    domain: 'dm'
  },
  'es-us': {
    description: 'United States - Spanish',
    domain: 'com'
  },
  'es-sv': {
    description: 'El Salvador - Spanish',
    domain: 'com.sv'
  },
  'zh-sg': {
    description: 'Singapore - Chinese',
    domain: 'com.sg'
  },
  'ar-so': {
    description: 'Somalia - Arabic',
    domain: 'so'
  },
  'vi-vn': {
    description: 'Vietnam - Vietnamese',
    domain: 'com.vn'
  },
  'ar-jo': {
    description: 'Jordan - Arabic',
    domain: 'jo'
  },
  'fr-gp': {
    description: 'Guadeloupe - French',
    domain: 'gp'
  },
  'sr-me': {
    description: 'Montenegro - Serbian',
    domain: 'me'
  },
  'pt-ao': {
    description: 'Angola - Portuguese',
    domain: 'co.ao'
  },
  'en-ag': {
    description: 'Antigua and Barbuda - English',
    domain: 'com.ag'
  },
  'cs-cz': {
    description: 'Czech Republic - Czech',
    domain: 'cz'
  },
  'es-py': {
    description: 'Paraguay - Spanish',
    domain: 'com.py'
  },
  'fr-ht': {
    description: 'Haiti - French',
    domain: 'ht'
  },
  'mr-in': {
    description: 'India - Marathi',
    domain: 'co.in'
  },
  'en-gh': {
    description: 'Ghana - English',
    domain: 'com.gh'
  },
  'en-tt': {
    description: 'Trinidad and Tobago - English',
    domain: 'tt'
  },
  'st-ls': {
    description: 'Lesotho - Sesotho',
    domain: 'co.ls'
  },
  'it-gi': {
    description: 'Gibraltar - Italian',
    domain: 'com.gi'
  },
  'en-so': {
    description: 'Somalia - English',
    domain: 'so'
  },
  'fr-ca': {
    description: 'Canada - French',
    domain: 'ca'
  },
  'en-bt': {
    description: 'Bhutan - English',
    domain: 'bt'
  },
  'de-be': {
    description: 'Belgium - German',
    domain: 'be'
  },
  'fr-lu': {
    description: 'Luxembourg - French',
    domain: 'lu'
  },
  'fr-mg': {
    description: 'Madagascar - French',
    domain: 'mg'
  },
  'ru-kz': {
    description: 'Kazakhstan - Russian',
    domain: 'kz'
  },
  'it-sm': {
    description: 'San Marino - Italian',
    domain: 'sm'
  },
  'en-hk': {
    description: 'Hong Kong - English',
    domain: 'com.hk'
  },
  'en-je': {
    description: 'Jersey - English',
    domain: 'je'
  },
  'en-vn': {
    description: 'Vietnam - English',
    domain: 'com.vn'
  },
  'hu-ro': {
    description: 'Romania - Hungarian',
    domain: 'ro'
  },
  'xh-za': {
    description: 'South Africa - IsiXhosa',
    domain: 'co.za'
  },
  'en-zw': {
    description: 'Zimbabwe - English',
    domain: 'co.zw'
  },
  'en-kh': {
    description: 'Cambodia - English',
    domain: 'com.kh'
  },
  'lv-lv': {
    description: 'Latvia - Latvian',
    domain: 'lv'
  },
  'bs-me': {
    description: 'Montenegro - Croatian',
    domain: 'me'
  },
  'ru-kg': {
    description: 'Kurgyzstan - Russian',
    domain: 'kg'
  },
  'fr-ma': {
    description: 'Morocco - French',
    domain: 'co.ma'
  },
  'ar-tn': {
    description: 'Tunisia - Arabic',
    domain: 'tn'
  },
  'en-au': {
    description: 'Australia - English',
    domain: 'com.au'
  },
  // 'sr-me-me': {
  //   description: 'Montenegro - Montenegrin',
  //   domain: 'me',
  // },
  'st-za': {
    description: 'South Africa - Sesotho',
    domain: 'co.za'
  },
  'lt-lv': {
    description: 'Latvia - Lithuanian',
    domain: 'lv'
  },
  'am-et': {
    description: 'Ethiopia - Amharic',
    domain: 'com.et'
  },
  'en-pn': {
    description: 'Pitcairn Island - English',
    domain: 'pn'
  },
  'es-hn': {
    description: 'Honduras - Spanish',
    domain: 'hn'
  },
  'mfe-mu': {
    description: 'Mauritius - Mauritian Creole',
    domain: 'mu'
  },
  'es-es': {
    description: 'Spain - Spanish',
    domain: 'es'
  },
  'en-ke': {
    description: 'Kenya - English',
    domain: 'co.ke'
  },
  'mi-nz': {
    description: 'New Zealand - Maori',
    domain: 'co.nz'
  },
  'ru-md': {
    description: 'Moldova - Russian',
    domain: 'md'
  },
  'nl-be': {
    description: 'Belgium - Dutch',
    domain: 'be'
  },
  'ko-kr': {
    description: 'South Korea - Korean',
    domain: 'co.kr'
  },
  'en-mu': {
    description: 'Mauritius - English',
    domain: 'mu'
  },
  'en-ae': {
    description: 'United Arab Emirates - English',
    domain: 'ae'
  },
  'ar-kw': {
    description: 'Kuwait - Arabic',
    domain: 'com.kw'
  },
  'ms-my': {
    description: 'Malaysia - Malay',
    domain: 'com.my'
  },
  'ta-sg': {
    description: 'Singapore - Tamil',
    domain: 'com.sg'
  },
  'ar-ps': {
    description: 'Palestinian territories - Arabic',
    domain: 'ps'
  },
  'en-by': {
    description: 'Belarus - English',
    domain: 'by'
  },
  'en-in': {
    description: 'India - English',
    domain: 'co.in'
  },
  'ko-us': {
    description: 'United States - Korean',
    domain: 'com'
  },
  'vi-us': {
    description: 'United States - Vietnamese',
    domain: 'com'
  },
  'zh-cn-us': {
    description: 'United States - Simplified Chinese',
    domain: 'com'
  },
  'zh-tw-us': {
    description: 'United States - Traditional Chinese',
    domain: 'com'
  },
  'es-419-ar': {
    description: 'Argentina - Latin American Spanish',
    domain: 'com.ar'
  },
  'es-419-bo': {
    description: 'Bolivia - Latin American Spanish',
    domain: 'com.bo'
  },
  'es-419-bz': {
    description: 'Belize - Latin American Spanish',
    domain: 'com.bz'
  },
  'es-419-ca': {
    description: 'Canada - Latin American Spanish',
    domain: 'ca'
  },
  'es-419-cl': {
    description: 'Chile - Latin American Spanish',
    domain: 'cl'
  },
  'es-419-co': {
    description: 'Colombia - Latin American Spanish',
    domain: 'com.co'
  },
  'es-419-cr': {
    description: 'Costa Rica - Latin American Spanish',
    domain: 'co.cr'
  },
  'es-419-cu': {
    description: 'Cuba - Latin American Spanish',
    domain: 'com.cu'
  },
  'es-419-do': {
    description: 'Dominican Republic - Latin American Spanish',
    domain: 'com.do'
  },
  'es-419-ec': {
    description: 'Ecuador - Latin American Spanish',
    domain: 'com.ec'
  },
  'es-419-gt': {
    description: 'Guatemala - Latin American Spanish',
    domain: 'com.gt'
  },
  'es-419-hn': {
    description: 'Honduras - Latin American Spanish',
    domain: 'hn'
  },
  'es-419-mx': {
    description: 'Mexico - Latin American Spanish',
    domain: 'com.mx'
  },
  'es-419-ni': {
    description: 'Nicaragua - Latin American Spanish',
    domain: 'com.ni'
  },
  'es-419-pa': {
    description: 'Panama - Latin American Spanish',
    domain: 'com.pa'
  },
  'es-419-pe': {
    description: 'Peru - Latin American Spanish',
    domain: 'com.pe'
  },
  'es-419-pr': {
    description: 'Puerto Rico - Latin American Spanish',
    domain: 'com.pr'
  },
  'es-419-py': {
    description: 'Paraguay - Latin American Spanish',
    domain: 'com.py'
  },
  'es-419-sv': {
    description: 'El Salvador - Latin American Spanish',
    domain: 'com.sv'
  },
  'es-419-tt': {
    description: 'Trinidad and Tobago - Latin American Spanish',
    domain: 'tt'
  },
  'es-419-us': {
    description: 'United States - Latin American Spanish',
    domain: 'com'
  },
  'es-419-uy': {
    description: 'Uruguay - Latin American Spanish',
    domain: 'com.uy'
  },
  'es-419-ve': {
    description: 'Venezuela - Latin American Spanish',
    domain: 'com.ve'
  },
  'ach-CD': {
    description: 'Democratic Republic of the Congo - Acoli',
    domain: 'cd'
  },
  'ach-CG': {
    description: 'Republic of the Congo - Acoli',
    domain: 'cg'
  },
  'id-TL': {
    description: 'Timor-Leste - Indonesian',
    domain: 'tl'
  }
};
const localeOptions = Object.keys(localeDetails);
const languageOptions = getLocaleOptions(localeOptions);
const geoCodeOptions = [{
  label: 'ES',
  value: 'ES'
}, {
  label: 'AE',
  value: 'AE'
}, {
  label: 'AF',
  value: 'AF'
}, {
  label: 'AL',
  value: 'AL'
}, {
  label: 'AM',
  value: 'AM'
}, {
  label: 'AO',
  value: 'AO'
}, {
  label: 'AR',
  value: 'AR'
}, {
  label: 'AT',
  value: 'AT'
}, {
  label: 'AU',
  value: 'AU'
}, {
  label: 'AX',
  value: 'AX'
}, {
  label: 'AZ',
  value: 'AZ'
}, {
  label: 'BA',
  value: 'BA'
}, {
  label: 'BD',
  value: 'BD'
}, {
  label: 'BE',
  value: 'BE'
}, {
  label: 'BF',
  value: 'BF'
}, {
  label: 'BG',
  value: 'BG'
}, {
  label: 'BI',
  value: 'BI'
}, {
  label: 'BJ',
  value: 'BJ'
}, {
  label: 'BN',
  value: 'BN'
}, {
  label: 'BO',
  value: 'BO'
}, {
  label: 'BR',
  value: 'BR'
}, {
  label: 'BS',
  value: 'BS'
}, {
  label: 'BT',
  value: 'BT'
}, {
  label: 'BW',
  value: 'BW'
}, {
  label: 'BY',
  value: 'BY'
}, {
  label: 'BZ',
  value: 'BZ'
}, {
  label: 'CA',
  value: 'CA'
}, {
  label: 'CD',
  value: 'CD'
}, {
  label: 'CF',
  value: 'CF'
}, {
  label: 'CG',
  value: 'CG'
}, {
  label: 'CH',
  value: 'CH'
}, {
  label: 'CI',
  value: 'CI'
}, {
  label: 'CL',
  value: 'CL'
}, {
  label: 'CM',
  value: 'CM'
}, {
  label: 'CN',
  value: 'CN'
}, {
  label: 'CO',
  value: 'CO'
}, {
  label: 'CR',
  value: 'CR'
}, {
  label: 'CU',
  value: 'CU'
}, {
  label: 'CY',
  value: 'CY'
}, {
  label: 'CZ',
  value: 'CZ'
}, {
  label: 'DE',
  value: 'DE'
}, {
  label: 'DJ',
  value: 'DJ'
}, {
  label: 'DK',
  value: 'DK'
}, {
  label: 'DO',
  value: 'DO'
}, {
  label: 'DZ',
  value: 'DZ'
}, {
  label: 'EC',
  value: 'EC'
}, {
  label: 'EE',
  value: 'EE'
}, {
  label: 'EG',
  value: 'EG'
}, {
  label: 'EH',
  value: 'EH'
}, {
  label: 'ER',
  value: 'ER'
}, {
  label: 'ES',
  value: 'ES'
}, {
  label: 'ET',
  value: 'ET'
}, {
  label: 'FI',
  value: 'FI'
}, {
  label: 'FJ',
  value: 'FJ'
}, {
  label: 'FK',
  value: 'FK'
}, {
  label: 'FO',
  value: 'FO'
}, {
  label: 'FR',
  value: 'FR'
}, {
  label: 'GA',
  value: 'GA'
}, {
  label: 'GB',
  value: 'GB'
}, {
  label: 'GE',
  value: 'GE'
}, {
  label: 'GF',
  value: 'GF'
}, {
  label: 'GH',
  value: 'GH'
}, {
  label: 'GL',
  value: 'GL'
}, {
  label: 'GM',
  value: 'GM'
}, {
  label: 'GN',
  value: 'GN'
}, {
  label: 'GQ',
  value: 'GQ'
}, {
  label: 'GR',
  value: 'GR'
}, {
  label: 'GT',
  value: 'GT'
}, {
  label: 'GW',
  value: 'GW'
}, {
  label: 'GY',
  value: 'GY'
}, {
  label: 'HN',
  value: 'HN'
}, {
  label: 'HR',
  value: 'HR'
}, {
  label: 'HT',
  value: 'HT'
}, {
  label: 'HU',
  value: 'HU'
}, {
  label: 'id',
  value: 'id'
}, {
  label: 'IE',
  value: 'IE'
}, {
  label: 'IL',
  value: 'IL'
}, {
  label: 'IM',
  value: 'IM'
}, {
  label: 'IN',
  value: 'IN'
}, {
  label: 'IQ',
  value: 'IQ'
}, {
  label: 'IR',
  value: 'IR'
}, {
  label: 'IS',
  value: 'IS'
}, {
  label: 'IT',
  value: 'IT'
}, {
  label: 'JM',
  value: 'JM'
}, {
  label: 'JO',
  value: 'JO'
}, {
  label: 'JP',
  value: 'JP'
}, {
  label: 'KE',
  value: 'KE'
}, {
  label: 'KG',
  value: 'KG'
}, {
  label: 'KH',
  value: 'KH'
}, {
  label: 'KP',
  value: 'KP'
}, {
  label: 'KR',
  value: 'KR'
}, {
  label: 'KW',
  value: 'KW'
}, {
  label: 'KZ',
  value: 'KZ'
}, {
  label: 'LA',
  value: 'LA'
}, {
  label: 'LB',
  value: 'LB'
}, {
  label: 'LK',
  value: 'LK'
}, {
  label: 'LR',
  value: 'LR'
}, {
  label: 'LT',
  value: 'LT'
}, {
  label: 'LU',
  value: 'LU'
}, {
  label: 'LV',
  value: 'LV'
}, {
  label: 'LY',
  value: 'LY'
}, {
  label: 'MA',
  value: 'MA'
}, {
  label: 'MD',
  value: 'MD'
}, {
  label: 'ME',
  value: 'ME'
}, {
  label: 'MG',
  value: 'MG'
}, {
  label: 'MK',
  value: 'MK'
}, {
  label: 'ML',
  value: 'ML'
}, {
  label: 'MM',
  value: 'MM'
}, {
  label: 'MN',
  value: 'MN'
}, {
  label: 'MQ',
  value: 'MQ'
}, {
  label: 'MR',
  value: 'MR'
}, {
  label: 'MU',
  value: 'MU'
}, {
  label: 'MW',
  value: 'MW'
}, {
  label: 'MX',
  value: 'MX'
}, {
  label: 'MY',
  value: 'MY'
}, {
  label: 'MZ',
  value: 'MZ'
}, {
  label: 'NA',
  value: 'NA'
}, {
  label: 'NC',
  value: 'NC'
}, {
  label: 'NE',
  value: 'NE'
}, {
  label: 'NG',
  value: 'NG'
}, {
  label: 'NI',
  value: 'NI'
}, {
  label: 'NL',
  value: 'NL'
}, {
  label: 'NO',
  value: 'NO'
}, {
  label: 'NP',
  value: 'NP'
}, {
  label: 'NZ',
  value: 'NZ'
}, {
  label: 'OM',
  value: 'OM'
}, {
  label: 'PA',
  value: 'PA'
}, {
  label: 'PE',
  value: 'PE'
}, {
  label: 'PG',
  value: 'PG'
}, {
  label: 'PH',
  value: 'PH'
}, {
  label: 'PK',
  value: 'PK'
}, {
  label: 'PL',
  value: 'PL'
}, {
  label: 'PR',
  value: 'PR'
}, {
  label: 'PT',
  value: 'PT'
}, {
  label: 'PY',
  value: 'PY'
}, {
  label: 'QA',
  value: 'QA'
}, {
  label: 'RE',
  value: 'RE'
}, {
  label: 'RO',
  value: 'RO'
}, {
  label: 'RS',
  value: 'RS'
}, {
  label: 'RU',
  value: 'RU'
}, {
  label: 'RW',
  value: 'RW'
}, {
  label: 'SA',
  value: 'SA'
}, {
  label: 'SB',
  value: 'SB'
}, {
  label: 'SD',
  value: 'SD'
}, {
  label: 'SE',
  value: 'SE'
}, {
  label: 'SI',
  value: 'SI'
}, {
  label: 'SJ',
  value: 'SJ'
}, {
  label: 'SK',
  value: 'SK'
}, {
  label: 'SL',
  value: 'SL'
}, {
  label: 'SN',
  value: 'SN'
}, {
  label: 'SO',
  value: 'SO'
}, {
  label: 'SR',
  value: 'SR'
}, {
  label: 'SS',
  value: 'SS'
}, {
  label: 'SV',
  value: 'SV'
}, {
  label: 'SY',
  value: 'SY'
}, {
  label: 'SZ',
  value: 'SZ'
}, {
  label: 'TD',
  value: 'TD'
}, {
  label: 'TG',
  value: 'TG'
}, {
  label: 'TH',
  value: 'TH'
}, {
  label: 'TJ',
  value: 'TJ'
}, {
  label: 'TL',
  value: 'TL'
}, {
  label: 'TM',
  value: 'TM'
}, {
  label: 'TN',
  value: 'TN'
}, {
  label: 'TR',
  value: 'TR'
}, {
  label: 'TT',
  value: 'TT'
}, {
  label: 'TW',
  value: 'TW'
}, {
  label: 'TZ',
  value: 'TZ'
}, {
  label: 'UA',
  value: 'UA'
}, {
  label: 'UG',
  value: 'UG'
}, {
  label: 'US',
  value: 'US'
}, {
  label: 'UY',
  value: 'UY'
}, {
  label: 'UZ',
  value: 'UZ'
}, {
  label: 'VE',
  value: 'VE'
}, {
  label: 'VN',
  value: 'VN'
}, {
  label: 'VU',
  value: 'VU'
}, {
  label: 'WS',
  value: 'WS'
}, {
  label: 'XK',
  value: 'XK'
}, {
  label: 'YE',
  value: 'YE'
}, {
  label: 'ZA',
  value: 'ZA'
}, {
  label: 'ZM',
  value: 'ZM'
}, {
  label: 'ZW',
  value: 'ZW'
}, {
  label: 'LS',
  value: 'LS'
}];
const deviceOptions = [{
  value: NO_SELECTION,
  label: 'No selection'
}, {
  value: 'desktop',
  label: 'Desktop'
}, {
  value: 'desktop_chrome',
  label: 'Desktop Chrome'
}, {
  value: 'desktop_edge',
  label: 'Desktop Edge'
}, {
  value: 'desktop_firefox',
  label: 'Desktop Firefox'
}, {
  value: 'desktop_opera',
  label: 'Desktop Opera'
}, {
  value: 'desktop_safari',
  label: 'Desktop Safari'
}, {
  value: 'mobile',
  label: 'Mobile'
}, {
  value: 'mobile_android',
  label: 'Mobile Android'
}, {
  value: 'mobile_ios',
  label: 'Mobile iOS'
}, {
  value: 'tablet',
  label: 'Tablet'
}, {
  value: 'tablet_android',
  label: 'Tablet Android'
}, {
  value: 'tablet_ios',
  label: 'Tablet iOS'
}];
const tbmOptions = [{
  value: NO_SELECTION,
  label: 'No selection'
}, {
  value: 'vid',
  label: 'Google Videos - vid'
}, {
  value: 'isch',
  label: 'Google Images - isch'
}, {
  value: 'lcl',
  label: 'Google Local - lcl'
}, {
  value: 'nws',
  label: 'Google News - nws'
}, {
  value: 'shop',
  label: 'Google Shopping - shop'
}];
const domainOptions = [{
  value: 'com.af',
  label: '.com.af'
}, {
  value: 'al',
  label: '.al'
}, {
  value: 'dz',
  label: '.dz'
}, {
  value: 'as',
  label: '.as'
}, {
  value: 'ad',
  label: '.ad'
}, {
  value: 'it.ao',
  label: '.it.ao'
}, {
  value: 'com.ai',
  label: '.com.ai'
}, {
  value: 'com.ag',
  label: '.com.ag'
}, {
  value: 'com.ar',
  label: '.com.ar'
}, {
  value: 'am',
  label: '.am'
}, {
  value: 'ac',
  label: '.ac'
}, {
  value: 'com.au',
  label: '.com.au'
}, {
  value: 'at',
  label: '.at'
}, {
  value: 'az',
  label: '.az'
}, {
  value: 'bs',
  label: '.bs'
}, {
  value: 'com.be',
  label: '.com.be'
}, {
  value: 'com.bh',
  label: '.com.bh'
}, {
  value: 'com.bd',
  label: '.com.bd'
}, {
  value: 'com.by',
  label: '.com.by'
}, {
  value: 'be',
  label: '.be'
}, {
  value: 'com.bz',
  label: '.com.bz'
}, {
  value: 'bj',
  label: '.bj'
}, {
  value: 'bt',
  label: '.bt'
}, {
  value: 'com.bo',
  label: '.com.bo'
}, {
  value: 'ba',
  label: '.ba'
}, {
  value: 'co.bw',
  label: '.co.bw'
}, {
  value: 'com.br',
  label: '.com.br'
}, {
  value: 'vg',
  label: '.vg'
}, {
  value: 'com.bn',
  label: '.com.bn'
}, {
  value: 'bg',
  label: '.bg'
}, {
  value: 'bf',
  label: '.bf'
}, {
  value: 'bi',
  label: '.bi'
}, {
  value: 'com.kh',
  label: '.com.kh'
}, {
  value: 'cm',
  label: '.cm'
}, {
  value: 'ca',
  label: '.ca'
}, {
  value: 'cv',
  label: '.cv'
}, {
  value: 'cat',
  label: '.cat'
}, {
  value: 'cf',
  label: '.cf'
}, {
  value: 'td',
  label: '.td'
}, {
  value: 'cl',
  label: '.cl'
}, {
  value: 'cn',
  label: '.cn'
}, {
  value: 'com.co',
  label: '.com.co'
}, {
  value: 'cd',
  label: '.cd'
}, {
  value: 'cg',
  label: '.cg'
}, {
  value: 'co.ck',
  label: '.co.ck'
}, {
  value: 'co.cr',
  label: '.co.cr'
}, {
  value: 'ci',
  label: '.ci'
}, {
  value: 'hr',
  label: '.hr'
}, {
  value: 'com.cu',
  label: '.com.cu'
}, {
  value: 'com.cy',
  label: '.com.cy'
}, {
  value: 'cz',
  label: '.cz'
}, {
  value: 'dk',
  label: '.dk'
}, {
  value: 'dj',
  label: '.dj'
}, {
  value: 'dm',
  label: '.dm'
}, {
  value: 'com.do',
  label: '.com.do'
}, {
  value: 'com.ec',
  label: '.com.ec'
}, {
  value: 'com.eg',
  label: '.com.eg'
}, {
  value: 'com.sv',
  label: '.com.sv'
}, {
  value: 'ee',
  label: '.ee'
}, {
  value: 'com.et',
  label: '.com.et'
}, {
  value: 'com.fj',
  label: '.com.fj'
}, {
  value: 'fi',
  label: '.fi'
}, {
  value: 'fr',
  label: '.fr'
}, {
  value: 'ga',
  label: '.ga'
}, {
  value: 'gm',
  label: '.gm'
}, {
  value: 'ge',
  label: '.ge'
}, {
  value: 'de',
  label: '.de'
}, {
  value: 'com.gh',
  label: '.com.gh'
}, {
  value: 'com.gi',
  label: '.com.gi'
}, {
  value: 'gr',
  label: '.gr'
}, {
  value: 'gl',
  label: '.gl'
}, {
  value: 'gp',
  label: '.gp'
}, {
  value: 'com.gt',
  label: '.com.gt'
}, {
  value: 'gg',
  label: '.gg'
}, {
  value: 'gy',
  label: '.gy'
}, {
  value: 'ht',
  label: '.ht'
}, {
  value: 'hn',
  label: '.hn'
}, {
  value: 'com.hk',
  label: '.com.hk'
}, {
  value: 'hu',
  label: '.hu'
}, {
  value: 'is',
  label: '.is'
}, {
  value: 'co.in',
  label: '.co.in'
}, {
  value: 'co.id',
  label: '.co.id'
}, {
  value: 'iq',
  label: '.iq'
}, {
  value: 'ie',
  label: '.ie'
}, {
  value: 'co.im',
  label: '.co.im'
}, {
  value: 'co.il',
  label: '.co.il'
}, {
  value: 'it',
  label: '.it'
}, {
  value: 'in',
  label: '.in'
}, {
  value: 'com.jm',
  label: '.com.jm'
}, {
  value: 'co.jp',
  label: '.co.jp'
}, {
  value: 'co.je',
  label: '.co.je'
}, {
  value: 'jo',
  label: '.jo'
}, {
  value: 'kz',
  label: '.kz'
}, {
  value: 'co.ke',
  label: '.co.ke'
}, {
  value: 'ki',
  label: '.ki'
}, {
  value: 'com.kw',
  label: '.com.kw'
}, {
  value: 'com.kg',
  label: '.com.kg'
}, {
  value: 'la',
  label: '.la'
}, {
  value: 'lv',
  label: '.lv'
}, {
  value: 'com.lb',
  label: '.com.lb'
}, {
  value: 'co.ls',
  label: '.co.ls'
}, {
  value: 'com.ly',
  label: '.com.ly'
}, {
  value: 'li',
  label: '.li'
}, {
  value: 'lt',
  label: '.lt'
}, {
  value: 'lu',
  label: '.lu'
}, {
  value: 'mk',
  label: '.mk'
}, {
  value: 'mg',
  label: '.mg'
}, {
  value: 'mw',
  label: '.mw'
}, {
  value: 'com.my',
  label: '.com.my'
}, {
  value: 'mv',
  label: '.mv'
}, {
  value: 'ml',
  label: '.ml'
}, {
  value: 'com.mt',
  label: '.com.mt'
}, {
  value: 'mu',
  label: '.mu'
}, {
  value: 'com.mx',
  label: '.com.mx'
}, {
  value: 'fm',
  label: '.fm'
}, {
  value: 'md',
  label: '.md'
}, {
  value: 'mn',
  label: '.mn'
}, {
  value: 'me',
  label: '.me'
}, {
  value: 'ms',
  label: '.ms'
}, {
  value: 'co.ma',
  label: '.co.ma'
}, {
  value: 'co.mz',
  label: '.co.mz'
}, {
  value: 'com.na',
  label: '.com.na'
}, {
  value: 'nr',
  label: '.nr'
}, {
  value: 'com.np',
  label: '.com.np'
}, {
  value: 'nl',
  label: '.nl'
}, {
  value: 'co.nz',
  label: '.co.nz'
}, {
  value: 'com.ni',
  label: '.com.ni'
}, {
  value: 'ne',
  label: '.ne'
}, {
  value: 'com.ng',
  label: '.com.ng'
}, {
  value: 'nu',
  label: '.nu'
}, {
  value: 'com.nf',
  label: '.com.nf'
}, {
  value: 'no',
  label: '.no'
}, {
  value: 'com.om',
  label: '.com.om'
}, {
  value: 'com.pk',
  label: '.com.pk'
}, {
  value: 'ps',
  label: '.ps'
}, {
  value: 'com.pa',
  label: '.com.pa'
}, {
  value: 'com.pg',
  label: '.com.pg'
}, {
  value: 'com.py',
  label: '.com.py'
}, {
  value: 'com.pe',
  label: '.com.pe'
}, {
  value: 'com.ph',
  label: '.com.ph'
}, {
  value: 'pn',
  label: '.pn'
}, {
  value: 'pl',
  label: '.pl'
}, {
  value: 'pt',
  label: '.pt'
}, {
  value: 'com.pr',
  label: '.com.pr'
}, {
  value: 'com.qa',
  label: '.com.qa'
}, {
  value: 'ro',
  label: '.ro'
}, {
  value: 'ru',
  label: '.ru'
}, {
  value: 'rw',
  label: '.rw'
}, {
  value: 'sh',
  label: '.sh'
}, {
  value: 'ws',
  label: '.ws'
}, {
  value: 'sm',
  label: '.sm'
}, {
  value: 'st',
  label: '.st'
}, {
  value: 'com.sa',
  label: '.com.sa'
}, {
  value: 'sn',
  label: '.sn'
}, {
  value: 'rs',
  label: '.rs'
}, {
  value: 'sc',
  label: '.sc'
}, {
  value: 'com.sl',
  label: '.com.sl'
}, {
  value: 'com.sg',
  label: '.com.sg'
}, {
  value: 'sg',
  label: '.sg'
}, {
  value: 'sk',
  label: '.sk'
}, {
  value: 'si',
  label: '.si'
}, {
  value: 'com.sb',
  label: '.com.sb'
}, {
  value: 'so',
  label: '.so'
}, {
  value: 'co.za',
  label: '.co.za'
}, {
  value: 'co.kr',
  label: '.co.kr'
}, {
  value: 'es',
  label: '.es'
}, {
  value: 'lk',
  label: '.lk'
}, {
  value: 'com.vc',
  label: '.com.vc'
}, {
  value: 'sr',
  label: '.sr'
}, {
  value: 'se',
  label: '.se'
}, {
  value: 'ch',
  label: '.ch'
}, {
  value: 'com.tw',
  label: '.com.tw'
}, {
  value: 'com.tj',
  label: '.com.tj'
}, {
  value: 'co.tz',
  label: '.co.tz'
}, {
  value: 'co.th',
  label: '.co.th'
}, {
  value: 'tl',
  label: '.tl'
}, {
  value: 'tg',
  label: '.tg'
}, {
  value: 'tk',
  label: '.tk'
}, {
  value: 'to',
  label: '.to'
}, {
  value: 'tt',
  label: '.tt'
}, {
  value: 'tn',
  label: '.tn'
}, {
  value: 'com.tr',
  label: '.com.tr'
}, {
  value: 'tm',
  label: '.tm'
}, {
  value: 'co.ug',
  label: '.co.ug'
}, {
  value: 'com.ua',
  label: '.com.ua'
}, {
  value: 'ae',
  label: '.ae'
}, {
  value: 'co.uk',
  label: '.co.uk'
}, {
  value: 'com',
  label: '.com'
}, {
  value: 'com.uy',
  label: '.com.uy'
}, {
  value: 'co.uz',
  label: '.co.uz'
}, {
  value: 'vu',
  label: '.vu'
}, {
  value: 'co.ve',
  label: '.co.ve'
}, {
  value: 'com.vn',
  label: '.com.vn'
}, {
  value: 'co.vi',
  label: '.co.vi'
}, {
  value: 'co.zm',
  label: '.co.zm'
}, {
  value: 'co.zw',
  label: '.co.zw'
}];
const playgroundDomainOptions = [{
  value: '',
  label: 'No selection'
}, ...domainOptions.sort((a, b) => a.label.localeCompare(b.label))];
const ratingOptions = [{
  label: '5',
  value: '5'
}, {
  label: '4 or higher',
  value: '4'
}, {
  label: '3 or higher',
  value: '3'
}, {
  label: '2 or higher',
  value: '2'
}, {
  label: '1 or higher',
  value: '1'
}, {
  label: 'All reviews',
  value: '0'
}];
const parserTypeOptions = [{
  value: NO_SELECTION,
  label: 'No selection'
}, {
  label: 'eCommerce product',
  value: 'ecommerce_product'
}];
const searchTypeOptions = [{
  label: 'No selection',
  value: NO_SELECTION
}, {
  label: 'Web search',
  value: 'web_search'
}, {
  label: 'Image search',
  value: 'image_search'
}, {
  label: 'Youtube search',
  value: 'video_search'
}, {
  label: 'Google shopping',
  value: 'google_shopping'
}];
const categoryOptions = [{
  label: 'No selection',
  value: NO_SELECTION
}, {
  label: 'All categories',
  value: '0'
}, {
  label: 'Arts & Entertainment',
  value: '3'
}, {
  label: 'Celebrities & Entertainment News',
  value: '184'
}, {
  label: 'Comics & Animation',
  value: '316'
}, {
  label: 'Animated Films',
  value: '1104'
}, {
  label: 'Anime & Manga',
  value: '317'
}, {
  label: 'Cartoons',
  value: '319'
}, {
  label: 'Comics',
  value: '318'
}, {
  label: 'Entertainment Industry',
  value: '612'
}, {
  label: 'Film & TV Industry',
  value: '1116'
}, {
  label: 'Film & TV Awards',
  value: '1108'
}, {
  label: 'Film & TV Production',
  value: '1117'
}, {
  label: 'Recording Industry',
  value: '1115'
}, {
  label: 'Music Awards',
  value: '1113'
}, {
  label: 'Record Labels',
  value: '1114'
}, {
  label: 'Events & Listings',
  value: '569'
}, {
  label: 'Clubs & Nightlife',
  value: '188'
}, {
  label: 'Concerts & Music Festivals',
  value: '891'
}, {
  label: 'Film Festivals',
  value: '1086'
}, {
  label: 'Live Sporting Events',
  value: '1273'
}, {
  label: 'Movie Listings & Theater Showtimes',
  value: '1085'
}, {
  label: 'Ticket Sales',
  value: '614'
}, {
  label: 'Fun & Trivia',
  value: '539'
}, {
  label: 'Dress-Up & Fashion Games',
  value: '1173'
}, {
  label: 'Flash-Based Entertainment',
  value: '447'
}, {
  label: 'Fun Tests & Silly Surveys',
  value: '1174'
}, {
  label: 'Humor',
  value: '182'
}, {
  label: 'Comedy Films',
  value: '1095'
}, {
  label: 'Live Comedy',
  value: '895'
}, {
  label: 'Political Humor',
  value: '1180'
}, {
  label: 'Spoofs & Satire',
  value: '1244'
}, {
  label: 'TV Comedies',
  value: '1047'
}, {
  label: 'Movies',
  value: '34'
}, {
  label: 'Action & Adventure Films',
  value: '1097'
}, {
  label: 'Martial Arts Films',
  value: '1101'
}, {
  label: 'Superhero Films',
  value: '1100'
}, {
  label: 'Western Films',
  value: '1099'
}, {
  label: 'Bollywood & South Asian Film',
  value: '360'
}, {
  label: 'Classic Films',
  value: '1102'
}, {
  label: 'Silent Films',
  value: '1098'
}, {
  label: 'Cult & Indie Films',
  value: '1103'
}, {
  label: 'Documentary Films',
  value: '1072'
}, {
  label: 'Drama Films',
  value: '1094'
}, {
  label: 'DVD & Video Shopping',
  value: '210'
}, {
  label: 'DVD & Video Rentals',
  value: '1145'
}, {
  label: 'Family Films',
  value: '1291'
}, {
  label: 'Horror Films',
  value: '615'
}, {
  label: 'Movie Memorabilia',
  value: '213'
}, {
  label: 'Movie Reference',
  value: '1106'
}, {
  label: 'Movie Reviews & Previews',
  value: '1107'
}, {
  label: 'Musical Films',
  value: '1105'
}, {
  label: 'Romance Films',
  value: '1310'
}, {
  label: 'Science Fiction & Fantasy Films',
  value: '616'
}, {
  label: 'Thriller, Crime & Mystery Films',
  value: '1096'
}, {
  label: 'Music & Audio',
  value: '35'
}, {
  label: 'CD & Audio Shopping',
  value: '217'
}, {
  label: 'Classical Music',
  value: '586'
}, {
  label: 'Opera',
  value: '1185'
}, {
  label: 'Country Music',
  value: '587'
}, {
  label: 'Dance & Electronic Music',
  value: '588'
}, {
  label: 'Experimental & Industrial Music',
  value: '1022'
}, {
  label: 'Folk & Traditional Music',
  value: '1023'
}, {
  label: 'Jazz & Blues',
  value: '589'
}, {
  label: 'Blues',
  value: '1040'
}, {
  label: 'Jazz',
  value: '42'
}, {
  label: 'Latin Pop',
  value: '1285'
}, {
  label: 'Music Art & Memorabilia',
  value: '218'
}, {
  label: 'Music Education & Instruction',
  value: '1087'
}, {
  label: 'Music Equipment & Technology',
  value: '1024'
}, {
  label: 'DJ Resources & Equipment',
  value: '1025'
}, {
  label: 'Music Recording Technology',
  value: '1026'
}, {
  label: 'Musical Instruments',
  value: '216'
}, {
  label: 'Drums & Percussion',
  value: '1327'
}, {
  label: 'Guitars',
  value: '1325'
}, {
  label: 'Pianos & Keyboards',
  value: '1326'
}, {
  label: 'Samples & Sound Libraries',
  value: '1091'
}, {
  label: 'Music Reference',
  value: '1027'
}, {
  label: 'Music Composition & Theory',
  value: '1028'
}, {
  label: 'Sheet Music',
  value: '892'
}, {
  label: 'Song Lyrics & Tabs',
  value: '617'
}, {
  label: 'Music Streams & Downloads',
  value: '220'
}, {
  label: 'Pop Music',
  value: '1021'
}, {
  label: 'Radio',
  value: '215'
}, {
  label: 'Podcasting',
  value: '809'
}, {
  label: 'Talk Radio',
  value: '1186'
}, {
  label: 'Religious Music',
  value: '1020'
}, {
  label: 'Christian & Gospel Music',
  value: '585'
}, {
  label: 'Rock Music',
  value: '590'
}, {
  label: 'Classic Rock & Oldies',
  value: '1037'
}, {
  label: 'Hard Rock & Progressive',
  value: '1035'
}, {
  label: 'Indie & Alternative Music',
  value: '1038'
}, {
  label: 'Metal (Music)',
  value: '1036'
}, {
  label: 'Punk (Music)',
  value: '1041'
}, {
  label: 'Soundtracks',
  value: '893'
}, {
  label: 'Urban & Hip-Hop',
  value: '592'
}, {
  label: 'Rap & Hip-Hop',
  value: '1030'
}, {
  label: 'Reggaeton',
  value: '1242'
}, {
  label: 'Soul & R&B',
  value: '1039'
}, {
  label: 'Vocals & Show Tunes',
  value: '618'
}, {
  label: 'World Music',
  value: '593'
}, {
  label: 'African Music',
  value: '1208'
}, {
  label: 'Arab & Middle Eastern Music',
  value: '1034'
}, {
  label: 'East Asian Music',
  value: '1033'
}, {
  label: 'Latin American Music',
  value: '591'
}, {
  label: 'Brazilian Music',
  value: '1287'
}, {
  label: 'Salsa & Tropical Music',
  value: '1286'
}, {
  label: 'Reggae & Caribbean Music',
  value: '1031'
}, {
  label: 'South Asian Music',
  value: '1032'
}, {
  label: 'Offbeat',
  value: '33'
}, {
  label: 'Edgy & Bizarre',
  value: '538'
}, {
  label: 'Occult & Paranormal',
  value: '449'
}, {
  label: 'Online Media',
  value: '613'
}, {
  label: 'Online Games',
  value: '105'
}, {
  label: 'Massive Multiplayer',
  value: '935'
}, {
  label: 'Online Image Galleries',
  value: '1222'
}, {
  label: 'Photo & Image Sharing',
  value: '978'
}, {
  label: 'Photo Rating Sites',
  value: '320'
}, {
  label: 'Stock Photography',
  value: '574'
}, {
  label: 'Online Video',
  value: '211'
}, {
  label: 'Video Sharing',
  value: '979'
}, {
  label: 'Web Portals',
  value: '301'
}, {
  label: 'Webcams & Virtual Tours',
  value: '575'
}, {
  label: 'Performing Arts',
  value: '23'
}, {
  label: 'Acting & Theater',
  value: '894'
}, {
  label: 'Broadway & Musical Theater',
  value: '1243'
}, {
  label: 'Dance',
  value: '581'
}, {
  label: 'TV & Video',
  value: '36'
}, {
  label: 'TV Commercials',
  value: '1055'
}, {
  label: 'TV Guides & Reference',
  value: '1187'
}, {
  label: 'TV Networks & Stations',
  value: '359'
}, {
  label: 'TV Shows & Programs',
  value: '358'
}, {
  label: 'TV Dramas',
  value: '1193'
}, {
  label: 'TV Crime & Legal Shows',
  value: '1111'
}, {
  label: 'TV Medical Shows',
  value: '1194'
}, {
  label: 'TV Soap Operas',
  value: '357'
}, {
  label: 'TV Family-Oriented Shows',
  value: '1110'
}, {
  label: 'TV Game Shows',
  value: '1050'
}, {
  label: 'TV Reality Shows',
  value: '1049'
}, {
  label: 'TV Sci-Fi & Fantasy Shows',
  value: '1112'
}, {
  label: 'TV Talk Shows',
  value: '1048'
}, {
  label: 'Visual Art & Design',
  value: '24'
}, {
  label: 'Architecture',
  value: '477'
}, {
  label: 'Art & Craft Supplies',
  value: '1361'
}, {
  label: 'Arts Education',
  value: '1195'
}, {
  label: 'Design',
  value: '653'
}, {
  label: 'CAD & CAM',
  value: '1300'
}, {
  label: 'Graphic Design',
  value: '654'
}, {
  label: 'Industrial & Product Design',
  value: '655'
}, {
  label: 'Interior Design',
  value: '656'
}, {
  label: 'Painting',
  value: '1167'
}, {
  label: 'Photographic & Digital Arts',
  value: '439'
}, {
  label: 'Camera & Photo Equipment',
  value: '573'
}, {
  label: 'Binoculars, Telescopes & Optical Devices',
  value: '1384'
}, {
  label: 'Cameras & Camcorders',
  value: '306'
}, {
  label: 'Camcorders',
  value: '308'
}, {
  label: 'Camera Lenses',
  value: '1383'
}, {
  label: 'Cameras',
  value: '307'
}, {
  label: 'Photo & Video Software',
  value: '577'
}, {
  label: 'Video File Formats & Codecs',
  value: '1315'
}, {
  label: 'Autos & Vehicles',
  value: '47'
}, {
  label: 'Automotive Industry',
  value: '1190'
}, {
  label: 'Bicycles & Accessories',
  value: '1191'
}, {
  label: 'Boats & Watercraft',
  value: '1140'
}, {
  label: 'Campers & RVs',
  value: '1213'
}, {
  label: 'Classic Vehicles',
  value: '1013'
}, {
  label: 'Commercial Vehicles',
  value: '1214'
}, {
  label: 'Cargo Trucks & Trailers',
  value: '1215'
}, {
  label: 'Custom & Performance Vehicles',
  value: '806'
}, {
  label: 'Hybrid & Alternative Vehicles',
  value: '810'
}, {
  label: 'Electric & Plug-In Vehicles',
  value: '1380'
}, {
  label: 'Microcars & City Cars',
  value: '1317'
}, {
  label: 'Motorcycles',
  value: '273'
}, {
  label: 'Off-Road Vehicles',
  value: '148'
}, {
  label: 'Personal Aircraft',
  value: '1147'
}, {
  label: 'Scooters & Mopeds',
  value: '1212'
}, {
  label: 'Trucks & SUVs',
  value: '610'
}, {
  label: 'SUVs',
  value: '1057'
}, {
  label: 'Trucks',
  value: '1056'
}, {
  label: 'Vans & Minivans',
  value: '1058'
}, {
  label: 'Vehicle Brands',
  value: '815'
}, {
  label: 'Acura',
  value: '820'
}, {
  label: 'Audi',
  value: '821'
}, {
  label: 'Bentley',
  value: '1059'
}, {
  label: 'BMW',
  value: '822'
}, {
  label: 'Buick',
  value: '1060'
}, {
  label: 'Cadillac',
  value: '823'
}, {
  label: 'Chevrolet',
  value: '826'
}, {
  label: 'Chrysler',
  value: '833'
}, {
  label: 'Citro\u00ebn',
  value: '834'
}, {
  label: 'Dodge',
  value: '836'
}, {
  label: 'Ferrari',
  value: '1061'
}, {
  label: 'Fiat',
  value: '838'
}, {
  label: 'Ford',
  value: '840'
}, {
  label: 'GM-Daewoo',
  value: '896'
}, {
  label: 'GMC',
  value: '842'
}, {
  label: 'Honda',
  value: '843'
}, {
  label: 'Hummer',
  value: '1062'
}, {
  label: 'Hyundai',
  value: '845'
}, {
  label: 'Isuzu',
  value: '1378'
}, {
  label: 'Jaguar',
  value: '1063'
}, {
  label: 'Jeep',
  value: '846'
}, {
  label: 'Kia',
  value: '848'
}, {
  label: 'Lamborghini',
  value: '1064'
}, {
  label: 'Land Rover',
  value: '1065'
}, {
  label: 'Lexus',
  value: '849'
}, {
  label: 'Lincoln',
  value: '850'
}, {
  label: 'Maserati',
  value: '1066'
}, {
  label: 'Mazda',
  value: '851'
}, {
  label: 'Mercedes-Benz',
  value: '852'
}, {
  label: 'Mercury',
  value: '853'
}, {
  label: 'Mini',
  value: '1067'
}, {
  label: 'Mitsubishi',
  value: '854'
}, {
  label: 'Nissan',
  value: '855'
}, {
  label: 'Infiniti',
  value: '1377'
}, {
  label: 'Peugeot',
  value: '856'
}, {
  label: 'Pontiac',
  value: '857'
}, {
  label: 'Porsche',
  value: '858'
}, {
  label: 'Renault-Samsung',
  value: '859'
}, {
  label: 'Rolls-Royce',
  value: '1068'
}, {
  label: 'Saab',
  value: '897'
}, {
  label: 'Saturn',
  value: '860'
}, {
  label: 'Subaru',
  value: '861'
}, {
  label: 'Suzuki',
  value: '1070'
}, {
  label: 'Toyota',
  value: '863'
}, {
  label: 'Scion',
  value: '1069'
}, {
  label: 'Vauxhall-Opel',
  value: '898'
}, {
  label: 'Volkswagen',
  value: '865'
}, {
  label: 'Volvo',
  value: '867'
}, {
  label: 'Vehicle Codes & Driving Laws',
  value: '1294'
}, {
  label: 'Drunk Driving Law',
  value: '968'
}, {
  label: 'Vehicle Licensing & Registration',
  value: '170'
}, {
  label: 'Vehicle Maintenance',
  value: '138'
}, {
  label: 'Vehicle Parts & Accessories',
  value: '89'
}, {
  label: 'Auto Exterior',
  value: '1217'
}, {
  label: 'Auto Interior',
  value: '1218'
}, {
  label: 'Car Electronics',
  value: '1188'
}, {
  label: 'Car Audio',
  value: '230'
}, {
  label: 'Car Video',
  value: '1189'
}, {
  label: 'GPS & Navigation',
  value: '794'
}, {
  label: 'Engine & Transmission',
  value: '1216'
}, {
  label: 'Vehicle Fuels & Lubricants',
  value: '1269'
}, {
  label: 'Vehicle Wheels & Tires',
  value: '438'
}, {
  label: 'Vehicle Shopping',
  value: '473'
}, {
  label: 'Fuel Economy & Gas Prices',
  value: '1268'
}, {
  label: 'Vehicle Specs, Reviews & Comparisons',
  value: '1267'
}, {
  label: 'Vehicle Shows',
  value: '803'
}, {
  label: 'Beauty & Fitness',
  value: '44'
}, {
  label: 'Beauty Pageants',
  value: '1219'
}, {
  label: 'Body Art',
  value: '239'
}, {
  label: 'Cosmetic Procedures',
  value: '1220'
}, {
  label: 'Cosmetic Surgery',
  value: '238'
}, {
  label: 'Cosmetology & Beauty Professionals',
  value: '147'
}, {
  label: 'Face & Body Care',
  value: '143'
}, {
  label: 'Hygiene & Toiletries',
  value: '244'
}, {
  label: 'Make-Up & Cosmetics',
  value: '234'
}, {
  label: 'Perfumes & Fragrances',
  value: '242'
}, {
  label: 'Skin & Nail Care',
  value: '93'
}, {
  label: 'Unwanted Body & Facial Hair Removal',
  value: '144'
}, {
  label: 'Fashion & Style',
  value: '185'
}, {
  label: 'Fashion Designers & Collections',
  value: '98'
}, {
  label: 'Fashion Modeling',
  value: '1155'
}, {
  label: 'Fitness',
  value: '94'
}, {
  label: 'Bodybuilding',
  value: '241'
}, {
  label: 'Yoga & Pilates',
  value: '611'
}, {
  label: 'Hair Care',
  value: '146'
}, {
  label: 'Hair Loss',
  value: '235'
}, {
  label: 'Spas & Beauty Services',
  value: '145'
}, {
  label: 'Massage Therapy',
  value: '557'
}, {
  label: 'Weight Loss',
  value: '236'
}, {
  label: 'Books & Literature',
  value: '22'
}, {
  label: 'Biographies & Quotations',
  value: '690'
}, {
  label: 'Book Retailers',
  value: '355'
}, {
  label: "Children's Literature",
  value: '1183'
}, {
  label: 'E-Books',
  value: '608'
}, {
  label: 'Fan Fiction',
  value: '540'
}, {
  label: 'Literary Classics',
  value: '1184'
}, {
  label: 'Magazines',
  value: '412'
}, {
  label: 'Poetry',
  value: '565'
}, {
  label: 'Writers Resources',
  value: '1177'
}, {
  label: 'Business & Industrial',
  value: '12'
}, {
  label: 'Advertising & Marketing',
  value: '25'
}, {
  label: 'Marketing Services',
  value: '83'
}, {
  label: 'Loyalty Cards & Programs',
  value: '1309'
}, {
  label: 'Public Relations',
  value: '327'
}, {
  label: 'Search Engine Optimization & Marketing',
  value: '84'
}, {
  label: 'Telemarketing',
  value: '328'
}, {
  label: 'Aerospace & Defense',
  value: '356'
}, {
  label: 'Defense Industry',
  value: '669'
}, {
  label: 'Space Technology',
  value: '668'
}, {
  label: 'Agriculture & Forestry',
  value: '46'
}, {
  label: 'Agricultural Equipment',
  value: '748'
}, {
  label: 'Aquaculture',
  value: '747'
}, {
  label: 'Crops & Seed',
  value: '749'
}, {
  label: 'Food Production',
  value: '621'
}, {
  label: 'Forestry',
  value: '750'
}, {
  label: 'Horticulture',
  value: '751'
}, {
  label: 'Livestock',
  value: '752'
}, {
  label: 'Business Education',
  value: '799'
}, {
  label: 'Business Finance',
  value: '1138'
}, {
  label: 'Commercial Lending',
  value: '1160'
}, {
  label: 'Investment Banking',
  value: '1139'
}, {
  label: 'Risk Management',
  value: '620'
}, {
  label: 'Venture Capital',
  value: '905'
}, {
  label: 'Business News',
  value: '784'
}, {
  label: 'Company News',
  value: '1179'
}, {
  label: 'Company Earnings',
  value: '1240'
}, {
  label: 'Mergers & Acquisitions',
  value: '1241'
}, {
  label: 'Economy News',
  value: '1164'
}, {
  label: 'Financial Markets',
  value: '1163'
}, {
  label: 'Fiscal Policy News',
  value: '1165'
}, {
  label: 'Business Operations',
  value: '1159'
}, {
  label: 'Business Plans & Presentations',
  value: '336'
}, {
  label: 'Human Resources',
  value: '157'
}, {
  label: 'Compensation & Benefits',
  value: '723'
}, {
  label: 'Corporate Training',
  value: '331'
}, {
  label: 'Payroll Services',
  value: '724'
}, {
  label: 'Recruitment & Staffing',
  value: '330'
}, {
  label: 'Management',
  value: '338'
}, {
  label: 'Business Process',
  value: '721'
}, {
  label: 'Project Management',
  value: '1360'
}, {
  label: 'Project Management Software',
  value: '1359'
}, {
  label: 'Strategic Planning',
  value: '722'
}, {
  label: 'Supply Chain Management',
  value: '801'
}, {
  label: 'Business Services',
  value: '329'
}, {
  label: 'Consulting',
  value: '1162'
}, {
  label: 'Corporate Events',
  value: '334'
}, {
  label: 'Trade Shows & Conventions',
  value: '335'
}, {
  label: 'E-Commerce Services',
  value: '340'
}, {
  label: 'Merchant Services & Payment Systems',
  value: '280'
}, {
  label: 'Fire & Security Services',
  value: '726'
}, {
  label: 'Knowledge Management',
  value: '800'
}, {
  label: 'Office Services',
  value: '28'
}, {
  label: 'Office & Facilities Management',
  value: '337'
}, {
  label: 'Office Supplies',
  value: '95'
}, {
  label: 'Business Cards & Stationary',
  value: '1375'
}, {
  label: 'Office Furniture',
  value: '333'
}, {
  label: 'Printers, Copiers & Fax',
  value: '1330'
}, {
  label: 'Copiers',
  value: '1331'
}, {
  label: 'Fax Machines',
  value: '1332'
}, {
  label: 'Ink & Toner',
  value: '1333'
}, {
  label: 'Printers',
  value: '494'
}, {
  label: 'Scanners',
  value: '495'
}, {
  label: 'Outsourcing',
  value: '718'
}, {
  label: 'Photo & Video Services',
  value: '576'
}, {
  label: 'Physical Asset Management',
  value: '719'
}, {
  label: 'Quality Control & Tracking',
  value: '720'
}, {
  label: 'Signage',
  value: '1076'
}, {
  label: 'Writing & Editing Services',
  value: '725'
}, {
  label: 'Chemicals Industry',
  value: '288'
}, {
  label: 'Agrochemicals',
  value: '670'
}, {
  label: 'Cleaning Agents',
  value: '671'
}, {
  label: 'Coatings & Adhesives',
  value: '672'
}, {
  label: 'Dyes & Pigments',
  value: '673'
}, {
  label: 'Plastics & Polymers',
  value: '674'
}, {
  label: 'Construction & Maintenance',
  value: '48'
}, {
  label: 'Building Materials & Supplies',
  value: '650'
}, {
  label: 'Doors & Windows',
  value: '827'
}, {
  label: 'HVAC & Climate Control',
  value: '828'
}, {
  label: 'Nails Screws & Fasteners',
  value: '829'
}, {
  label: 'Plumbing Fixtures & Equipment',
  value: '830'
}, {
  label: 'Wood & Plastics',
  value: '831'
}, {
  label: 'Civil Engineering',
  value: '651'
}, {
  label: 'Construction Consulting & Contracting',
  value: '652'
}, {
  label: 'Urban & Regional Planning',
  value: '686'
}, {
  label: 'Energy & Utilities',
  value: '233'
}, {
  label: 'Electricity',
  value: '658'
}, {
  label: 'Nuclear Energy',
  value: '954'
}, {
  label: 'Oil & Gas',
  value: '659'
}, {
  label: 'Renewable & Alternative Energy',
  value: '657'
}, {
  label: 'Waste Management',
  value: '660'
}, {
  label: 'Recycling',
  value: '1307'
}, {
  label: 'Water Supply & Treatment',
  value: '1349'
}, {
  label: 'Enterprise Technology',
  value: '77'
}, {
  label: 'Customer Relationship Management (CRM)',
  value: '341'
}, {
  label: 'Data Management',
  value: '343'
}, {
  label: 'Enterprise Resource Planning (ERP)',
  value: '342'
}, {
  label: 'Hospitality Industry',
  value: '955'
}, {
  label: 'Event Planning',
  value: '956'
}, {
  label: 'Food Service',
  value: '957'
}, {
  label: 'Grocery & Food Retailers',
  value: '121'
}, {
  label: 'Restaurant Supply',
  value: '816'
}, {
  label: 'Industrial Materials & Equipment',
  value: '287'
}, {
  label: 'Fluid Handling',
  value: '1152'
}, {
  label: 'Valves Hoses & Fittings',
  value: '839'
}, {
  label: 'Generators',
  value: '835'
}, {
  label: 'Heavy Machinery',
  value: '837'
}, {
  label: 'Manufacturing',
  value: '49'
}, {
  label: 'Factory Automation',
  value: '661'
}, {
  label: 'Metals & Mining',
  value: '606'
}, {
  label: 'Pharmaceuticals & Biotech',
  value: '255'
}, {
  label: 'Printing & Publishing',
  value: '1176'
}, {
  label: 'Document & Printing Services',
  value: '332'
}, {
  label: 'Journalism & News Industry',
  value: '1204'
}, {
  label: 'Professional & Trade Associations',
  value: '1199'
}, {
  label: 'Retail Trade',
  value: '841'
}, {
  label: 'Retail Equipment & Technology',
  value: '844'
}, {
  label: 'Small Business',
  value: '551'
}, {
  label: 'Business Formation',
  value: '1200'
}, {
  label: 'Home Office',
  value: '727'
}, {
  label: 'MLM & Business Opportunities',
  value: '552'
}, {
  label: 'Textiles & Nonwovens',
  value: '566'
}, {
  label: 'Transportation & Logistics',
  value: '50'
}, {
  label: 'Aviation',
  value: '662'
}, {
  label: 'Distribution & Logistics',
  value: '664'
}, {
  label: 'Freight & Trucking',
  value: '289'
}, {
  label: 'Import & Export',
  value: '354'
}, {
  label: 'Mail & Package Delivery',
  value: '1150'
}, {
  label: 'Couriers & Messengers',
  value: '663'
}, {
  label: 'Maritime Transport',
  value: '665'
}, {
  label: 'Moving & Relocation',
  value: '291'
}, {
  label: 'Packaging',
  value: '290'
}, {
  label: 'Parking',
  value: '1306'
}, {
  label: 'Airport Parking & Transportation',
  value: '1245'
}, {
  label: 'Public Storage',
  value: '1347'
}, {
  label: 'Rail Transport',
  value: '666'
}, {
  label: 'Urban Transport',
  value: '667'
}, {
  label: 'Computers & Electronics',
  value: '5'
}, {
  label: 'Computer Hardware',
  value: '30'
}, {
  label: 'Computer Components',
  value: '717'
}, {
  label: 'Chips & Processors',
  value: '741'
}, {
  label: 'Computer Memory',
  value: '226'
}, {
  label: 'Sound & Video Cards',
  value: '740'
}, {
  label: 'Computer Drives & Storage',
  value: '496'
}, {
  label: 'CD & DVD Drives & Burners',
  value: '1321'
}, {
  label: 'CD & DVD Storage Media',
  value: '1322'
}, {
  label: 'Data Backup & Recovery',
  value: '1323'
}, {
  label: 'Flash Drives & Memory Cards',
  value: '1318'
}, {
  label: 'Hard Drives',
  value: '1320'
}, {
  label: 'Memory Card Readers',
  value: '1319'
}, {
  label: 'Network Storage',
  value: '729'
}, {
  label: 'Computer Peripherals',
  value: '312'
}, {
  label: 'Computer Monitors & Displays',
  value: '487'
}, {
  label: 'Input Devices',
  value: '493'
}, {
  label: 'Computer Servers',
  value: '728'
}, {
  label: 'Desktop Computers',
  value: '309'
}, {
  label: 'Hardware Modding & Tuning',
  value: '739'
}, {
  label: 'Laptops & Notebooks',
  value: '310'
}, {
  label: 'Tablet PCs',
  value: '1277'
}, {
  label: 'Computer Security',
  value: '314'
}, {
  label: 'Antivirus & Malware',
  value: '315'
}, {
  label: 'Network Security',
  value: '344'
}, {
  label: 'Consumer Electronics',
  value: '78'
}, {
  label: 'Audio Equipment',
  value: '361'
}, {
  label: 'Headphones',
  value: '1396'
}, {
  label: 'MP3 & Portable Media Players',
  value: '227'
}, {
  label: 'Speakers',
  value: '1158'
}, {
  label: 'Stereo Systems & Components',
  value: '91'
}, {
  label: 'Electronic Accessories',
  value: '1192'
}, {
  label: 'Gadgets & Portable Electronics',
  value: '362'
}, {
  label: 'E-Book Readers',
  value: '1324'
}, {
  label: 'Handheld Game Consoles',
  value: '1046'
}, {
  label: 'PDAs & Handhelds',
  value: '228'
}, {
  label: 'Game Systems & Consoles',
  value: '899'
}, {
  label: 'Nintendo',
  value: '1043'
}, {
  label: 'Sony PlayStation',
  value: '1044'
}, {
  label: 'Xbox',
  value: '1045'
}, {
  label: 'TV & Video Equipment',
  value: '229'
}, {
  label: 'DVRs & Set-Top Boxes',
  value: '1393'
}, {
  label: 'Home Theater Systems',
  value: '1157'
}, {
  label: 'Projectors & Screens',
  value: '1334'
}, {
  label: 'Televisions',
  value: '305'
}, {
  label: 'HDTVs',
  value: '1354'
}, {
  label: 'LCD TVs',
  value: '1356'
}, {
  label: 'Plasma TVs',
  value: '1355'
}, {
  label: 'Projection TVs',
  value: '1357'
}, {
  label: 'Video Players & Recorders',
  value: '492'
}, {
  label: 'Blu-Ray Players & Recorders',
  value: '1394'
}, {
  label: 'DVD Players & Recorders',
  value: '1395'
}, {
  label: 'Electronics & Electrical',
  value: '434'
}, {
  label: 'Data Sheets & Electronics Reference',
  value: '900'
}, {
  label: 'Electromechanical Devices',
  value: '743'
}, {
  label: 'Electronic Components',
  value: '742'
}, {
  label: 'Optoelectronics & Fiber',
  value: '744'
}, {
  label: 'Power Supplies',
  value: '745'
}, {
  label: 'Test & Measurement',
  value: '746'
}, {
  label: 'Networking',
  value: '311'
}, {
  label: 'Data Formats & Protocols',
  value: '488'
}, {
  label: 'Distributed & Parallel Computing',
  value: '1298'
}, {
  label: 'Network Monitoring & Management',
  value: '347'
}, {
  label: 'Networking Equipment',
  value: '346'
}, {
  label: 'VPN & Remote Access',
  value: '1279'
}, {
  label: 'Programming',
  value: '31'
}, {
  label: 'C & C++',
  value: '731'
}, {
  label: 'Developer Jobs',
  value: '802'
}, {
  label: 'Development Tools',
  value: '730'
}, {
  label: 'Java',
  value: '732'
}, {
  label: 'Scripting Languages',
  value: '733'
}, {
  label: 'Windows & .NET',
  value: '734'
}, {
  label: 'Software',
  value: '32'
}, {
  label: 'Business & Productivity Software',
  value: '498'
}, {
  label: 'Accounting & Financial Software',
  value: '1341'
}, {
  label: 'Calendar & Scheduling Software',
  value: '1358'
}, {
  label: 'Presentation Software',
  value: '1346'
}, {
  label: 'Spreadsheet Software',
  value: '1344'
}, {
  label: 'Word Processing Software',
  value: '1345'
}, {
  label: 'Device Drivers',
  value: '225'
}, {
  label: 'Educational Software',
  value: '804'
}, {
  label: 'Freeware & Shareware',
  value: '901'
}, {
  label: 'Internet Software',
  value: '807'
}, {
  label: 'Content Management',
  value: '808'
}, {
  label: 'Internet Clients & Browsers',
  value: '304'
}, {
  label: 'Proxying & Filtering',
  value: '902'
}, {
  label: 'Mobile Apps & Add-Ons',
  value: '1109'
}, {
  label: 'Ringtones & Mobile Goodies',
  value: '532'
}, {
  label: 'Multimedia Software',
  value: '497'
}, {
  label: 'Audio & Music Software',
  value: '1089'
}, {
  label: 'Audio Files Formats & Codecs',
  value: '1092'
}, {
  label: 'Desktop Publishing',
  value: '1088'
}, {
  label: 'Fonts',
  value: '805'
}, {
  label: 'Graphics & Animation Software',
  value: '486'
}, {
  label: 'Media Players',
  value: '1090'
}, {
  label: 'Open Source',
  value: '313'
}, {
  label: 'Operating Systems',
  value: '303'
}, {
  label: 'Linux & Unix',
  value: '736'
}, {
  label: 'Mac OS',
  value: '735'
}, {
  label: 'Mobile OS',
  value: '1382'
}, {
  label: 'Windows OS',
  value: '737'
}, {
  label: 'Software Utilities',
  value: '224'
}, {
  label: 'Web Apps & Online Tools',
  value: '1142'
}, {
  label: 'Technical Support',
  value: '567'
}, {
  label: 'Technology News',
  value: '785'
}, {
  label: 'Finance',
  value: '7'
}, {
  label: 'Accounting & Auditing',
  value: '278'
}, {
  label: 'Tax Preparation & Planning',
  value: '1283'
}, {
  label: 'Banking',
  value: '37'
}, {
  label: 'Credit & Lending',
  value: '279'
}, {
  label: 'Auto Financing',
  value: '468'
}, {
  label: 'College Financing',
  value: '813'
}, {
  label: 'Credit Cards',
  value: '811'
}, {
  label: 'Debt Management',
  value: '812'
}, {
  label: 'Home Financing',
  value: '466'
}, {
  label: 'Currencies & Foreign Exchange',
  value: '814'
}, {
  label: 'Financial Planning',
  value: '903'
}, {
  label: 'Grants & Financial Assistance',
  value: '1282'
}, {
  label: 'Insurance',
  value: '38'
}, {
  label: 'Auto Insurance',
  value: '467'
}, {
  label: 'Health Insurance',
  value: '249'
}, {
  label: 'Home Insurance',
  value: '465'
}, {
  label: 'Investing',
  value: '107'
}, {
  label: 'Commodities & Futures Trading',
  value: '904'
}, {
  label: 'Retirement & Pension',
  value: '619'
}, {
  label: 'Food & Drink',
  value: '71'
}, {
  label: 'Alcoholic Beverages',
  value: '277'
}, {
  label: 'Beer',
  value: '404'
}, {
  label: 'Liquor',
  value: '406'
}, {
  label: 'Wine',
  value: '405'
}, {
  label: 'Candy & Sweets',
  value: '906'
}, {
  label: 'Cooking & Recipes',
  value: '122'
}, {
  label: 'Baked Goods',
  value: '907'
}, {
  label: 'Fruits & Vegetables',
  value: '908'
}, {
  label: 'Meat & Seafood',
  value: '909'
}, {
  label: 'Soups & Stews',
  value: '910'
}, {
  label: 'Vegetarian Cuisine',
  value: '825'
}, {
  label: 'World Cuisines',
  value: '911'
}, {
  label: 'Asian Cuisine',
  value: '912'
}, {
  label: 'Latin American Cuisine',
  value: '913'
}, {
  label: 'Mediterranean Cuisine',
  value: '914'
}, {
  label: 'North American Cuisine',
  value: '915'
}, {
  label: 'Culinary Training',
  value: '297'
}, {
  label: 'Non-Alcoholic Beverages',
  value: '560'
}, {
  label: 'Coffee & Tea',
  value: '916'
}, {
  label: 'Restaurants',
  value: '276'
}, {
  label: 'Dining Guides',
  value: '917'
}, {
  label: 'Fast Food',
  value: '918'
}, {
  label: 'Games',
  value: '8'
}, {
  label: 'Arcade & Coin-Op Games',
  value: '919'
}, {
  label: 'Board Games',
  value: '920'
}, {
  label: 'Chess & Abstract Strategy Games',
  value: '921'
}, {
  label: 'Miniatures & Wargaming',
  value: '922'
}, {
  label: 'Card Games',
  value: '39'
}, {
  label: 'Collectible Card Games',
  value: '923'
}, {
  label: 'Poker & Casino Games',
  value: '924'
}, {
  label: 'Computer & Video Games',
  value: '41'
}, {
  label: 'Action & Platform Games',
  value: '1311'
}, {
  label: 'Adventure Games',
  value: '925'
}, {
  label: 'Casual Games',
  value: '926'
}, {
  label: 'Driving & Racing Games',
  value: '927'
}, {
  label: 'Fighting Games',
  value: '928'
}, {
  label: 'Gaming Media & Reference',
  value: '1343'
}, {
  label: 'Game Cheats & Hints',
  value: '381'
}, {
  label: 'Music & Dance Games',
  value: '929'
}, {
  label: 'Shooter Games',
  value: '930'
}, {
  label: 'Simulation Games',
  value: '931'
}, {
  label: 'Sports Games',
  value: '932'
}, {
  label: 'Strategy Games',
  value: '933'
}, {
  label: 'Video Game Emulation',
  value: '1342'
}, {
  label: 'Video Game Retailers',
  value: '1146'
}, {
  label: 'Family-Oriented Games & Activities',
  value: '1290'
}, {
  label: 'Drawing & Coloring',
  value: '1397'
}, {
  label: 'Party Games',
  value: '936'
}, {
  label: 'Puzzles & Brainteasers',
  value: '937'
}, {
  label: 'Roleplaying Games',
  value: '622'
}, {
  label: 'Table Games',
  value: '938'
}, {
  label: 'Billiards',
  value: '939'
}, {
  label: 'Table Tennis',
  value: '940'
}, {
  label: 'Health',
  value: '45'
}, {
  label: 'Aging & Geriatrics',
  value: '623'
}, {
  label: "Alzheimer's Disease",
  value: '624'
}, {
  label: 'Alternative & Natural Medicine',
  value: '499'
}, {
  label: 'Acupuncture & Chinese Medicine',
  value: '1239'
}, {
  label: 'Cleansing & Detoxification',
  value: '1238'
}, {
  label: 'Health Conditions',
  value: '419'
}, {
  label: 'AIDS & HIV',
  value: '625'
}, {
  label: 'Allergies',
  value: '626'
}, {
  label: 'Arthritis',
  value: '628'
}, {
  label: 'Cancer',
  value: '429'
}, {
  label: 'Cold & Flu',
  value: '629'
}, {
  label: 'Diabetes',
  value: '630'
}, {
  label: 'Ear Nose & Throat',
  value: '1211'
}, {
  label: 'Eating Disorders',
  value: '571'
}, {
  label: 'Endocrine Conditions',
  value: '1328'
}, {
  label: 'Thyroid Conditions',
  value: '1329'
}, {
  label: 'Genetic Disorders',
  value: '941'
}, {
  label: 'GERD & Digestive Disorders',
  value: '638'
}, {
  label: 'Heart & Hypertension',
  value: '559'
}, {
  label: 'Infectious Diseases',
  value: '632'
}, {
  label: 'Parasites & Parasitic Diseases',
  value: '1262'
}, {
  label: 'Sexually Transmitted Diseases',
  value: '421'
}, {
  label: 'Vaccines & Immunizations',
  value: '1263'
}, {
  label: 'Injury',
  value: '817'
}, {
  label: 'Neurological Disorders',
  value: '942'
}, {
  label: 'Obesity',
  value: '818'
}, {
  label: 'Pain Management',
  value: '819'
}, {
  label: 'Headaches & Migraines',
  value: '631'
}, {
  label: 'Respiratory Conditions',
  value: '824'
}, {
  label: 'Asthma',
  value: '627'
}, {
  label: 'Skin Conditions',
  value: '420'
}, {
  label: 'Sleep Disorders',
  value: '633'
}, {
  label: 'Health Education & Medical Training',
  value: '254'
}, {
  label: 'Health Foundations & Medical Research',
  value: '252'
}, {
  label: 'Health News',
  value: '1253'
}, {
  label: 'Health Policy',
  value: '1256'
}, {
  label: 'Medical Devices & Equipment',
  value: '251'
}, {
  label: 'Assistive Technology',
  value: '1352'
}, {
  label: 'Mobility Equipment & Accessories',
  value: '1353'
}, {
  label: 'Medical Facilities & Services',
  value: '256'
}, {
  label: "Doctors' Offices",
  value: '634'
}, {
  label: 'Hospitals & Treatment Centers',
  value: '250'
}, {
  label: 'Medical Procedures',
  value: '635'
}, {
  label: 'Medical Tests & Exams',
  value: '943'
}, {
  label: 'Surgery',
  value: '944'
}, {
  label: 'Physical Therapy',
  value: '500'
}, {
  label: 'Medical Literature & Resources',
  value: '253'
}, {
  label: 'Medical Photos & Illustration',
  value: '945'
}, {
  label: "Men's Health",
  value: '636'
}, {
  label: 'Erectile Dysfunction',
  value: '202'
}, {
  label: 'Mental Health',
  value: '437'
}, {
  label: 'Anxiety & Stress',
  value: '639'
}, {
  label: 'Depression',
  value: '640'
}, {
  label: 'Learning & Developmental Disabilities',
  value: '641'
}, {
  label: 'ADD & ADHD',
  value: '642'
}, {
  label: 'Nursing',
  value: '418'
}, {
  label: 'Assisted Living & Long Term Care',
  value: '649'
}, {
  label: 'Nutrition',
  value: '456'
}, {
  label: 'Special & Restricted Diets',
  value: '457'
}, {
  label: 'Cholesterol Issues',
  value: '643'
}, {
  label: 'Vitamins & Supplements',
  value: '237'
}, {
  label: 'Oral & Dental Care',
  value: '245'
}, {
  label: 'Pediatrics',
  value: '645'
}, {
  label: 'Pharmacy',
  value: '248'
}, {
  label: 'Drugs & Medications',
  value: '646'
}, {
  label: 'Public Health',
  value: '947'
}, {
  label: 'Occupational Health & Safety',
  value: '644'
}, {
  label: 'Poisons & Overdoses',
  value: '946'
}, {
  label: 'Reproductive Health',
  value: '195'
}, {
  label: 'Birth Control',
  value: '198'
}, {
  label: 'Infertility',
  value: '647'
}, {
  label: 'OBGYN',
  value: '558'
}, {
  label: 'Pregnancy & Maternity',
  value: '401'
}, {
  label: 'Sex Education & Counseling',
  value: '536'
}, {
  label: 'Sexual Enhancement',
  value: '1236'
}, {
  label: 'Substance Abuse',
  value: '257'
}, {
  label: 'Drug & Alcohol Testing',
  value: '1351'
}, {
  label: 'Drug & Alcohol Treatment',
  value: '1350'
}, {
  label: 'Smoking & Smoking Cessation',
  value: '1237'
}, {
  label: 'Steroids & Performance-Enhancing Drugs',
  value: '1235'
}, {
  label: 'Vision Care',
  value: '246'
}, {
  label: 'Eyeglasses & Contacts',
  value: '1224'
}, {
  label: "Women's Health",
  value: '648'
}, {
  label: 'Hobbies & Leisure',
  value: '65'
}, {
  label: 'Antiques & Collectibles',
  value: '64'
}, {
  label: 'Bowling',
  value: '1016'
}, {
  label: 'Clubs & Organizations',
  value: '189'
}, {
  label: 'Contests, Awards & Prizes',
  value: '1276'
}, {
  label: 'Lottery & Sweepstakes',
  value: '364'
}, {
  label: 'Crafts',
  value: '284'
}, {
  label: 'Fiber & Textile Arts',
  value: '1230'
}, {
  label: 'Cycling',
  value: '458'
}, {
  label: 'Outdoors',
  value: '688'
}, {
  label: 'Equestrian',
  value: '568'
}, {
  label: 'Fishing',
  value: '462'
}, {
  label: 'Hiking & Camping',
  value: '542'
}, {
  label: 'Hunting & Shooting',
  value: '461'
}, {
  label: 'Paintball',
  value: '786'
}, {
  label: 'Pets & Animals',
  value: '66'
}, {
  label: 'Animal Products & Services',
  value: '882'
}, {
  label: 'Animal Welfare',
  value: '883'
}, {
  label: 'Pet Food & Supplies',
  value: '379'
}, {
  label: 'Veterinarians',
  value: '380'
}, {
  label: 'Pets',
  value: '563'
}, {
  label: 'Birds',
  value: '884'
}, {
  label: 'Cats',
  value: '885'
}, {
  label: 'Dogs',
  value: '886'
}, {
  label: 'Exotic Pets',
  value: '607'
}, {
  label: 'Fish & Aquaria',
  value: '887'
}, {
  label: 'Horses',
  value: '888'
}, {
  label: 'Rabbits & Rodents',
  value: '889'
}, {
  label: 'Reptiles & Amphibians',
  value: '890'
}, {
  label: 'Wildlife',
  value: '119'
}, {
  label: 'Insects & Entomology',
  value: '1278'
}, {
  label: 'Zoos-Aquariums-Preserves',
  value: '1009'
}, {
  label: 'Radio Control & Modeling',
  value: '787'
}, {
  label: 'Recreational Aviation',
  value: '999'
}, {
  label: 'Running & Walking',
  value: '541'
}, {
  label: 'Special Occasions',
  value: '977'
}, {
  label: 'Gifts & Special Event Items',
  value: '70'
}, {
  label: 'Cards & Greetings',
  value: '100'
}, {
  label: 'Flowers',
  value: '323'
}, {
  label: 'Gifts',
  value: '99'
}, {
  label: 'Party & Holiday Supplies',
  value: '324'
}, {
  label: 'Holidays & Seasonal Events',
  value: '678'
}, {
  label: 'Birthdays & Name Days',
  value: '1270'
}, {
  label: 'Carnival & Mardi Gras',
  value: '1246'
}, {
  label: 'Christian Holidays',
  value: '1274'
}, {
  label: 'Christmas',
  value: '1078'
}, {
  label: 'Easter',
  value: '1123'
}, {
  label: 'Halloween & October 31st',
  value: '1079'
}, {
  label: 'Islamic Holidays',
  value: '1275'
}, {
  label: 'Jewish Holidays',
  value: '1124'
}, {
  label: 'New Year',
  value: '1271'
}, {
  label: 'Thanksgiving',
  value: '1125'
}, {
  label: "Valentine's Day",
  value: '1122'
}, {
  label: 'Weddings',
  value: '293'
}, {
  label: 'Subcultures & Niche Interests',
  value: '502'
}, {
  label: 'Goth Subculture',
  value: '503'
}, {
  label: 'Science Fiction & Fantasy',
  value: '676'
}, {
  label: 'Water Activities',
  value: '1002'
}, {
  label: 'Boating',
  value: '459'
}, {
  label: 'Diving & Underwater Activities',
  value: '1305'
}, {
  label: 'Surf & Swim',
  value: '689'
}, {
  label: 'Water Sports',
  value: '118'
}, {
  label: 'Home & Garden',
  value: '11'
}, {
  label: 'Bed & Bath',
  value: '948'
}, {
  label: 'Bathroom',
  value: '1365'
}, {
  label: 'Bedroom',
  value: '1366'
}, {
  label: 'Bedding & Bed Linens',
  value: '1369'
}, {
  label: 'Beds & Headboards',
  value: '1367'
}, {
  label: 'Mattresses',
  value: '1368'
}, {
  label: 'Domestic Services',
  value: '472'
}, {
  label: 'Cleaning Supplies & Services',
  value: '949'
}, {
  label: 'Gardening & Landscaping',
  value: '269'
}, {
  label: 'Home Appliances',
  value: '271'
}, {
  label: 'Major Kitchen Appliances',
  value: '1293'
}, {
  label: 'Small Kitchen Appliances',
  value: '1292'
}, {
  label: 'Water Filters & Purifiers',
  value: '1371'
}, {
  label: 'Home Furnishings',
  value: '270'
}, {
  label: 'Clocks',
  value: '1363'
}, {
  label: 'Lamps & Lighting',
  value: '272'
}, {
  label: 'Rugs & Carpets',
  value: '1362'
}, {
  label: 'Sofas & Chairs',
  value: '1370'
}, {
  label: 'Home Improvement',
  value: '158'
}, {
  label: 'Construction & Power Tools',
  value: '950'
}, {
  label: 'Flooring',
  value: '832'
}, {
  label: 'House Painting & Finishing',
  value: '1232'
}, {
  label: 'Plumbing',
  value: '1153'
}, {
  label: 'Roofing',
  value: '1175'
}, {
  label: 'Home Storage & Shelving',
  value: '1348'
}, {
  label: 'Homemaking & Interior Decor',
  value: '137'
}, {
  label: 'Kitchen & Dining',
  value: '951'
}, {
  label: 'Cookware & Diningware',
  value: '120'
}, {
  label: 'Cutlery & Cutting Accessories',
  value: '1373'
}, {
  label: 'Laundry',
  value: '1364'
}, {
  label: 'Nursery & Playroom',
  value: '1372'
}, {
  label: 'Pest Control',
  value: '471'
}, {
  label: 'Swimming Pools & Spas',
  value: '952'
}, {
  label: 'Yard & Patio',
  value: '953'
}, {
  label: 'Internet & Telecom',
  value: '13'
}, {
  label: 'Communications Equipment',
  value: '385'
}, {
  label: 'Radio Equipment',
  value: '1182'
}, {
  label: 'Email & Messaging',
  value: '394'
}, {
  label: 'Microblogging',
  value: '1381'
}, {
  label: 'Text & Instant Messaging',
  value: '1379'
}, {
  label: 'Voice & Video Chat',
  value: '386'
}, {
  label: 'Mobile & Wireless',
  value: '382'
}, {
  label: 'Mobile & Wireless Accessories',
  value: '1171'
}, {
  label: 'Bluetooth Accessories',
  value: '1170'
}, {
  label: 'Mobile Phones',
  value: '390'
}, {
  label: 'Smart Phones',
  value: '1071'
}, {
  label: 'Search Engines',
  value: '485'
}, {
  label: 'People Search',
  value: '1234'
}, {
  label: 'Service Providers',
  value: '383'
}, {
  label: 'Cable & Satellite Providers',
  value: '501'
}, {
  label: 'ISPs',
  value: '104'
}, {
  label: 'Phone Service Providers',
  value: '384'
}, {
  label: 'Calling Cards',
  value: '389'
}, {
  label: 'Teleconferencing',
  value: '392'
}, {
  label: 'Web Services',
  value: '302'
}, {
  label: 'Affiliate Programs',
  value: '326'
}, {
  label: 'Web Design & Development',
  value: '422'
}, {
  label: 'Web Hosting & Domain Registration',
  value: '53'
}, {
  label: 'Web Stats & Analytics',
  value: '675'
}, {
  label: 'Jobs & Education',
  value: '958'
}, {
  label: 'Education',
  value: '74'
}, {
  label: 'Academic Conferences & Publications',
  value: '1289'
}, {
  label: 'Alumni & Reunions',
  value: '1015'
}, {
  label: 'Colleges & Universities',
  value: '372'
}, {
  label: 'Distance Learning',
  value: '367'
}, {
  label: 'Early Childhood Education',
  value: '1012'
}, {
  label: 'Foreign Language Study',
  value: '1266'
}, {
  label: 'Homeschooling',
  value: '791'
}, {
  label: 'Legal Education',
  value: '792'
}, {
  label: 'Primary & Secondary Schooling (K-12)',
  value: '371'
}, {
  label: 'Special Education',
  value: '1118'
}, {
  label: 'Standardized & Admissions Tests',
  value: '373'
}, {
  label: 'Study Abroad',
  value: '1308'
}, {
  label: 'Teaching & Classroom Resources',
  value: '700'
}, {
  label: 'Training & Certification',
  value: '1388'
}, {
  label: 'Vocational & Continuing Education',
  value: '369'
}, {
  label: 'Computer Education',
  value: '1229'
}, {
  label: 'Jobs',
  value: '60'
}, {
  label: 'Career Resources & Planning',
  value: '959'
}, {
  label: 'Job Listings',
  value: '960'
}, {
  label: 'Resumes & Portfolios',
  value: '961'
}, {
  label: 'Law & Government',
  value: '19'
}, {
  label: 'Government',
  value: '76'
}, {
  label: 'Courts & Judiciary',
  value: '1075'
}, {
  label: 'Embassies & Consulates',
  value: '962'
}, {
  label: 'Executive Branch',
  value: '963'
}, {
  label: 'Government Agencies',
  value: '1387'
}, {
  label: 'Government Contracting & Procurement',
  value: '1385'
}, {
  label: 'Intelligence & Counterterrorism',
  value: '1221'
}, {
  label: 'Legislative Branch',
  value: '964'
}, {
  label: 'Lobbying',
  value: '1386'
}, {
  label: 'Multilateral Organizations',
  value: '965'
}, {
  label: 'Public Finance',
  value: '1161'
}, {
  label: 'Public Policy',
  value: '1316'
}, {
  label: 'Drug Laws & Policy',
  value: '1314'
}, {
  label: 'Immigration Policy & Border Issues',
  value: '1313'
}, {
  label: 'International Relations',
  value: '521'
}, {
  label: 'Royalty',
  value: '702'
}, {
  label: 'State & Local Government',
  value: '966'
}, {
  label: 'Visa & Immigration',
  value: '555'
}, {
  label: 'Legal',
  value: '75'
}, {
  label: 'Accident & Personal Injury Law',
  value: '427'
}, {
  label: 'Bankruptcy',
  value: '423'
}, {
  label: 'Business & Corporate Law',
  value: '1272'
}, {
  label: 'Constitutional Law & Civil Rights',
  value: '967'
}, {
  label: 'Criminal Law',
  value: '424'
}, {
  label: 'Family Law',
  value: '522'
}, {
  label: 'Intellectual Property',
  value: '426'
}, {
  label: 'Labor & Employment Law',
  value: '701'
}, {
  label: 'Legal Services',
  value: '969'
}, {
  label: 'Product Liability',
  value: '970'
}, {
  label: 'Military',
  value: '366'
}, {
  label: 'Air Force',
  value: '1247'
}, {
  label: 'Army',
  value: '1248'
}, {
  label: 'Marines',
  value: '1250'
}, {
  label: 'Military History',
  value: '1288'
}, {
  label: 'Navy',
  value: '1249'
}, {
  label: 'Veterans',
  value: '793'
}, {
  label: 'Public Safety',
  value: '166'
}, {
  label: 'Crime & Justice',
  value: '704'
}, {
  label: 'Corporate & Financial Crime',
  value: '1181'
}, {
  label: 'Gangs & Organized Crime',
  value: '1312'
}, {
  label: 'Prisons & Corrections',
  value: '1284'
}, {
  label: 'Emergency Services',
  value: '168'
}, {
  label: 'Law Enforcement',
  value: '535'
}, {
  label: 'Security Products & Services',
  value: '705'
}, {
  label: 'Social Services',
  value: '508'
}, {
  label: 'Counseling Services',
  value: '511'
}, {
  label: 'Welfare & Unemployment',
  value: '706'
}, {
  label: 'News',
  value: '16'
}, {
  label: 'Broadcast & Network News',
  value: '112'
}, {
  label: 'Gossip & Tabloid News',
  value: '507'
}, {
  label: 'Scandals & Investigations',
  value: '1259'
}, {
  label: 'Local News',
  value: '572'
}, {
  label: 'Newspapers',
  value: '408'
}, {
  label: 'Politics',
  value: '396'
}, {
  label: 'Campaigns & Elections',
  value: '398'
}, {
  label: 'Left-Wing Politics',
  value: '410'
}, {
  label: 'Media Critics & Watchdogs',
  value: '1203'
}, {
  label: 'Opinion & Commentary',
  value: '1201'
}, {
  label: 'Political Polls & Surveys',
  value: '1202'
}, {
  label: 'Right-Wing Politics',
  value: '409'
}, {
  label: 'Sports News',
  value: '1077'
}, {
  label: 'Weather',
  value: '63'
}, {
  label: 'World News',
  value: '1209'
}, {
  label: 'Online Communities',
  value: '299'
}, {
  label: 'Blogging Resources & Services',
  value: '504'
}, {
  label: 'Dating & Personals',
  value: '55'
}, {
  label: 'Matrimonial Services',
  value: '546'
}, {
  label: 'Personals',
  value: '102'
}, {
  label: 'File Sharing & Hosting',
  value: '321'
}, {
  label: 'Forum & Chat Providers',
  value: '191'
}, {
  label: 'Online Goodies',
  value: '43'
}, {
  label: 'Clip Art & Animated GIFs',
  value: '1223'
}, {
  label: 'Skins Themes & Wallpapers',
  value: '578'
}, {
  label: 'Social Network Apps & Add-Ons',
  value: '847'
}, {
  label: 'Online Journals & Personal Sites',
  value: '582'
}, {
  label: 'Photo & Video Sharing',
  value: '275'
}, {
  label: 'Social Networks',
  value: '529'
}, {
  label: 'Virtual Worlds',
  value: '972'
}, {
  label: 'People & Society',
  value: '14'
}, {
  label: 'Disabled & Special Needs',
  value: '677'
}, {
  label: 'Ethnic & Identity Groups',
  value: '56'
}, {
  label: 'Africans & Diaspora',
  value: '579'
}, {
  label: 'African-Americans',
  value: '547'
}, {
  label: 'Arabs & Middle Easterners',
  value: '556'
}, {
  label: 'Asians & Diaspora',
  value: '1257'
}, {
  label: 'East Asians & Diaspora',
  value: '549'
}, {
  label: 'South Asians & Diaspora',
  value: '528'
}, {
  label: 'Southeast Asians & Pacific Islanders',
  value: '580'
}, {
  label: 'Discrimination & Identity Relations',
  value: '1205'
}, {
  label: 'Eastern Europeans',
  value: '682'
}, {
  label: 'Expatriate Communities',
  value: '973'
}, {
  label: 'Gay-Lesbian-Bisexual-Transgender',
  value: '113'
}, {
  label: 'Indigenous Peoples',
  value: '681'
}, {
  label: 'Native Americans',
  value: '171'
}, {
  label: 'Jewish Culture',
  value: '550'
}, {
  label: 'Latinos & Latin-Americans',
  value: '548'
}, {
  label: 'Western Europeans',
  value: '683'
}, {
  label: 'Family & Relationships',
  value: '1131'
}, {
  label: 'Etiquette',
  value: '1304'
}, {
  label: 'Family',
  value: '1132'
}, {
  label: 'Ancestry & Genealogy',
  value: '400'
}, {
  label: 'Baby & Pet Names',
  value: '1231'
}, {
  label: 'Parenting',
  value: '58'
}, {
  label: 'Adoption',
  value: '974'
}, {
  label: 'Babies & Toddlers',
  value: '1374'
}, {
  label: 'Baby Care & Hygiene',
  value: '115'
}, {
  label: 'Child Care',
  value: '403'
}, {
  label: 'Youth Camps',
  value: '402'
}, {
  label: 'Friendship',
  value: '1134'
}, {
  label: 'Marriage',
  value: '1133'
}, {
  label: 'Divorce & Separation',
  value: '1261'
}, {
  label: 'Romance',
  value: '1135'
}, {
  label: 'Troubled Relationships',
  value: '1260'
}, {
  label: 'Kids & Teens',
  value: '154'
}, {
  label: "Children's Interests",
  value: '679'
}, {
  label: 'Teen Interests',
  value: '680'
}, {
  label: 'Religion & Belief',
  value: '59'
}, {
  label: 'Astrology & Divination',
  value: '448'
}, {
  label: 'Buddhism',
  value: '862'
}, {
  label: 'Christianity',
  value: '864'
}, {
  label: 'Hinduism',
  value: '866'
}, {
  label: 'Islam',
  value: '868'
}, {
  label: 'Judaism',
  value: '869'
}, {
  label: 'Pagan & Esoteric Traditions',
  value: '1258'
}, {
  label: 'Places of Worship',
  value: '1296'
}, {
  label: 'Scientology',
  value: '1251'
}, {
  label: 'Self-Help & Motivational',
  value: '870'
}, {
  label: 'Skeptics & Non-Believers',
  value: '975'
}, {
  label: 'Spirituality',
  value: '101'
}, {
  label: 'Theology & Religious Study',
  value: '1340'
}, {
  label: 'Seniors & Retirement',
  value: '298'
}, {
  label: 'Social Issues & Advocacy',
  value: '54'
}, {
  label: 'Charity & Philanthropy',
  value: '57'
}, {
  label: 'Environmental Issues',
  value: '82'
}, {
  label: 'Climate Change & Global Warming',
  value: '1255'
}, {
  label: 'Housing & Development',
  value: '1166'
}, {
  label: 'Human Rights & Liberties',
  value: '1280'
}, {
  label: 'Poverty & Hunger',
  value: '1127'
}, {
  label: 'Privacy Issues',
  value: '1281'
}, {
  label: 'Reproductive Rights',
  value: '976'
}, {
  label: 'Same-Sex Marriage',
  value: '1301'
}, {
  label: 'Work & Labor Issues',
  value: '703'
}, {
  label: 'Unions & Labor Movement',
  value: '1121'
}, {
  label: 'Social Sciences',
  value: '509'
}, {
  label: 'Communications & Media Studies',
  value: '1302'
}, {
  label: 'Public Speaking',
  value: '1303'
}, {
  label: 'Demographics',
  value: '510'
}, {
  label: 'Economics',
  value: '520'
}, {
  label: 'Psychology',
  value: '543'
}, {
  label: 'Real Estate',
  value: '29'
}, {
  label: 'Apartments & Residential Rentals',
  value: '378'
}, {
  label: 'Commercial & Investment Real Estate',
  value: '1178'
}, {
  label: 'Property Development',
  value: '687'
}, {
  label: 'Property Inspections & Appraisals',
  value: '463'
}, {
  label: 'Property Management',
  value: '425'
}, {
  label: 'Real Estate Agencies',
  value: '96'
}, {
  label: 'Real Estate Listings',
  value: '1080'
}, {
  label: 'Timeshares & Vacation Properties',
  value: '1081'
}, {
  label: 'Reference',
  value: '533'
}, {
  label: 'Directories & Listings',
  value: '527'
}, {
  label: 'Business & Personal Listings',
  value: '377'
}, {
  label: 'General Reference',
  value: '980'
}, {
  label: 'Calculators & Reference Tools',
  value: '691'
}, {
  label: 'Dictionaries & Encyclopedias',
  value: '692'
}, {
  label: 'Educational Resources',
  value: '374'
}, {
  label: 'Forms Guides & Templates',
  value: '693'
}, {
  label: 'Legal Forms',
  value: '1137'
}, {
  label: 'How-To, DIY & Expert Content',
  value: '694'
}, {
  label: 'Public Records',
  value: '1136'
}, {
  label: 'Time & Calendars',
  value: '695'
}, {
  label: 'Geographic Reference',
  value: '1084'
}, {
  label: 'City & Local Guides',
  value: '1014'
}, {
  label: 'Maps',
  value: '268'
}, {
  label: 'Traffic & Public Transit',
  value: '685'
}, {
  label: 'Humanities',
  value: '474'
}, {
  label: 'History',
  value: '433'
}, {
  label: 'Myth & Folklore',
  value: '609'
}, {
  label: 'Philosophy',
  value: '1093'
}, {
  label: 'Language Resources',
  value: '108'
}, {
  label: 'Foreign Language Resources',
  value: '1264'
}, {
  label: 'Translation Tools & Resources',
  value: '1265'
}, {
  label: 'Libraries & Museums',
  value: '375'
}, {
  label: 'Technical Reference',
  value: '1233'
}, {
  label: 'Science',
  value: '174'
}, {
  label: 'Astronomy',
  value: '435'
}, {
  label: 'Biological Sciences',
  value: '440'
}, {
  label: 'Anatomy',
  value: '788'
}, {
  label: 'Flora & Fauna',
  value: '981'
}, {
  label: 'Genetics',
  value: '982'
}, {
  label: 'Neuroscience',
  value: '1226'
}, {
  label: 'Chemistry',
  value: '505'
}, {
  label: 'Computer Science',
  value: '1227'
}, {
  label: 'Machine Learning & Artificial Intelligence',
  value: '1299'
}, {
  label: 'Earth Sciences',
  value: '1168'
}, {
  label: 'Atmospheric Science',
  value: '1254'
}, {
  label: 'Geology',
  value: '443'
}, {
  label: 'Paleontology',
  value: '1169'
}, {
  label: 'Water & Marine Sciences',
  value: '441'
}, {
  label: 'Ecology & Environment',
  value: '442'
}, {
  label: 'Engineering & Technology',
  value: '231'
}, {
  label: 'Robotics',
  value: '1141'
}, {
  label: 'Mathematics',
  value: '436'
}, {
  label: 'Statistics',
  value: '1252'
}, {
  label: 'Physics',
  value: '444'
}, {
  label: 'Scientific Equipment',
  value: '445'
}, {
  label: 'Scientific Institutions',
  value: '446'
}, {
  label: 'Shopping',
  value: '18'
}, {
  label: 'Apparel',
  value: '68'
}, {
  label: 'Apparel Services',
  value: '1228'
}, {
  label: 'Athletic Apparel',
  value: '983'
}, {
  label: 'Casual Apparel',
  value: '984'
}, {
  label: 'T-Shirts',
  value: '428'
}, {
  label: "Children's Clothing",
  value: '985'
}, {
  label: 'Clothing Accessories',
  value: '124'
}, {
  label: 'Gems & Jewelry',
  value: '350'
}, {
  label: 'Handbags & Purses',
  value: '986'
}, {
  label: 'Watches',
  value: '987'
}, {
  label: 'Costumes',
  value: '988'
}, {
  label: 'Eyewear',
  value: '989'
}, {
  label: 'Footwear',
  value: '697'
}, {
  label: 'Formal Wear',
  value: '990'
}, {
  label: 'Headwear',
  value: '991'
}, {
  label: "Men's Clothing",
  value: '992'
}, {
  label: 'Outerwear',
  value: '993'
}, {
  label: 'Sleepwear',
  value: '994'
}, {
  label: 'Swimwear',
  value: '995'
}, {
  label: 'Undergarments',
  value: '530'
}, {
  label: 'Uniforms & Workwear',
  value: '996'
}, {
  label: "Women's Clothing",
  value: '997'
}, {
  label: 'Auctions',
  value: '292'
}, {
  label: 'Classifieds',
  value: '61'
}, {
  label: 'Consumer Resources',
  value: '69'
}, {
  label: 'Consumer Advocacy & Protection',
  value: '97'
}, {
  label: 'Coupons & Discount Offers',
  value: '365'
}, {
  label: 'Customer Services',
  value: '450'
}, {
  label: 'Warranties & Service Contracts',
  value: '451'
}, {
  label: 'Product Reviews & Price Comparisons',
  value: '353'
}, {
  label: 'Price Comparisons',
  value: '352'
}, {
  label: 'Entertainment Media',
  value: '1143'
}, {
  label: 'Entertainment Media Rentals',
  value: '1144'
}, {
  label: 'Luxury Goods',
  value: '696'
}, {
  label: 'Mass Merchants & Department Stores',
  value: '73'
}, {
  label: 'Shopping Portals & Search Engines',
  value: '531'
}, {
  label: 'Sporting Goods',
  value: '263'
}, {
  label: 'Sports Memorabilia',
  value: '1083'
}, {
  label: 'Swap Meets & Outdoor Markets',
  value: '1210'
}, {
  label: 'Tobacco Products',
  value: '123'
}, {
  label: 'Toys',
  value: '432'
}, {
  label: 'Wholesalers & Liquidators',
  value: '1225'
}, {
  label: 'Sports',
  value: '20'
}, {
  label: 'College Sports',
  value: '1073'
}, {
  label: 'Combat Sports',
  value: '514'
}, {
  label: 'Boxing',
  value: '515'
}, {
  label: 'Martial Arts',
  value: '516'
}, {
  label: 'Wrestling',
  value: '512'
}, {
  label: 'Extreme Sports',
  value: '554'
}, {
  label: 'Drag & Street Racing',
  value: '1206'
}, {
  label: 'Stunts & Dangerous Feats',
  value: '1207'
}, {
  label: 'Fantasy Sports',
  value: '998'
}, {
  label: 'Individual Sports',
  value: '1000'
}, {
  label: 'Golf',
  value: '261'
}, {
  label: 'Gymnastics',
  value: '519'
}, {
  label: 'Racquet Sports',
  value: '262'
}, {
  label: 'Tennis',
  value: '1376'
}, {
  label: 'Skate Sports',
  value: '1126'
}, {
  label: 'Track & Field',
  value: '518'
}, {
  label: 'Motor Sports',
  value: '180'
}, {
  label: 'Sports Coaching & Training',
  value: '1082'
}, {
  label: 'Team Sports',
  value: '1001'
}, {
  label: 'American Football',
  value: '258'
}, {
  label: 'Baseball',
  value: '259'
}, {
  label: 'Basketball',
  value: '264'
}, {
  label: 'Cheerleading',
  value: '534'
}, {
  label: 'Cricket',
  value: '296'
}, {
  label: 'Handball',
  value: '1017'
}, {
  label: 'Hockey',
  value: '260'
}, {
  label: 'Rugby',
  value: '517'
}, {
  label: 'Soccer',
  value: '294'
}, {
  label: 'Volleyball',
  value: '699'
}, {
  label: 'Winter Sports',
  value: '265'
}, {
  label: 'Ice Skating',
  value: '1149'
}, {
  label: 'Skiing & Snowboarding',
  value: '1148'
}, {
  label: 'World Sports Competitions',
  value: '1198'
}, {
  label: 'Olympics',
  value: '513'
}, {
  label: 'Travel',
  value: '67'
}, {
  label: 'Air Travel',
  value: '203'
}, {
  label: 'Bus & Rail',
  value: '708'
}, {
  label: 'Car Rental & Taxi Services',
  value: '205'
}, {
  label: 'Carpooling & Ridesharing',
  value: '1339'
}, {
  label: 'Cruises & Charters',
  value: '206'
}, {
  label: 'Hotels & Accommodations',
  value: '179'
}, {
  label: 'Luggage & Travel Accessories',
  value: '1003'
}, {
  label: 'Specialty Travel',
  value: '1004'
}, {
  label: 'Adventure Travel',
  value: '707'
}, {
  label: 'Agritourism',
  value: '1389'
}, {
  label: 'Ecotourism',
  value: '1005'
}, {
  label: 'Sightseeing Tours',
  value: '1390'
}, {
  label: 'Vineyards & Wine Tourism',
  value: '1391'
}, {
  label: 'Tourist Destinations',
  value: '208'
}, {
  label: 'Beaches & Islands',
  value: '1074'
}, {
  label: 'Historical Sites & Buildings',
  value: '1006'
}, {
  label: 'Lakes & Rivers',
  value: '1120'
}, {
  label: 'Mountain & Ski Resorts',
  value: '1119'
}, {
  label: 'Regional Parks & Gardens',
  value: '1007'
}, {
  label: 'Theme Parks',
  value: '1008'
}, {
  label: 'Travel Agencies & Services',
  value: '1010'
}, {
  label: 'Tourist Boards & Visitor Centers',
  value: '1392'
}, {
  label: 'Vacation Offers',
  value: '1019'
}, {
  label: 'Travel Guides & Travelogues',
  value: '1011'
}];
const locationOptions = [{
  value: '',
  label: 'No selection'
}, {
  value: 'Afghanistan',
  label: 'Afghanistan'
}, {
  value: 'Albania',
  label: 'Albania'
}, {
  value: 'Algeria',
  label: 'Algeria'
}, {
  value: 'American Samoa',
  label: 'American Samoa'
}, {
  value: 'Andorra',
  label: 'Andorra'
}, {
  value: 'Angola',
  label: 'Angola'
}, {
  value: 'Anguila',
  label: 'Anguila'
}, {
  value: 'Antigua & Barbuda',
  label: 'Antigua & Barbuda'
}, {
  value: 'Argentina',
  label: 'Argentina'
}, {
  value: 'Armenia',
  label: 'Armenia'
}, {
  value: 'Ascension Island',
  label: 'Ascension Island'
}, {
  value: 'Australia',
  label: 'Australia'
}, {
  value: 'Austria',
  label: 'Austria'
}, {
  value: 'Azerbaijan',
  label: 'Azerbaijan'
}, {
  value: 'Bahamas',
  label: 'Bahamas'
}, {
  value: 'Bahrain',
  label: 'Bahrain'
}, {
  value: 'Bangladesh',
  label: 'Bangladesh'
}, {
  value: 'Belarus',
  label: 'Belarus'
}, {
  value: 'Belgium',
  label: 'Belgium'
}, {
  value: 'Belize',
  label: 'Belize'
}, {
  value: 'Benin',
  label: 'Benin'
}, {
  value: 'Bhutan',
  label: 'Bhutan'
}, {
  value: 'Bolivia',
  label: 'Bolivia'
}, {
  value: 'Bosnia & Herzegovinia',
  label: 'Bosnia & Herzegovinia'
}, {
  value: 'Botswana',
  label: 'Botswana'
}, {
  value: 'Brazil',
  label: 'Brazil'
}, {
  value: 'British Virgin Islands',
  label: 'British Virgin Islands'
}, {
  value: 'Brunei',
  label: 'Brunei'
}, {
  value: 'Bulgaria',
  label: 'Bulgaria'
}, {
  value: 'Burkina Faso',
  label: 'Burkina Faso'
}, {
  value: 'Burundi',
  label: 'Burundi'
}, {
  value: 'Cambodia',
  label: 'Cambodia'
}, {
  value: 'Cameroon',
  label: 'Cameroon'
}, {
  value: 'Canada',
  label: 'Canada'
}, {
  value: 'Cape Verde',
  label: 'Cape Verde'
}, {
  value: 'Catalan Countries',
  label: 'Catalan Countries'
}, {
  value: 'Central African Republic',
  label: 'Central African Republic'
}, {
  value: 'Chad',
  label: 'Chad'
}, {
  value: 'Chile',
  label: 'Chile'
}, {
  value: 'China',
  label: 'China'
}, {
  value: 'Columbia',
  label: 'Columbia'
}, {
  value: 'Congo, Democratic Republic',
  label: 'Congo, Democratic Republic'
}, {
  value: 'Congo',
  label: 'Congo'
}, {
  value: 'Cook Islands',
  label: 'Cook Islands'
}, {
  value: 'Costa Rica',
  label: 'Costa Rica'
}, {
  value: "Côte d'Ivoire",
  label: "Côte d'Ivoire"
}, {
  value: 'Croatia',
  label: 'Croatia'
}, {
  value: 'Cuba',
  label: 'Cuba'
}, {
  value: 'Cyprus',
  label: 'Cyprus'
}, {
  value: 'Czech Republic',
  label: 'Czech Republic'
}, {
  value: 'Denmark',
  label: 'Denmark'
}, {
  value: 'Djibouti',
  label: 'Djibouti'
}, {
  value: 'Dominica',
  label: 'Dominica'
}, {
  value: 'Dominican Republic',
  label: 'Dominican Republic'
}, {
  value: 'Ecuador',
  label: 'Ecuador'
}, {
  value: 'Egypt',
  label: 'Egypt'
}, {
  value: 'El Salvador',
  label: 'El Salvador'
}, {
  value: 'Estonia',
  label: 'Estonia'
}, {
  value: 'Ethiopia',
  label: 'Ethiopia'
}, {
  value: 'Fiji',
  label: 'Fiji'
}, {
  value: 'Finland',
  label: 'Finland'
}, {
  value: 'France',
  label: 'France'
}, {
  value: 'Gabon',
  label: 'Gabon'
}, {
  value: 'Gambia',
  label: 'Gambia'
}, {
  value: 'Georgia',
  label: 'Georgia'
}, {
  value: 'Germany',
  label: 'Germany'
}, {
  value: 'Ghana',
  label: 'Ghana'
}, {
  value: 'Gibraltar',
  label: 'Gibraltar'
}, {
  value: 'Greece',
  label: 'Greece'
}, {
  value: 'Greenland',
  label: 'Greenland'
}, {
  value: 'Guadeloupe',
  label: 'Guadeloupe'
}, {
  value: 'Guatemala',
  label: 'Guatemala'
}, {
  value: 'Guernsey',
  label: 'Guernsey'
}, {
  value: 'Guyana',
  label: 'Guyana'
}, {
  value: 'Haiti',
  label: 'Haiti'
}, {
  value: 'Honduras',
  label: 'Honduras'
}, {
  value: 'Hong Kong',
  label: 'Hong Kong'
}, {
  value: 'Hungary',
  label: 'Hungary'
}, {
  value: 'Iceland',
  label: 'Iceland'
}, {
  value: 'India',
  label: 'India'
}, {
  value: 'Indonesia',
  label: 'Indonesia'
}, {
  value: 'Iraq',
  label: 'Iraq'
}, {
  value: 'Ireland',
  label: 'Ireland'
}, {
  value: 'Isle of Man',
  label: 'Isle of Man'
}, {
  value: 'Israel',
  label: 'Israel'
}, {
  value: 'Italy',
  label: 'Italy'
}, {
  value: 'Ivory Coast',
  label: 'Ivory Coast'
}, {
  value: 'Jamaica',
  label: 'Jamaica'
}, {
  value: 'Japan',
  label: 'Japan'
}, {
  value: 'Jersey',
  label: 'Jersey'
}, {
  value: 'Jordon',
  label: 'Jordon'
}, {
  value: 'Kazakhstan',
  label: 'Kazakhstan'
}, {
  value: 'Kenya',
  label: 'Kenya'
}, {
  value: 'Kiribati',
  label: 'Kiribati'
}, {
  value: 'Kuwait',
  label: 'Kuwait'
}, {
  value: 'Kyrgyzstan',
  label: 'Kyrgyzstan'
}, {
  value: 'Laos',
  label: 'Laos'
}, {
  value: 'Latvia',
  label: 'Latvia'
}, {
  value: 'Lebanon',
  label: 'Lebanon'
}, {
  value: 'Lesotho',
  label: 'Lesotho'
}, {
  value: 'Libya',
  label: 'Libya'
}, {
  value: 'Liechtenstein',
  label: 'Liechtenstein'
}, {
  value: 'Lithuania',
  label: 'Lithuania'
}, {
  value: 'Luxembourg',
  label: 'Luxembourg'
}, {
  value: 'Macedonia',
  label: 'Macedonia'
}, {
  value: 'Madagascar',
  label: 'Madagascar'
}, {
  value: 'Malawi',
  label: 'Malawi'
}, {
  value: 'Malaysia',
  label: 'Malaysia'
}, {
  value: 'Maldives',
  label: 'Maldives'
}, {
  value: 'Mali',
  label: 'Mali'
}, {
  value: 'Malta',
  label: 'Malta'
}, {
  value: 'Mauritius',
  label: 'Mauritius'
}, {
  value: 'Mexico',
  label: 'Mexico'
}, {
  value: 'Micronesia',
  label: 'Micronesia'
}, {
  value: 'Moldavia',
  label: 'Moldavia'
}, {
  value: 'Mongolia',
  label: 'Mongolia'
}, {
  value: 'Montenegro',
  label: 'Montenegro'
}, {
  value: 'Montserrat',
  label: 'Montserrat'
}, {
  value: 'Morocco',
  label: 'Morocco'
}, {
  value: 'Mozambique',
  label: 'Mozambique'
}, {
  value: 'Namibia',
  label: 'Namibia'
}, {
  value: 'Nauru',
  label: 'Nauru'
}, {
  value: 'Nepal',
  label: 'Nepal'
}, {
  value: 'Netherlands',
  label: 'Netherlands'
}, {
  value: 'New Zealand',
  label: 'New Zealand'
}, {
  value: 'Nicaragua',
  label: 'Nicaragua'
}, {
  value: 'Niger',
  label: 'Niger'
}, {
  value: 'Nigeria',
  label: 'Nigeria'
}, {
  value: 'Niue',
  label: 'Niue'
}, {
  value: 'Norfolk Island',
  label: 'Norfolk Island'
}, {
  value: 'Norway',
  label: 'Norway'
}, {
  value: 'Oman',
  label: 'Oman'
}, {
  value: 'Pakistan',
  label: 'Pakistan'
}, {
  value: 'Palestine',
  label: 'Palestine'
}, {
  value: 'Panama',
  label: 'Panama'
}, {
  value: 'Papua New Guina',
  label: 'Papua New Guina'
}, {
  value: 'Paraguay',
  label: 'Paraguay'
}, {
  value: 'Peru',
  label: 'Peru'
}, {
  value: 'Philippines',
  label: 'Philippines'
}, {
  value: 'Pitcairn',
  label: 'Pitcairn'
}, {
  value: 'Poland',
  label: 'Poland'
}, {
  value: 'Portugal',
  label: 'Portugal'
}, {
  value: 'Puerto Rico',
  label: 'Puerto Rico'
}, {
  value: 'Quatar',
  label: 'Quatar'
}, {
  value: 'Romania',
  label: 'Romania'
}, {
  value: 'Russia',
  label: 'Russia'
}, {
  value: 'Rwanda',
  label: 'Rwanda'
}, {
  value: 'Saint Helena',
  label: 'Saint Helena'
}, {
  value: 'Samoa',
  label: 'Samoa'
}, {
  value: 'San Marino',
  label: 'San Marino'
}, {
  value: 'Sao Tome and Principe',
  label: 'Sao Tome and Principe'
}, {
  value: 'Saudia Arabia',
  label: 'Saudia Arabia'
}, {
  value: 'Senegal',
  label: 'Senegal'
}, {
  value: 'Serbia',
  label: 'Serbia'
}, {
  value: 'Seychelles',
  label: 'Seychelles'
}, {
  value: 'Sierra Leone',
  label: 'Sierra Leone'
}, {
  value: 'Singapore',
  label: 'Singapore'
}, {
  value: 'Slovakia',
  label: 'Slovakia'
}, {
  value: 'Slovenia',
  label: 'Slovenia'
}, {
  value: 'Solomon Islands',
  label: 'Solomon Islands'
}, {
  value: 'Somalia',
  label: 'Somalia'
}, {
  value: 'South Africa',
  label: 'South Africa'
}, {
  value: 'South Korea',
  label: 'South Korea'
}, {
  value: 'Spain',
  label: 'Spain'
}, {
  value: 'Sri Lanka',
  label: 'Sri Lanka'
}, {
  value: 'St Vincent & Grenadines',
  label: 'St Vincent & Grenadines'
}, {
  value: 'Suriname',
  label: 'Suriname'
}, {
  value: 'Sweden',
  label: 'Sweden'
}, {
  value: 'Switzerland',
  label: 'Switzerland'
}, {
  value: 'Taiwan',
  label: 'Taiwan'
}, {
  value: 'Tajikistan',
  label: 'Tajikistan'
}, {
  value: 'Tanzania',
  label: 'Tanzania'
}, {
  value: 'Thailand',
  label: 'Thailand'
}, {
  value: 'Timor-Leste',
  label: 'Timor-Leste'
}, {
  value: 'Togo',
  label: 'Togo'
}, {
  value: 'Tokelau',
  label: 'Tokelau'
}, {
  value: 'Tonga',
  label: 'Tonga'
}, {
  value: 'Trinidad & Tobago',
  label: 'Trinidad & Tobago'
}, {
  value: 'Tunisia',
  label: 'Tunisia'
}, {
  value: 'Turkey',
  label: 'Turkey'
}, {
  value: 'Turkmenistan',
  label: 'Turkmenistan'
}, {
  value: 'Uganda',
  label: 'Uganda'
}, {
  value: 'Ukraine',
  label: 'Ukraine'
}, {
  value: 'United Arab Emirates',
  label: 'United Arab Emirates'
}, {
  value: 'United Kingdom',
  label: 'United Kingdom'
}, {
  value: 'United States',
  label: 'United States'
}, {
  value: 'Uruguay',
  label: 'Uruguay'
}, {
  value: 'Uzbekistan',
  label: 'Uzbekistan'
}, {
  value: 'Vanuatu',
  label: 'Vanuatu'
}, {
  value: 'Venezuela',
  label: 'Venezuela'
}, {
  value: 'Vietnam',
  label: 'Vietnam'
}, {
  value: 'Virgin Islands (US)',
  label: 'Virgin Islands (US)'
}, {
  value: 'Zambia',
  label: 'Zambia'
}, {
  value: 'Zimbabwe',
  label: 'Zimbabwe'
}];
const httpMethodOptions = [{
  label: 'Get Request',
  value: 'GET'
}, {
  label: 'Post Request',
  value: 'POST'
}];
const jsRenderingOptions = [{
  label: 'JS rendering',
  value: 'html'
}, {
  label: 'No JS rendering',
  value: ''
}];

const MIN_IG_GQL_QUERY_COUNT = 12;
const MAX_IG_GQL_QUERY_COUNT = 50;
const MIN_PAGE_NUM = 0;
const MAX_PAGE_NUM = 100;
const PARAM_GROUPS = {
  PRIMARY: 'primary',
  REGULAR: 'regular',
  PAGINATION: 'pagination',
  TARGET_SPECIFIC: 'target_specific',
  OTHER: 'other'
};
var INPUT_TYPES;
(function (INPUT_TYPES) {
  INPUT_TYPES["PASSWORD"] = "password";
  INPUT_TYPES["TEXT"] = "text";
  INPUT_TYPES["NUMBER"] = "number";
  INPUT_TYPES["SELECT"] = "select";
  INPUT_TYPES["TOGGLE"] = "toggle";
  INPUT_TYPES["HEADERS"] = "headers";
})(INPUT_TYPES || (INPUT_TYPES = {}));
const SCRAPER_REQUEST_PARAM_GROUPS = {
  [PARAM_GROUPS.PRIMARY]: {
    URL: 'url',
    QUERY: 'query'
  },
  [PARAM_GROUPS.REGULAR]: {
    DOMAIN: 'domain',
    DEVICE_TYPE: 'device_type',
    LOCALE: 'locale',
    GEO: 'geo',
    GEO_CODE: 'geo_code',
    GEO_CODE_SELECT: 'geo_code_select',
    CATEGORY: 'category',
    SEARCH_TYPE: 'search_type',
    CURSOR: 'cursor',
    RESULTS: 'results',
    HEADERS: 'headers'
  },
  [PARAM_GROUPS.PAGINATION]: {
    NUM_PAGES: 'num_pages',
    PAGE_FROM: 'page_from',
    GUESTS: 'guests'
  },
  [PARAM_GROUPS.TARGET_SPECIFIC]: {
    GOOGLE_RESULTS_LANGUAGE: 'google_results_language',
    GOOGLE_TBM: 'google_tbm',
    GOOGLE_TBS: 'google_tbs',
    DATE_RANGE: 'date_range',
    HOTEL_OCCUPANCY: 'hotel_occupancy',
    STARS: 'stars',
    HOTEL_CLASSES: 'hotel_classes',
    DATE_START: 'date_start',
    DATE_END: 'date_end',
    MERCHANT: 'merchant',
    AMAZON_CATEGORY_ID: 'amazon_category_id',
    TIKTOK_TIMESTAMP: 'timestamp',
    TIKTOK_HASHTAG_ID: 'hashtag_id',
    HTTP_METHOD: 'httpMethod',
    CUSTOM_STATUS_CODE: 'customStatusCode',
    CUSTOM_COOKIES: 'customCookies',
    REQUEST_BODY: 'requestBody',
    SESSION_ID: 'sessionId',
    IG_GRAPHQL_COUNT: 'ig_graphql_count',
    IG_GRAPHQL_CURSOR: 'ig_graphql_cursor',
    TIKTOK_API_COUNT: 'count'
  },
  [PARAM_GROUPS.OTHER]: {
    PARSE: 'parse',
    HEADLESS: 'headless',
    GOOGLE_NFPR: 'google_nfpr',
    GOOGLE_SAFE_SEARCH: 'google_safe_search',
    AUTOSELECT_VARIANT: 'autoselect_variant',
    PARSER_TYPE: 'parser_type'
  }
};
const SCRAPER_REQUEST_PARAMS = {
  ...SCRAPER_REQUEST_PARAM_GROUPS[PARAM_GROUPS.PRIMARY],
  ...SCRAPER_REQUEST_PARAM_GROUPS[PARAM_GROUPS.REGULAR],
  ...SCRAPER_REQUEST_PARAM_GROUPS[PARAM_GROUPS.PAGINATION],
  ...SCRAPER_REQUEST_PARAM_GROUPS[PARAM_GROUPS.TARGET_SPECIFIC],
  ...SCRAPER_REQUEST_PARAM_GROUPS[PARAM_GROUPS.OTHER]
};
const paramsConfig = {
  [SCRAPER_REQUEST_PARAMS.URL]: {
    key: SCRAPER_REQUEST_PARAMS.URL,
    header: 'Search URL',
    type: INPUT_TYPES.TEXT,
    group: PARAM_GROUPS.PRIMARY
  },
  [SCRAPER_REQUEST_PARAMS.QUERY]: {
    key: SCRAPER_REQUEST_PARAMS.QUERY,
    header: 'Search query',
    type: INPUT_TYPES.TEXT,
    group: PARAM_GROUPS.PRIMARY
  },
  [SCRAPER_REQUEST_PARAMS.DOMAIN]: {
    key: SCRAPER_REQUEST_PARAMS.DOMAIN,
    header: 'Website domain',
    options: playgroundDomainOptions,
    type: INPUT_TYPES.SELECT,
    group: PARAM_GROUPS.REGULAR
  },
  [SCRAPER_REQUEST_PARAMS.LOCALE]: {
    key: SCRAPER_REQUEST_PARAMS.LOCALE,
    header: 'Language',
    options: languageOptions,
    type: INPUT_TYPES.SELECT,
    group: PARAM_GROUPS.REGULAR,
    description: 'Changes the web page interface language, not the language of the results'
  },
  [SCRAPER_REQUEST_PARAMS.GEO]: {
    key: SCRAPER_REQUEST_PARAMS.GEO,
    header: 'Location',
    options: locationOptions,
    type: INPUT_TYPES.SELECT,
    group: PARAM_GROUPS.REGULAR
  },
  [SCRAPER_REQUEST_PARAMS.GEO_CODE]: {
    key: SCRAPER_REQUEST_PARAMS.GEO,
    header: 'Location',
    type: INPUT_TYPES.TEXT,
    group: PARAM_GROUPS.REGULAR,
    description: 'ZIP Code, e.g. 10001'
  },
  [SCRAPER_REQUEST_PARAMS.GEO_CODE_SELECT]: {
    key: SCRAPER_REQUEST_PARAMS.GEO,
    header: 'Location',
    options: geoCodeOptions,
    type: INPUT_TYPES.SELECT,
    group: PARAM_GROUPS.REGULAR,
    description: 'The geographical location that the results depends on'
  },
  [SCRAPER_REQUEST_PARAMS.TIKTOK_API_COUNT]: {
    key: SCRAPER_REQUEST_PARAMS.TIKTOK_API_COUNT,
    header: 'Count',
    min: 1,
    max: 35,
    type: INPUT_TYPES.NUMBER,
    group: PARAM_GROUPS.TARGET_SPECIFIC
  },
  [SCRAPER_REQUEST_PARAMS.IG_GRAPHQL_COUNT]: {
    key: SCRAPER_REQUEST_PARAMS.IG_GRAPHQL_COUNT,
    header: 'Count',
    min: MIN_IG_GQL_QUERY_COUNT,
    max: MAX_IG_GQL_QUERY_COUNT,
    type: INPUT_TYPES.NUMBER,
    group: PARAM_GROUPS.REGULAR
  },
  [SCRAPER_REQUEST_PARAMS.IG_GRAPHQL_CURSOR]: {
    key: SCRAPER_REQUEST_PARAMS.IG_GRAPHQL_CURSOR,
    header: 'Cursor',
    type: INPUT_TYPES.TEXT,
    group: PARAM_GROUPS.REGULAR,
    description: 'String used for pagination. See documentation on how to use'
  },
  [SCRAPER_REQUEST_PARAMS.CURSOR]: {
    key: SCRAPER_REQUEST_PARAMS.CURSOR,
    header: 'Cursor',
    min: 0,
    type: INPUT_TYPES.NUMBER,
    group: PARAM_GROUPS.REGULAR,
    description: 'Number for indicating how offset the results should be'
  },
  [SCRAPER_REQUEST_PARAMS.DEVICE_TYPE]: {
    key: SCRAPER_REQUEST_PARAMS.DEVICE_TYPE,
    header: 'Device type and browser',
    options: deviceOptions,
    type: INPUT_TYPES.SELECT,
    group: PARAM_GROUPS.REGULAR
  },
  [SCRAPER_REQUEST_PARAMS.PAGE_FROM]: {
    key: SCRAPER_REQUEST_PARAMS.PAGE_FROM,
    header: 'Starting page number',
    min: MIN_PAGE_NUM,
    max: MAX_PAGE_NUM,
    type: INPUT_TYPES.NUMBER,
    group: PARAM_GROUPS.PAGINATION
  },
  [SCRAPER_REQUEST_PARAMS.NUM_PAGES]: {
    key: SCRAPER_REQUEST_PARAMS.NUM_PAGES,
    header: 'Page number',
    min: MIN_PAGE_NUM,
    max: MAX_PAGE_NUM,
    type: INPUT_TYPES.NUMBER,
    group: PARAM_GROUPS.PAGINATION,
    description: 'Retrieve a specific number of results in a page'
  },
  [SCRAPER_REQUEST_PARAMS.RESULTS]: {
    key: SCRAPER_REQUEST_PARAMS.RESULTS,
    header: 'Number of results',
    min: 1,
    type: INPUT_TYPES.NUMBER,
    group: PARAM_GROUPS.REGULAR
  },
  [SCRAPER_REQUEST_PARAMS.GOOGLE_TBM]: {
    key: SCRAPER_REQUEST_PARAMS.GOOGLE_TBM,
    header: 'Tbm',
    options: tbmOptions,
    type: INPUT_TYPES.SELECT,
    group: PARAM_GROUPS.TARGET_SPECIFIC,
    description: 'Filter Google Search results for specific content types'
  },
  [SCRAPER_REQUEST_PARAMS.GOOGLE_TBS]: {
    key: SCRAPER_REQUEST_PARAMS.GOOGLE_TBS,
    header: 'Tbs',
    type: INPUT_TYPES.TEXT,
    group: PARAM_GROUPS.TARGET_SPECIFIC,
    description: 'This parameter contains parameters, like limiting/sorting results by date'
  },
  [SCRAPER_REQUEST_PARAMS.GOOGLE_RESULTS_LANGUAGE]: {
    key: SCRAPER_REQUEST_PARAMS.GOOGLE_RESULTS_LANGUAGE,
    header: 'Results language',
    options: resultLocaleOptions,
    type: INPUT_TYPES.SELECT,
    group: PARAM_GROUPS.TARGET_SPECIFIC
  },
  [SCRAPER_REQUEST_PARAMS.STARS]: {
    key: SCRAPER_REQUEST_PARAMS.STARS,
    header: 'Rating',
    options: ratingOptions,
    type: INPUT_TYPES.SELECT,
    group: PARAM_GROUPS.TARGET_SPECIFIC
  },
  [SCRAPER_REQUEST_PARAMS.PARSE]: {
    key: SCRAPER_REQUEST_PARAMS.PARSE,
    header: 'Parse',
    type: INPUT_TYPES.TOGGLE,
    group: PARAM_GROUPS.OTHER
  },
  [SCRAPER_REQUEST_PARAMS.HEADLESS]: {
    key: SCRAPER_REQUEST_PARAMS.HEADLESS,
    header: 'JS Rendering',
    options: jsRenderingOptions,
    type: INPUT_TYPES.SELECT,
    group: PARAM_GROUPS.OTHER
  },
  [SCRAPER_REQUEST_PARAMS.GOOGLE_NFPR]: {
    key: SCRAPER_REQUEST_PARAMS.GOOGLE_NFPR,
    header: 'Autocorrection',
    type: INPUT_TYPES.TOGGLE,
    group: PARAM_GROUPS.OTHER
  },
  [SCRAPER_REQUEST_PARAMS.GOOGLE_SAFE_SEARCH]: {
    key: SCRAPER_REQUEST_PARAMS.GOOGLE_SAFE_SEARCH,
    header: 'Safe search',
    type: INPUT_TYPES.TOGGLE,
    group: PARAM_GROUPS.OTHER,
    description: 'Safe search to hide explicit result content'
  },
  [SCRAPER_REQUEST_PARAMS.PARSER_TYPE]: {
    key: SCRAPER_REQUEST_PARAMS.PARSER_TYPE,
    header: 'Parser type',
    options: parserTypeOptions,
    type: INPUT_TYPES.SELECT,
    group: PARAM_GROUPS.OTHER
  },
  [SCRAPER_REQUEST_PARAMS.DATE_START]: {
    key: SCRAPER_REQUEST_PARAMS.DATE_START,
    header: 'Start date',
    type: INPUT_TYPES.TEXT,
    group: PARAM_GROUPS.TARGET_SPECIFIC
  },
  [SCRAPER_REQUEST_PARAMS.DATE_END]: {
    key: SCRAPER_REQUEST_PARAMS.DATE_END,
    header: 'End date',
    type: INPUT_TYPES.TEXT,
    group: PARAM_GROUPS.TARGET_SPECIFIC
  },
  [SCRAPER_REQUEST_PARAMS.CATEGORY]: {
    key: SCRAPER_REQUEST_PARAMS.CATEGORY,
    header: 'Category ID',
    options: categoryOptions,
    type: INPUT_TYPES.SELECT,
    group: PARAM_GROUPS.REGULAR
  },
  [SCRAPER_REQUEST_PARAMS.SEARCH_TYPE]: {
    key: SCRAPER_REQUEST_PARAMS.SEARCH_TYPE,
    header: 'Search type',
    options: searchTypeOptions,
    type: INPUT_TYPES.SELECT,
    group: PARAM_GROUPS.REGULAR
  },
  [SCRAPER_REQUEST_PARAMS.DATE_RANGE]: {
    key: SCRAPER_REQUEST_PARAMS.DATE_RANGE,
    header: 'Date range',
    type: INPUT_TYPES.TEXT,
    group: PARAM_GROUPS.TARGET_SPECIFIC
  },
  [SCRAPER_REQUEST_PARAMS.GUESTS]: {
    key: SCRAPER_REQUEST_PARAMS.GUESTS,
    header: 'Search URL',
    type: INPUT_TYPES.TEXT,
    group: PARAM_GROUPS.TARGET_SPECIFIC
  },
  [SCRAPER_REQUEST_PARAMS.HOTEL_OCCUPANCY]: {
    key: SCRAPER_REQUEST_PARAMS.HOTEL_OCCUPANCY,
    header: 'Hotel occupancy',
    type: INPUT_TYPES.TEXT,
    group: PARAM_GROUPS.TARGET_SPECIFIC
  },
  [SCRAPER_REQUEST_PARAMS.HOTEL_CLASSES]: {
    key: SCRAPER_REQUEST_PARAMS.HOTEL_CLASSES,
    header: 'Hotel classes',
    type: INPUT_TYPES.TEXT,
    group: PARAM_GROUPS.TARGET_SPECIFIC
  },
  [SCRAPER_REQUEST_PARAMS.AUTOSELECT_VARIANT]: {
    key: SCRAPER_REQUEST_PARAMS.AUTOSELECT_VARIANT,
    header: 'Autoselect',
    type: INPUT_TYPES.TOGGLE,
    group: PARAM_GROUPS.OTHER
  },
  [SCRAPER_REQUEST_PARAMS.MERCHANT]: {
    key: SCRAPER_REQUEST_PARAMS.MERCHANT,
    header: 'Merchant ID',
    type: INPUT_TYPES.TEXT,
    group: PARAM_GROUPS.TARGET_SPECIFIC
  },
  [SCRAPER_REQUEST_PARAMS.AMAZON_CATEGORY_ID]: {
    key: SCRAPER_REQUEST_PARAMS.CATEGORY,
    header: 'Category ID',
    type: INPUT_TYPES.TEXT,
    group: PARAM_GROUPS.TARGET_SPECIFIC
  },
  [SCRAPER_REQUEST_PARAMS.TIKTOK_HASHTAG_ID]: {
    key: SCRAPER_REQUEST_PARAMS.TIKTOK_HASHTAG_ID,
    header: 'Hashtag ID',
    type: INPUT_TYPES.TEXT,
    group: PARAM_GROUPS.TARGET_SPECIFIC,
    description: 'Use as a fallback if query does not work, see documentation',
    link: `${globalDocs}/tiktok#query-fallback`
  },
  [SCRAPER_REQUEST_PARAMS.TIKTOK_TIMESTAMP]: {
    key: SCRAPER_REQUEST_PARAMS.TIKTOK_TIMESTAMP,
    header: 'Timestamp',
    type: INPUT_TYPES.TEXT,
    group: PARAM_GROUPS.TARGET_SPECIFIC,
    description: 'Used for pagination, see documentation',
    link: `${globalDocs}/tiktok#extracting-more-profile-results`
  },
  [SCRAPER_REQUEST_PARAMS.HEADERS]: {
    key: SCRAPER_REQUEST_PARAMS.HEADERS,
    header: 'Headers',
    type: INPUT_TYPES.HEADERS,
    group: PARAM_GROUPS.REGULAR
  },
  [SCRAPER_REQUEST_PARAMS.HTTP_METHOD]: {
    key: SCRAPER_REQUEST_PARAMS.HTTP_METHOD,
    header: 'HTTP method',
    type: INPUT_TYPES.SELECT,
    options: httpMethodOptions,
    group: PARAM_GROUPS.REGULAR
  },
  [SCRAPER_REQUEST_PARAMS.CUSTOM_STATUS_CODE]: {
    key: SCRAPER_REQUEST_PARAMS.CUSTOM_STATUS_CODE,
    header: 'Custom status code',
    type: INPUT_TYPES.TEXT,
    group: PARAM_GROUPS.REGULAR,
    description: 'Add the header with all the HTTP response codes that work for you: 501, 502, 503 and etc.'
  },
  [SCRAPER_REQUEST_PARAMS.CUSTOM_COOKIES]: {
    key: SCRAPER_REQUEST_PARAMS.CUSTOM_COOKIES,
    header: 'Custom cookies',
    type: INPUT_TYPES.TEXT,
    group: PARAM_GROUPS.REGULAR,
    description: 'Example: NID=1234567890'
  },
  [SCRAPER_REQUEST_PARAMS.SESSION_ID]: {
    key: SCRAPER_REQUEST_PARAMS.SESSION_ID,
    header: 'Session ID',
    type: INPUT_TYPES.TEXT,
    group: PARAM_GROUPS.REGULAR,
    description: 'You may give any name to a session'
  },
  [SCRAPER_REQUEST_PARAMS.REQUEST_BODY]: {
    key: SCRAPER_REQUEST_PARAMS.REQUEST_BODY,
    header: 'Request body',
    type: INPUT_TYPES.TEXT,
    group: PARAM_GROUPS.REGULAR
  }
};

var TARGET;
(function (TARGET) {
  // Oxy targets
  TARGET["UNIVERSAL_ECOMMERCE"] = "universal_ecommerce";
  // SERP
  TARGET["GOOGLE_SEARCH"] = "google_search";
  TARGET["GOOGLE_HOTELS"] = "google_hotels";
  TARGET["GOOGLE_TRAVEL_HOTELS"] = "google_travel_hotels";
  TARGET["GOOGLE_TRENDS_EXPLORE"] = "google_trends_explore";
  TARGET["GOOGLE_SHOPPING_SEARCH"] = "google_shopping_search";
  TARGET["GOOGLE_SHOPPING_PRODUCT"] = "google_shopping_product";
  TARGET["GOOGLE_SHOPPING_PRICING"] = "google_shopping_pricing";
  TARGET["GOOGLE"] = "google";
  TARGET["GOOGLE_IMAGES"] = "google_images";
  TARGET["GOOGLE_SUGGEST"] = "google_suggest";
  TARGET["GOOGLE_MAPS"] = "google_maps";
  TARGET["GOOGLE_ADS"] = "google_ads";
  TARGET["GOOGLE_LENS"] = "google_lens";
  TARGET["BING_SEARCH"] = "bing_search";
  TARGET["BING"] = "bing";
  // eCommerce
  TARGET["AMAZON_PRODUCT"] = "amazon_product";
  TARGET["AMAZON_PRICING"] = "amazon_pricing";
  TARGET["AMAZON_REVIEWS"] = "amazon_reviews";
  TARGET["AMAZON_QUESTIONS"] = "amazon_questions";
  TARGET["AMAZON_SEARCH"] = "amazon_search";
  TARGET["AMAZON_SELLERS"] = "amazon_sellers";
  TARGET["AMAZON_BESTSELLERS"] = "amazon_bestsellers";
  TARGET["AMAZON"] = "amazon";
  TARGET["ECOMMERCE"] = "ecommerce";
  // Web
  TARGET["UNIVERSAL"] = "universal";
  // Social media
  TARGET["INSTAGRAM_GRAPHQL_POST"] = "instagram_graphql_post";
  TARGET["INSTAGRAM_GRAPHQL_PROFILE"] = "instagram_graphql_profile";
  TARGET["INSTAGRAM_GRAPHQL_REEL"] = "instagram_graphql_reel";
  TARGET["INSTAGRAM_GRAPHQL_HASHTAG"] = "instagram_graphql_hashtag";
  TARGET["INSTAGRAM_GRAPHQL_USER_POSTS"] = "instagram_graphql_user_posts";
  TARGET["INSTAGRAM_GRAPHQL_USER_FOLLOWING"] = "instagram_graphql_user_following";
  TARGET["INSTAGRAM_GRAPHQL_USER_FOLLOWERS"] = "instagram_graphql_user_followers";
  TARGET["INSTAGRAM_GRAPHQL_HASHTAGS"] = "instagram_graphql_hashtags";
  TARGET["TIKTOK_PROFILE"] = "tiktok_profile";
  TARGET["TIKTOK_POST"] = "tiktok_post";
  TARGET["TIKTOK_API_PROFILE"] = "tiktok_api_profile";
  TARGET["TIKTOK_API_HASHTAG"] = "tiktok_api_hashtag";
  TARGET["REDDIT_POST"] = "reddit_post";
  TARGET["REDDIT_SUBREDDIT"] = "reddit_subreddit";
  TARGET["REDDIT_USER"] = "reddit_user";
  // Site unblockers
  TARGET["SITE_UNBLOCKER"] = "site_unblocker";
  TARGET["SITE_UNBLOCKER_REQ"] = "site_unblocker_req";
})(TARGET || (TARGET = {}));
const ProductTargets = {
  [PROXY_TYPE.SERP]: [TARGET.GOOGLE, TARGET.GOOGLE_SEARCH, TARGET.GOOGLE_HOTELS, TARGET.GOOGLE_TRAVEL_HOTELS, TARGET.GOOGLE_TRENDS_EXPLORE, TARGET.GOOGLE_SHOPPING_SEARCH, TARGET.GOOGLE_SHOPPING_PRODUCT, TARGET.GOOGLE_SHOPPING_PRICING, TARGET.GOOGLE_IMAGES, TARGET.GOOGLE_SUGGEST, TARGET.GOOGLE_ADS, TARGET.GOOGLE_MAPS, TARGET.GOOGLE_LENS, TARGET.BING_SEARCH, TARGET.BING],
  [PROXY_TYPE.ECOMMERCE]: [TARGET.AMAZON_PRODUCT, TARGET.AMAZON_PRICING, TARGET.AMAZON_REVIEWS, TARGET.AMAZON_QUESTIONS, TARGET.AMAZON_SEARCH, TARGET.AMAZON_SELLERS, TARGET.AMAZON_BESTSELLERS, TARGET.AMAZON, TARGET.ECOMMERCE],
  [PROXY_TYPE.UNIVERSAL]: [TARGET.UNIVERSAL],
  [PROXY_TYPE.SOCIAL_MEDIA]: [TARGET.INSTAGRAM_GRAPHQL_POST, TARGET.INSTAGRAM_GRAPHQL_PROFILE, TARGET.INSTAGRAM_GRAPHQL_REEL, TARGET.INSTAGRAM_GRAPHQL_HASHTAG, TARGET.INSTAGRAM_GRAPHQL_USER_POSTS, TARGET.INSTAGRAM_GRAPHQL_USER_FOLLOWING, TARGET.INSTAGRAM_GRAPHQL_USER_FOLLOWERS, TARGET.INSTAGRAM_GRAPHQL_HASHTAGS, TARGET.TIKTOK_PROFILE, TARGET.TIKTOK_POST, TARGET.TIKTOK_API_PROFILE, TARGET.TIKTOK_API_HASHTAG, TARGET.REDDIT_POST, TARGET.REDDIT_SUBREDDIT, TARGET.REDDIT_USER],
  [PROXY_TYPE.SITE_UNBLOCKER]: [TARGET.SITE_UNBLOCKER],
  [PROXY_TYPE.SITE_UNBLOCKER_REQ]: [TARGET.SITE_UNBLOCKER_REQ]
};
const PARAMETER_DEFAULT_VALUES = {
  DEFAULT_LOCALE_EN: 'en',
  DEFAULT_GEO_US: '',
  DEFAULT_DOMAIN_COM: '',
  DEFAULT_DEVICE_DESKTOP: 'desktop',
  DEFAULT_PAGE_FROM: 1,
  DEFAULT_NUM_PAGES: 10,
  DEFAULT_NFPR: true,
  DEFAULT_QUERY: ['pizza']
};
const targetParamMap = {
  [TARGET.GOOGLE_HOTELS]: [],
  [TARGET.UNIVERSAL_ECOMMERCE]: [],
  [TARGET.GOOGLE_IMAGES]: [paramsConfig[SCRAPER_REQUEST_PARAMS.QUERY], paramsConfig[SCRAPER_REQUEST_PARAMS.LOCALE], paramsConfig[SCRAPER_REQUEST_PARAMS.GEO], paramsConfig[SCRAPER_REQUEST_PARAMS.DOMAIN], paramsConfig[SCRAPER_REQUEST_PARAMS.DEVICE_TYPE], paramsConfig[SCRAPER_REQUEST_PARAMS.PAGE_FROM], paramsConfig[SCRAPER_REQUEST_PARAMS.NUM_PAGES], paramsConfig[SCRAPER_REQUEST_PARAMS.GOOGLE_RESULTS_LANGUAGE], paramsConfig[SCRAPER_REQUEST_PARAMS.GOOGLE_NFPR]],
  [TARGET.GOOGLE]: [paramsConfig[SCRAPER_REQUEST_PARAMS.URL], paramsConfig[SCRAPER_REQUEST_PARAMS.LOCALE], paramsConfig[SCRAPER_REQUEST_PARAMS.GEO], paramsConfig[SCRAPER_REQUEST_PARAMS.DEVICE_TYPE], paramsConfig[SCRAPER_REQUEST_PARAMS.PARSE]],
  [TARGET.GOOGLE_SHOPPING_PRICING]: [paramsConfig[SCRAPER_REQUEST_PARAMS.QUERY], paramsConfig[SCRAPER_REQUEST_PARAMS.LOCALE], paramsConfig[SCRAPER_REQUEST_PARAMS.GEO], paramsConfig[SCRAPER_REQUEST_PARAMS.DEVICE_TYPE], paramsConfig[SCRAPER_REQUEST_PARAMS.DOMAIN], paramsConfig[SCRAPER_REQUEST_PARAMS.PAGE_FROM], paramsConfig[SCRAPER_REQUEST_PARAMS.NUM_PAGES], paramsConfig[SCRAPER_REQUEST_PARAMS.PARSE]],
  [TARGET.GOOGLE_SHOPPING_PRODUCT]: [paramsConfig[SCRAPER_REQUEST_PARAMS.QUERY], paramsConfig[SCRAPER_REQUEST_PARAMS.LOCALE], paramsConfig[SCRAPER_REQUEST_PARAMS.GEO], paramsConfig[SCRAPER_REQUEST_PARAMS.DOMAIN], paramsConfig[SCRAPER_REQUEST_PARAMS.DEVICE_TYPE], paramsConfig[SCRAPER_REQUEST_PARAMS.PAGE_FROM], paramsConfig[SCRAPER_REQUEST_PARAMS.NUM_PAGES], paramsConfig[SCRAPER_REQUEST_PARAMS.PARSE]],
  [TARGET.GOOGLE_SEARCH]: [paramsConfig[SCRAPER_REQUEST_PARAMS.QUERY], paramsConfig[SCRAPER_REQUEST_PARAMS.LOCALE], paramsConfig[SCRAPER_REQUEST_PARAMS.GEO], paramsConfig[SCRAPER_REQUEST_PARAMS.DEVICE_TYPE], paramsConfig[SCRAPER_REQUEST_PARAMS.DOMAIN], paramsConfig[SCRAPER_REQUEST_PARAMS.PAGE_FROM], paramsConfig[SCRAPER_REQUEST_PARAMS.NUM_PAGES], paramsConfig[SCRAPER_REQUEST_PARAMS.GOOGLE_RESULTS_LANGUAGE], paramsConfig[SCRAPER_REQUEST_PARAMS.GOOGLE_TBM], paramsConfig[SCRAPER_REQUEST_PARAMS.GOOGLE_TBS], paramsConfig[SCRAPER_REQUEST_PARAMS.PARSE], paramsConfig[SCRAPER_REQUEST_PARAMS.GOOGLE_NFPR], paramsConfig[SCRAPER_REQUEST_PARAMS.GOOGLE_SAFE_SEARCH]],
  [TARGET.GOOGLE_TRAVEL_HOTELS]: [paramsConfig[SCRAPER_REQUEST_PARAMS.QUERY], paramsConfig[SCRAPER_REQUEST_PARAMS.LOCALE],
  // https://developers.oxylabs.io/scraper-apis/serp-scraper-api/google#google-travel-hotels-unaccepted-values
  // paramsConfig[SCRAPER_REQUEST_PARAMS.GEO],
  paramsConfig[SCRAPER_REQUEST_PARAMS.DOMAIN], paramsConfig[SCRAPER_REQUEST_PARAMS.DEVICE_TYPE], paramsConfig[SCRAPER_REQUEST_PARAMS.PAGE_FROM], paramsConfig[SCRAPER_REQUEST_PARAMS.NUM_PAGES], paramsConfig[SCRAPER_REQUEST_PARAMS.STARS], paramsConfig[SCRAPER_REQUEST_PARAMS.DATE_RANGE], paramsConfig[SCRAPER_REQUEST_PARAMS.HOTEL_OCCUPANCY], paramsConfig[SCRAPER_REQUEST_PARAMS.HOTEL_CLASSES]],
  [TARGET.GOOGLE_TRENDS_EXPLORE]: [paramsConfig[SCRAPER_REQUEST_PARAMS.QUERY], paramsConfig[SCRAPER_REQUEST_PARAMS.GEO], paramsConfig[SCRAPER_REQUEST_PARAMS.DEVICE_TYPE], paramsConfig[SCRAPER_REQUEST_PARAMS.SEARCH_TYPE], paramsConfig[SCRAPER_REQUEST_PARAMS.DATE_START], paramsConfig[SCRAPER_REQUEST_PARAMS.DATE_END]],
  [TARGET.GOOGLE_SHOPPING_SEARCH]: [paramsConfig[SCRAPER_REQUEST_PARAMS.QUERY], paramsConfig[SCRAPER_REQUEST_PARAMS.LOCALE], paramsConfig[SCRAPER_REQUEST_PARAMS.GEO], paramsConfig[SCRAPER_REQUEST_PARAMS.DOMAIN], paramsConfig[SCRAPER_REQUEST_PARAMS.DEVICE_TYPE], paramsConfig[SCRAPER_REQUEST_PARAMS.PAGE_FROM], paramsConfig[SCRAPER_REQUEST_PARAMS.NUM_PAGES], paramsConfig[SCRAPER_REQUEST_PARAMS.GOOGLE_TBS], paramsConfig[SCRAPER_REQUEST_PARAMS.PARSE]],
  [TARGET.GOOGLE_SUGGEST]: [paramsConfig[SCRAPER_REQUEST_PARAMS.QUERY], paramsConfig[SCRAPER_REQUEST_PARAMS.DEVICE_TYPE]],
  [TARGET.GOOGLE_ADS]: [paramsConfig[SCRAPER_REQUEST_PARAMS.QUERY], paramsConfig[SCRAPER_REQUEST_PARAMS.LOCALE], paramsConfig[SCRAPER_REQUEST_PARAMS.GEO], paramsConfig[SCRAPER_REQUEST_PARAMS.DOMAIN], paramsConfig[SCRAPER_REQUEST_PARAMS.DEVICE_TYPE], paramsConfig[SCRAPER_REQUEST_PARAMS.PAGE_FROM], paramsConfig[SCRAPER_REQUEST_PARAMS.NUM_PAGES], paramsConfig[SCRAPER_REQUEST_PARAMS.GOOGLE_RESULTS_LANGUAGE], paramsConfig[SCRAPER_REQUEST_PARAMS.GOOGLE_TBM], paramsConfig[SCRAPER_REQUEST_PARAMS.GOOGLE_TBS], paramsConfig[SCRAPER_REQUEST_PARAMS.PARSE], paramsConfig[SCRAPER_REQUEST_PARAMS.GOOGLE_NFPR]],
  [TARGET.GOOGLE_MAPS]: [paramsConfig[SCRAPER_REQUEST_PARAMS.QUERY], paramsConfig[SCRAPER_REQUEST_PARAMS.GEO], paramsConfig[SCRAPER_REQUEST_PARAMS.LOCALE], paramsConfig[SCRAPER_REQUEST_PARAMS.DOMAIN], paramsConfig[SCRAPER_REQUEST_PARAMS.PAGE_FROM], paramsConfig[SCRAPER_REQUEST_PARAMS.NUM_PAGES], paramsConfig[SCRAPER_REQUEST_PARAMS.DEVICE_TYPE], paramsConfig[SCRAPER_REQUEST_PARAMS.HEADLESS], paramsConfig[SCRAPER_REQUEST_PARAMS.GOOGLE_RESULTS_LANGUAGE], paramsConfig[SCRAPER_REQUEST_PARAMS.GOOGLE_NFPR], paramsConfig[SCRAPER_REQUEST_PARAMS.HOTEL_OCCUPANCY], paramsConfig[SCRAPER_REQUEST_PARAMS.DATE_RANGE]],
  [TARGET.GOOGLE_LENS]: [paramsConfig[SCRAPER_REQUEST_PARAMS.QUERY], paramsConfig[SCRAPER_REQUEST_PARAMS.HEADLESS], paramsConfig[SCRAPER_REQUEST_PARAMS.PARSE], paramsConfig[SCRAPER_REQUEST_PARAMS.DEVICE_TYPE]],
  [TARGET.BING]: [paramsConfig[SCRAPER_REQUEST_PARAMS.URL], paramsConfig[SCRAPER_REQUEST_PARAMS.LOCALE], paramsConfig[SCRAPER_REQUEST_PARAMS.GEO], paramsConfig[SCRAPER_REQUEST_PARAMS.DEVICE_TYPE], paramsConfig[SCRAPER_REQUEST_PARAMS.PAGE_FROM], paramsConfig[SCRAPER_REQUEST_PARAMS.NUM_PAGES], paramsConfig[SCRAPER_REQUEST_PARAMS.PARSE]],
  [TARGET.BING_SEARCH]: [paramsConfig[SCRAPER_REQUEST_PARAMS.QUERY], paramsConfig[SCRAPER_REQUEST_PARAMS.LOCALE], paramsConfig[SCRAPER_REQUEST_PARAMS.GEO], paramsConfig[SCRAPER_REQUEST_PARAMS.DOMAIN], paramsConfig[SCRAPER_REQUEST_PARAMS.DEVICE_TYPE], paramsConfig[SCRAPER_REQUEST_PARAMS.PAGE_FROM], paramsConfig[SCRAPER_REQUEST_PARAMS.NUM_PAGES], paramsConfig[SCRAPER_REQUEST_PARAMS.PARSE]],
  [TARGET.UNIVERSAL]: [paramsConfig[SCRAPER_REQUEST_PARAMS.URL], paramsConfig[SCRAPER_REQUEST_PARAMS.LOCALE], paramsConfig[SCRAPER_REQUEST_PARAMS.GEO], paramsConfig[SCRAPER_REQUEST_PARAMS.DEVICE_TYPE], paramsConfig[SCRAPER_REQUEST_PARAMS.HEADLESS]],
  [TARGET.AMAZON]: [paramsConfig[SCRAPER_REQUEST_PARAMS.URL], paramsConfig[SCRAPER_REQUEST_PARAMS.DEVICE_TYPE], paramsConfig[SCRAPER_REQUEST_PARAMS.PARSE]],
  [TARGET.AMAZON_PRODUCT]: [paramsConfig[SCRAPER_REQUEST_PARAMS.QUERY], paramsConfig[SCRAPER_REQUEST_PARAMS.DOMAIN], paramsConfig[SCRAPER_REQUEST_PARAMS.DEVICE_TYPE], paramsConfig[SCRAPER_REQUEST_PARAMS.PARSE], paramsConfig[SCRAPER_REQUEST_PARAMS.AUTOSELECT_VARIANT]],
  [TARGET.AMAZON_PRICING]: [paramsConfig[SCRAPER_REQUEST_PARAMS.QUERY], paramsConfig[SCRAPER_REQUEST_PARAMS.DOMAIN], paramsConfig[SCRAPER_REQUEST_PARAMS.DEVICE_TYPE], paramsConfig[SCRAPER_REQUEST_PARAMS.PAGE_FROM], paramsConfig[SCRAPER_REQUEST_PARAMS.PARSE]],
  [TARGET.AMAZON_REVIEWS]: [paramsConfig[SCRAPER_REQUEST_PARAMS.QUERY], paramsConfig[SCRAPER_REQUEST_PARAMS.DOMAIN], paramsConfig[SCRAPER_REQUEST_PARAMS.DEVICE_TYPE], paramsConfig[SCRAPER_REQUEST_PARAMS.PAGE_FROM], paramsConfig[SCRAPER_REQUEST_PARAMS.PARSE]],
  [TARGET.AMAZON_QUESTIONS]: [paramsConfig[SCRAPER_REQUEST_PARAMS.QUERY], paramsConfig[SCRAPER_REQUEST_PARAMS.DOMAIN], paramsConfig[SCRAPER_REQUEST_PARAMS.DEVICE_TYPE], paramsConfig[SCRAPER_REQUEST_PARAMS.PARSE]],
  [TARGET.AMAZON_SEARCH]: [paramsConfig[SCRAPER_REQUEST_PARAMS.QUERY], paramsConfig[SCRAPER_REQUEST_PARAMS.DOMAIN], paramsConfig[SCRAPER_REQUEST_PARAMS.DEVICE_TYPE], paramsConfig[SCRAPER_REQUEST_PARAMS.PAGE_FROM], paramsConfig[SCRAPER_REQUEST_PARAMS.AMAZON_CATEGORY_ID], paramsConfig[SCRAPER_REQUEST_PARAMS.MERCHANT], paramsConfig[SCRAPER_REQUEST_PARAMS.PARSE]],
  [TARGET.AMAZON_SELLERS]: [paramsConfig[SCRAPER_REQUEST_PARAMS.QUERY], paramsConfig[SCRAPER_REQUEST_PARAMS.LOCALE], paramsConfig[SCRAPER_REQUEST_PARAMS.DOMAIN], paramsConfig[SCRAPER_REQUEST_PARAMS.DEVICE_TYPE], paramsConfig[SCRAPER_REQUEST_PARAMS.PARSE]],
  [TARGET.AMAZON_BESTSELLERS]: [paramsConfig[SCRAPER_REQUEST_PARAMS.QUERY], paramsConfig[SCRAPER_REQUEST_PARAMS.DOMAIN], paramsConfig[SCRAPER_REQUEST_PARAMS.DEVICE_TYPE], paramsConfig[SCRAPER_REQUEST_PARAMS.GEO_CODE], paramsConfig[SCRAPER_REQUEST_PARAMS.PAGE_FROM], paramsConfig[SCRAPER_REQUEST_PARAMS.NUM_PAGES], paramsConfig[SCRAPER_REQUEST_PARAMS.CATEGORY], paramsConfig[SCRAPER_REQUEST_PARAMS.PARSE]],
  [TARGET.TIKTOK_POST]: [paramsConfig[SCRAPER_REQUEST_PARAMS.URL]],
  [TARGET.TIKTOK_PROFILE]: [paramsConfig[SCRAPER_REQUEST_PARAMS.URL]],
  [TARGET.TIKTOK_API_PROFILE]: [paramsConfig[SCRAPER_REQUEST_PARAMS.QUERY], paramsConfig[SCRAPER_REQUEST_PARAMS.TIKTOK_HASHTAG_ID], paramsConfig[SCRAPER_REQUEST_PARAMS.TIKTOK_TIMESTAMP], paramsConfig[SCRAPER_REQUEST_PARAMS.TIKTOK_API_COUNT]],
  [TARGET.TIKTOK_API_HASHTAG]: [paramsConfig[SCRAPER_REQUEST_PARAMS.QUERY], paramsConfig[SCRAPER_REQUEST_PARAMS.TIKTOK_HASHTAG_ID], paramsConfig[SCRAPER_REQUEST_PARAMS.TIKTOK_TIMESTAMP], paramsConfig[SCRAPER_REQUEST_PARAMS.TIKTOK_API_COUNT]],
  [TARGET.INSTAGRAM_GRAPHQL_POST]: [paramsConfig[SCRAPER_REQUEST_PARAMS.URL]],
  [TARGET.INSTAGRAM_GRAPHQL_PROFILE]: [paramsConfig[SCRAPER_REQUEST_PARAMS.QUERY]],
  [TARGET.INSTAGRAM_GRAPHQL_REEL]: [paramsConfig[SCRAPER_REQUEST_PARAMS.URL]],
  [TARGET.INSTAGRAM_GRAPHQL_USER_POSTS]: [paramsConfig[SCRAPER_REQUEST_PARAMS.QUERY], paramsConfig[SCRAPER_REQUEST_PARAMS.IG_GRAPHQL_COUNT], paramsConfig[SCRAPER_REQUEST_PARAMS.IG_GRAPHQL_CURSOR]],
  [TARGET.INSTAGRAM_GRAPHQL_USER_FOLLOWING]: [paramsConfig[SCRAPER_REQUEST_PARAMS.QUERY]],
  [TARGET.INSTAGRAM_GRAPHQL_USER_FOLLOWERS]: [paramsConfig[SCRAPER_REQUEST_PARAMS.QUERY]],
  [TARGET.INSTAGRAM_GRAPHQL_HASHTAG]: [paramsConfig[SCRAPER_REQUEST_PARAMS.QUERY], paramsConfig[SCRAPER_REQUEST_PARAMS.IG_GRAPHQL_COUNT], paramsConfig[SCRAPER_REQUEST_PARAMS.IG_GRAPHQL_CURSOR]],
  [TARGET.INSTAGRAM_GRAPHQL_HASHTAGS]: [paramsConfig[SCRAPER_REQUEST_PARAMS.QUERY], paramsConfig[SCRAPER_REQUEST_PARAMS.IG_GRAPHQL_COUNT], paramsConfig[SCRAPER_REQUEST_PARAMS.IG_GRAPHQL_CURSOR]],
  [TARGET.ECOMMERCE]: [paramsConfig[SCRAPER_REQUEST_PARAMS.URL], paramsConfig[SCRAPER_REQUEST_PARAMS.LOCALE], paramsConfig[SCRAPER_REQUEST_PARAMS.GEO], paramsConfig[SCRAPER_REQUEST_PARAMS.DEVICE_TYPE], paramsConfig[SCRAPER_REQUEST_PARAMS.HEADLESS], paramsConfig[SCRAPER_REQUEST_PARAMS.PARSE], paramsConfig[SCRAPER_REQUEST_PARAMS.PARSER_TYPE]],
  [TARGET.REDDIT_POST]: [paramsConfig[SCRAPER_REQUEST_PARAMS.URL], paramsConfig[SCRAPER_REQUEST_PARAMS.LOCALE], paramsConfig[SCRAPER_REQUEST_PARAMS.GEO]],
  [TARGET.REDDIT_SUBREDDIT]: [paramsConfig[SCRAPER_REQUEST_PARAMS.URL], paramsConfig[SCRAPER_REQUEST_PARAMS.LOCALE], paramsConfig[SCRAPER_REQUEST_PARAMS.GEO]],
  [TARGET.REDDIT_USER]: [paramsConfig[SCRAPER_REQUEST_PARAMS.URL], paramsConfig[SCRAPER_REQUEST_PARAMS.LOCALE], paramsConfig[SCRAPER_REQUEST_PARAMS.GEO]],
  [TARGET.SITE_UNBLOCKER]: [paramsConfig[SCRAPER_REQUEST_PARAMS.URL], paramsConfig[SCRAPER_REQUEST_PARAMS.GEO], paramsConfig[SCRAPER_REQUEST_PARAMS.HEADERS], paramsConfig[SCRAPER_REQUEST_PARAMS.SESSION_ID], paramsConfig[SCRAPER_REQUEST_PARAMS.HTTP_METHOD], paramsConfig[SCRAPER_REQUEST_PARAMS.CUSTOM_STATUS_CODE], paramsConfig[SCRAPER_REQUEST_PARAMS.CUSTOM_COOKIES], paramsConfig[SCRAPER_REQUEST_PARAMS.REQUEST_BODY], paramsConfig[SCRAPER_REQUEST_PARAMS.HEADLESS]],
  [TARGET.SITE_UNBLOCKER_REQ]: [paramsConfig[SCRAPER_REQUEST_PARAMS.URL], paramsConfig[SCRAPER_REQUEST_PARAMS.GEO], paramsConfig[SCRAPER_REQUEST_PARAMS.HEADERS], paramsConfig[SCRAPER_REQUEST_PARAMS.SESSION_ID], paramsConfig[SCRAPER_REQUEST_PARAMS.HTTP_METHOD], paramsConfig[SCRAPER_REQUEST_PARAMS.CUSTOM_STATUS_CODE], paramsConfig[SCRAPER_REQUEST_PARAMS.CUSTOM_COOKIES], paramsConfig[SCRAPER_REQUEST_PARAMS.REQUEST_BODY], paramsConfig[SCRAPER_REQUEST_PARAMS.HEADLESS]]
};
const targetConfig = {
  [TARGET.GOOGLE]: {
    format: 'json',
    supportScheduling: false,
    defaults: {
      url: ['https://www.google.com/search?q=pizza&source=hp&ei=OrK3ZITEEY6Ixc8P3NemmA4&iflsig=AD69kcEAAAAAZLfASni8y8AdTBIjpShc1wPCNRMLoubj&ved=0ahUKEwiEyafav5qAAxUORPEDHdyrCeMQ4dUDCAk&uact=5&oq=pizza&gs_lp=Egdnd3Mtd2l6IgVwaXp6YTILEC4YgAQYxwEY0QMyBRAAGIAEMgUQLhiABDIFEAAYgAQyBRAAGIAEMgUQABiABDIFEAAYgAQyCxAuGIAEGMcBGK8BMgsQLhiABBjHARivATIFEC4YgARI1ApQgARYyQlwAXgAkAEAmAF1oAGuBKoBAzAuNbgBA8gBAPgBAagCAA&sclient=gws-wiz']
    }
  },
  [TARGET.GOOGLE_SEARCH]: {
    format: 'json',
    supportScheduling: true,
    defaults: {
      query: PARAMETER_DEFAULT_VALUES.DEFAULT_QUERY
    }
  },
  [TARGET.GOOGLE_HOTELS]: {
    format: 'html',
    supportScheduling: false,
    defaults: {}
  },
  [TARGET.GOOGLE_TRAVEL_HOTELS]: {
    format: 'html',
    supportScheduling: true,
    defaults: {
      query: ['trivago']
    }
  },
  [TARGET.GOOGLE_TRENDS_EXPLORE]: {
    format: 'json',
    supportScheduling: false,
    defaults: {
      query: ['seo optimization']
    }
  },
  [TARGET.GOOGLE_MAPS]: {
    format: 'html',
    supportScheduling: true,
    defaults: {
      query: ['restaurants in barcelona']
    }
  },
  [TARGET.GOOGLE_IMAGES]: {
    format: 'html',
    supportScheduling: true,
    defaults: {
      query: ['https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Sheba1.JPG/800px-Sheba1.JPG']
    }
  },
  [TARGET.GOOGLE_SHOPPING_SEARCH]: {
    format: 'json',
    supportScheduling: true,
    defaults: {
      query: PARAMETER_DEFAULT_VALUES.DEFAULT_QUERY
    }
  },
  [TARGET.GOOGLE_SHOPPING_PRODUCT]: {
    format: 'json',
    supportScheduling: true,
    defaults: {
      query: ['3805205938126402128']
    }
  },
  [TARGET.GOOGLE_SHOPPING_PRICING]: {
    format: 'json',
    supportScheduling: true,
    defaults: {
      query: ['3805205938126402128']
    }
  },
  [TARGET.GOOGLE_SUGGEST]: {
    format: 'json',
    supportScheduling: true,
    defaults: {
      query: PARAMETER_DEFAULT_VALUES.DEFAULT_QUERY
    }
  },
  [TARGET.GOOGLE_ADS]: {
    format: 'json',
    supportScheduling: true,
    defaults: {
      query: PARAMETER_DEFAULT_VALUES.DEFAULT_QUERY
    }
  },
  [TARGET.GOOGLE_LENS]: {
    format: 'json',
    supportScheduling: false,
    defaults: {
      query: ['https://www.humanesociety.org/sites/default/files/2021-06/hamster-540188.jpg']
    }
  },
  [TARGET.BING]: {
    format: 'json',
    supportScheduling: true,
    defaults: {
      url: ['https://www.bing.com/search?q=pizza&form=QBLH&sp=-1&ghc=1&lq=0&pq=pizza&sc=10-5&qs=n&sk=&cvid=1BA925DE7F3C4081A886A53452B5070D&ghsh=0&ghacc=0&ghpl=']
    }
  },
  [TARGET.BING_SEARCH]: {
    format: 'json',
    supportScheduling: true,
    defaults: {
      query: PARAMETER_DEFAULT_VALUES.DEFAULT_QUERY
    }
  },
  [TARGET.UNIVERSAL_ECOMMERCE]: {
    format: 'html',
    supportScheduling: false,
    defaults: {}
  },
  [TARGET.AMAZON]: {
    format: 'json',
    supportScheduling: false,
    defaults: {
      url: ['https://www.amazon.com/dp/B09H74FXNW'],
      geo_code: '10001',
      headless: null
    }
  },
  [TARGET.AMAZON_PRODUCT]: {
    format: 'json',
    supportScheduling: false,
    defaults: {
      query: ['B09H74FXNW'],
      geo_code: '10001',
      headless: null
    }
  },
  [TARGET.AMAZON_PRICING]: {
    format: 'json',
    supportScheduling: false,
    defaults: {
      query: ['B09H74FXNW'],
      geo_code: '10001',
      headless: null
    }
  },
  [TARGET.AMAZON_REVIEWS]: {
    format: 'json',
    supportScheduling: true,
    defaults: {
      query: ['B09H74FXNW'],
      geo_code: '10001',
      headless: null
    }
  },
  [TARGET.AMAZON_QUESTIONS]: {
    format: 'json',
    supportScheduling: false,
    defaults: {
      query: ['B09H74FXNW'],
      geo_code: '10001',
      headless: null
    }
  },
  [TARGET.AMAZON_SEARCH]: {
    format: 'json',
    supportScheduling: true,
    defaults: {
      query: ['laptop'],
      geo_code: '10001',
      headless: null
    }
  },
  [TARGET.AMAZON_SELLERS]: {
    format: 'json',
    supportScheduling: false,
    defaults: {
      query: ['A1R0Z7FJGTKESH']
    }
  },
  [TARGET.AMAZON_BESTSELLERS]: {
    format: 'json',
    supportScheduling: false,
    defaults: {
      query: ['laptop']
    }
  },
  [TARGET.ECOMMERCE]: {
    format: 'json',
    supportScheduling: false,
    defaults: {
      url: ['https://www.walmart.com/ip/Marketside-Pepperoni-Pizza-Traditional-Crust-Extra-Large-44-6-oz-Fresh/579824441?athbdg=L1600&from=searchResults']
    }
  },
  [TARGET.UNIVERSAL]: {
    format: 'html',
    supportScheduling: true,
    defaults: {
      url: ['https://ip.smartproxy.com/'],
      urlZh: ['https://ip.smartdaili-china.com'],
      query: null
    }
  },
  [TARGET.TIKTOK_POST]: {
    format: 'json',
    supportScheduling: false,
    defaults: {
      url: ['https://www.tiktok.com/@nba/video/7255379108241198378']
    }
  },
  [TARGET.TIKTOK_PROFILE]: {
    format: 'json',
    supportScheduling: false,
    defaults: {
      url: ['https://www.tiktok.com/@nba']
    }
  },
  [TARGET.TIKTOK_API_HASHTAG]: {
    format: 'json',
    supportScheduling: false,
    defaults: {
      query: ['nba']
    }
  },
  [TARGET.TIKTOK_API_PROFILE]: {
    format: 'json',
    supportScheduling: false,
    defaults: {
      query: ['nba']
    }
  },
  [TARGET.INSTAGRAM_GRAPHQL_POST]: {
    format: 'json',
    supportScheduling: false,
    defaults: {
      url: ['https://www.instagram.com/p/CywoT0YPNEt/']
    }
  },
  [TARGET.INSTAGRAM_GRAPHQL_REEL]: {
    format: 'json',
    supportScheduling: false,
    defaults: {
      url: ['https://www.instagram.com/reel/ClfPAdQgqTc/']
    }
  },
  [TARGET.INSTAGRAM_GRAPHQL_PROFILE]: {
    format: 'json',
    supportScheduling: false,
    defaults: {
      query: ['nba']
    }
  },
  [TARGET.INSTAGRAM_GRAPHQL_USER_POSTS]: {
    format: 'json',
    supportScheduling: false,
    defaults: {
      query: ['nba'],
      count: '12'
    }
  },
  [TARGET.INSTAGRAM_GRAPHQL_USER_FOLLOWING]: {
    format: 'json',
    supportScheduling: false,
    defaults: {
      query: ['nba']
    }
  },
  [TARGET.INSTAGRAM_GRAPHQL_USER_FOLLOWERS]: {
    format: 'json',
    supportScheduling: false,
    defaults: {
      query: ['nba']
    }
  },
  [TARGET.INSTAGRAM_GRAPHQL_HASHTAG]: {
    format: 'json',
    supportScheduling: false,
    defaults: {
      query: ['nba'],
      count: '12'
    }
  },
  [TARGET.INSTAGRAM_GRAPHQL_HASHTAGS]: {
    format: 'json',
    supportScheduling: false,
    defaults: {
      query: ['nba'],
      count: '12'
    }
  },
  [TARGET.REDDIT_POST]: {
    format: 'json',
    supportScheduling: false,
    defaults: {
      url: ['https://www.reddit.com/r/nba/comments/17jrqc5/serious_next_day_thread_postgame_discussion/']
    }
  },
  [TARGET.REDDIT_SUBREDDIT]: {
    format: 'json',
    supportScheduling: false,
    defaults: {
      url: ['https://www.reddit.com/r/nba/']
    }
  },
  [TARGET.REDDIT_USER]: {
    format: 'json',
    supportScheduling: false,
    defaults: {
      url: ['https://www.reddit.com/user/IWasRightOnce/']
    }
  },
  [TARGET.SITE_UNBLOCKER_REQ]: {
    format: 'html',
    supportScheduling: false,
    defaults: {
      url: ['https://ip.smartproxy.com'],
      urlZh: ['https://ip.smartdaili-china.com'],
      headless: null
    }
  },
  [TARGET.SITE_UNBLOCKER]: {
    format: 'html',
    supportScheduling: false,
    defaults: {
      url: ['https://ip.smartproxy.com'],
      urlZh: ['https://ip.smartdaili-china.com'],
      headless: null
    }
  }
};

/**
 * Throw organic and paid results into one array
 * @param {GoogleResult[]} paid - Paid results
 * @param {GoogleResult[]} organic - Organic results
 */
const mergeOrganicAndPaidGoogleResults = ({
  paid = [],
  organic = []
}) => {
  const paidResults = paid.map(paidResult => ({
    ...paidResult,
    source: 'paid'
  }));
  const organicResults = organic.map(organicResult => ({
    ...organicResult,
    source: 'organic'
  }));
  return [...paidResults, ...organicResults];
};
const mergeOrganicAndExactMatchGoogleLensResults = ({
  organic = [],
  exact_match = []
}) => {
  const organicResults = organic.map(organicResult => ({
    ...organicResult,
    source: 'organic'
  }));
  const exactMatchResults = exact_match.map(exactMatchResult => ({
    ...exactMatchResult,
    source: 'exact_match'
  }));
  return [...organicResults, ...exactMatchResults];
};

const CSV_COLUMNS = {
  [TARGET.ECOMMERCE]: ['url', 'price', 'title', 'description'],
  [TARGET.GOOGLE_SEARCH]: ['pos', 'url', 'title', 'desc', 'source'],
  [TARGET.GOOGLE]: ['pos', 'url', 'title', 'desc'],
  [TARGET.GOOGLE_SHOPPING_SEARCH]: ['pos', 'url', 'type', 'price', 'title', 'currency', 'delivery', 'price_str', 'thumbnail', 'pos_overall'],
  [TARGET.GOOGLE_SHOPPING_PRODUCT]: ['price', 'seller', 'details', 'currency', 'condition', 'price_tax', 'price_total', 'seller_link', 'price_shipping'],
  [TARGET.GOOGLE_SUGGEST]: ['suggestion'],
  [TARGET.GOOGLE_ADS]: ['pos', 'url', 'title', 'desc', 'source'],
  [TARGET.GOOGLE_TRENDS_EXPLORE]: ['mid', 'title', 'type', 'value', 'formatted_value', 'link'],
  [TARGET.GOOGLE_LENS]: ['pos', 'url', 'title', 'domain', 'pos_overall', 'url_thumbnail', 'source'],
  [TARGET.BING]: ['pos', 'url', 'title', 'desc'],
  [TARGET.BING_SEARCH]: ['pos', 'url', 'title', 'desc'],
  [TARGET.AMAZON]: ['pos', 'url', 'asin', 'price', 'title', 'rating', 'source', 'currency', 'is_prime', 'url_image', 'best_seller', 'price_upper', 'is_sponsored', 'manufacturer', 'pricing_count', 'reviews_count', 'is_amazons_choice', 'price_strikethrough', 'shipping_information'],
  [TARGET.AMAZON_SEARCH]: ['pos', 'url', 'asin', 'price', 'title', 'rating', 'source', 'currency', 'is_prime', 'url_image', 'best_seller', 'price_upper', 'is_sponsored', 'manufacturer', 'pricing_count', 'reviews_count', 'is_amazons_choice', 'price_strikethrough', 'shipping_information'],
  [TARGET.AMAZON_PRODUCT]: ['url', 'asin', 'page', 'price', 'stock', 'title', 'coupon', 'images', 'rating', 'currency', '_warnings', 'deal_type', 'page_type', 'price_sns', 'has_videos', 'top_review', 'asin_in_url', 'description', 'parent_asin', 'price_upper', 'pricing_str', 'pricing_url', 'discount_end', 'manufacturer', 'max_quantity', 'price_buybox', 'product_name', 'amazon_choice', 'bullet_points', 'is_addon_item', 'price_initial', 'pricing_count', 'reviews_count', 'lightning_deal', 'price_shipping', 'is_prime_pantry'],
  [TARGET.AMAZON_PRICING]: ['price', 'seller', 'currency', 'delivery', 'condition', 'seller_id', 'seller_link', 'rating_count', 'price_shipping'],
  [TARGET.AMAZON_REVIEWS]: ['id', 'title', 'author', 'rating', 'content', 'timestamp', 'is_verified', 'product_attributes'],
  [TARGET.AMAZON_QUESTIONS]: ['title', 'votes', 'answer', 'answer_author'],
  [TARGET.AMAZON_BESTSELLERS]: ['pos', 'url', 'asin', 'price', 'title', 'rating', 'currency', 'is_prime', 'price_str', 'price_upper', 'ratings_count'],
  [TARGET.TIKTOK_API_PROFILE]: ['id', 'desc', 'createTime', 'plays', 'shares', 'comments', 'diggs'],
  [TARGET.INSTAGRAM_GRAPHQL_PROFILE]: ['id', 'text', 'comment_count', 'taken_at_timestamp', 'accessibility_caption', 'is_video', 'comments_disabled', 'display_url'],
  [TARGET.INSTAGRAM_GRAPHQL_POST]: ['id', 'text', 'like_count', 'comment_count', 'accessibility_caption', 'display_url', 'created_at'],
  [TARGET.INSTAGRAM_GRAPHQL_REEL]: ['id', 'text', 'created_at', 'video_view_count', 'video_play_count', 'comment_count', 'is_video', 'video_duration', 'display_url'],
  [TARGET.INSTAGRAM_GRAPHQL_USER_POSTS]: ['id', 'text', 'shortcode', 'like_count', 'comment_count', 'display_url', 'is_video'],
  [TARGET.INSTAGRAM_GRAPHQL_HASHTAGS]: ['id', 'text', 'owner_id', 'comment_count', 'like_count', 'shortcode', 'taken_at_timestamp', 'display_url', 'thumbnail_src', 'is_video', 'width', 'height'],
  [TARGET.REDDIT_POST]: ['body', 'author', 'ups', 'downs', 'created_utc', 'permalink'],
  [TARGET.REDDIT_SUBREDDIT]: ['title', 'selftext', 'ups', 'downs'],
  [TARGET.REDDIT_USER]: ['subreddit', 'body', 'link_title', 'link_author', 'created_utc', 'link_url']
};

const mergeOrganicAndPaidAmazonResults = ({
  paid,
  organic
}) => {
  const paidResults = paid.map(paidResult => ({
    ...paidResult,
    source: 'paid'
  }));
  const organicResults = organic.map(organicResult => ({
    ...organicResult,
    source: 'organic'
  }));
  return [...paidResults, ...organicResults];
};

const checkParsingStatus = record => {
  if (Object.keys(record).length < 4) return null;
  return [record];
};

const getCSVString = ({
  target,
  data
}) => {
  const {
    selectData,
    columns,
    rowAccessor
  } = scrapingCSVFormat.get(target);
  const selectedData = selectData(data);
  const csvRows = selectedData.map(row => columns.map(key => rowAccessor ? rowAccessor(row)[key] : row[key]).join(';')).join('\n');
  return csvRows;
};
const scrapingCSVFormat = new Map([[TARGET.GOOGLE_SEARCH, {
  selectData: data => mergeOrganicAndPaidGoogleResults(data.results.results),
  columns: CSV_COLUMNS[TARGET.GOOGLE_SEARCH]
}], [TARGET.ECOMMERCE, {
  selectData: data => checkParsingStatus(data.results),
  columns: CSV_COLUMNS[TARGET.ECOMMERCE]
}], [TARGET.GOOGLE, {
  selectData: data => mergeOrganicAndPaidGoogleResults(data.results.results),
  columns: CSV_COLUMNS[TARGET.GOOGLE]
}], [TARGET.GOOGLE_SHOPPING_SEARCH, {
  selectData: data => mergeOrganicAndPaidGoogleResults(data.results.results),
  columns: CSV_COLUMNS[TARGET.GOOGLE_SHOPPING_SEARCH]
}], [TARGET.GOOGLE_SHOPPING_PRODUCT, {
  selectData: data => data.results.pricing.online,
  columns: CSV_COLUMNS[TARGET.GOOGLE_SHOPPING_PRODUCT]
}], [TARGET.GOOGLE_SUGGEST, {
  selectData: data => data[1].map(suggestion => ({
    suggestion
  })),
  columns: CSV_COLUMNS[TARGET.GOOGLE_SUGGEST]
}], [TARGET.GOOGLE_ADS, {
  selectData: data => mergeOrganicAndPaidGoogleResults(data.results.results),
  columns: CSV_COLUMNS[TARGET.GOOGLE_ADS]
}], [TARGET.GOOGLE_LENS, {
  selectData: data => mergeOrganicAndExactMatchGoogleLensResults(data.results.results),
  columns: CSV_COLUMNS[TARGET.GOOGLE_LENS]
}], [TARGET.GOOGLE_TRENDS_EXPLORE, {
  selectData: data => data.related_topics[0].items,
  rowAccessor: data => {
    const {
      topic: {
        mid,
        title,
        type
      }
    } = data;
    return {
      ...data,
      mid,
      title,
      type
    };
  },
  columns: CSV_COLUMNS[TARGET.GOOGLE_TRENDS_EXPLORE]
}], [TARGET.BING, {
  selectData: data => data.results.results.organic,
  columns: CSV_COLUMNS[TARGET.BING]
}], [TARGET.BING_SEARCH, {
  selectData: data => data.results.results.organic,
  columns: CSV_COLUMNS[TARGET.BING_SEARCH]
}], [TARGET.AMAZON, {
  selectData: data => mergeOrganicAndPaidAmazonResults(data.results.results),
  columns: CSV_COLUMNS[TARGET.AMAZON]
}], [TARGET.AMAZON_SEARCH, {
  selectData: data => mergeOrganicAndPaidAmazonResults(data.results.results),
  columns: CSV_COLUMNS[TARGET.AMAZON_SEARCH]
}], [TARGET.AMAZON_PRODUCT, {
  selectData: data => [data.results],
  columns: CSV_COLUMNS[TARGET.AMAZON_PRODUCT]
}], [TARGET.AMAZON_PRICING, {
  selectData: data => data.results.pricing,
  columns: CSV_COLUMNS[TARGET.AMAZON_PRICING]
}], [TARGET.AMAZON_REVIEWS, {
  selectData: data => data.results.reviews,
  columns: CSV_COLUMNS[TARGET.AMAZON_REVIEWS]
}], [TARGET.AMAZON_QUESTIONS, {
  selectData: data => {
    return data.results.questions;
  },
  rowAccessor: ({
    title,
    votes,
    answers: [firstAnswer]
  }) => ({
    title,
    votes,
    ...(firstAnswer && {
      answer: firstAnswer.content,
      answer_author: firstAnswer.author
    })
  }),
  columns: CSV_COLUMNS[TARGET.AMAZON_QUESTIONS]
}], [TARGET.AMAZON_BESTSELLERS, {
  selectData: data => data.results.results,
  columns: CSV_COLUMNS[TARGET.AMAZON_BESTSELLERS]
}], [TARGET.TIKTOK_API_PROFILE, {
  selectData: data => data.itemList,
  rowAccessor: data => {
    const {
      stats: {
        commentCount: comments,
        diggCount: diggs,
        playCount: plays,
        shareCount: shares
      },
      video: {
        cover,
        definition,
        duration,
        format
      }
    } = data;
    return {
      ...data,
      comments,
      diggs,
      plays,
      shares,
      cover,
      definition,
      duration,
      format
    };
  },
  columns: CSV_COLUMNS[TARGET.TIKTOK_API_PROFILE]
}], [TARGET.INSTAGRAM_GRAPHQL_PROFILE, {
  selectData: data => data.data.user.edge_owner_to_timeline_media.edges,
  rowAccessor: ({
    node
  }) => {
    const {
      edge_media_to_caption,
      edge_media_to_comment
    } = node;
    return {
      text: edge_media_to_caption.edges[0].node.text,
      comment_count: edge_media_to_comment.count,
      ...node
    };
  },
  columns: CSV_COLUMNS[TARGET.INSTAGRAM_GRAPHQL_PROFILE]
}], [TARGET.INSTAGRAM_GRAPHQL_POST, {
  selectData: data => [data.shortcode_media],
  rowAccessor: data => {
    const {
      edge_media_to_caption: {
        edges: [{
          node: {
            text,
            created_at
          }
        }]
      },
      edge_media_to_parent_comment: {
        count: comment_count
      },
      edge_media_preview_like: {
        count: like_count
      }
    } = data;
    return {
      ...data,
      text,
      comment_count,
      like_count,
      created_at
    };
  },
  columns: CSV_COLUMNS[TARGET.INSTAGRAM_GRAPHQL_POST]
}], [TARGET.INSTAGRAM_GRAPHQL_REEL, {
  selectData: data => [data.shortcode_media],
  rowAccessor: data => {
    const {
      edge_media_to_caption: {
        edges: [{
          node: {
            text,
            created_at
          }
        }]
      },
      edge_media_preview_comment: {
        count: comment_count
      }
    } = data;
    return {
      ...data,
      text,
      created_at,
      comment_count
    };
  },
  columns: CSV_COLUMNS[TARGET.INSTAGRAM_GRAPHQL_REEL]
}], [TARGET.INSTAGRAM_GRAPHQL_USER_POSTS, {
  selectData: data => data.data.user.edge_owner_to_timeline_media.edges,
  rowAccessor: ({
    node
  }) => {
    return {
      ...node,
      text: node.edge_media_to_caption.edges[0].node.text,
      like_count: node.edge_media_preview_like.count,
      comment_count: node.edge_media_to_comment.count
    };
  },
  columns: CSV_COLUMNS[TARGET.INSTAGRAM_GRAPHQL_USER_POSTS]
}], [TARGET.INSTAGRAM_GRAPHQL_HASHTAGS, {
  selectData: data => {
    return data?.data?.hashtag?.edge_hashtag_to_media?.edges;
  },
  rowAccessor: ({
    node
  }) => {
    return {
      ...node,
      text: node.edge_media_to_caption.edges[0].node.text,
      owner_id: node?.owner?.id,
      comment_count: node?.edge_media_to_comment?.count,
      like_count: node?.edge_liked_by.count,
      width: node?.dimensions?.width,
      height: node?.dimensions?.height
    };
  },
  columns: CSV_COLUMNS[TARGET.INSTAGRAM_GRAPHQL_HASHTAGS]
}], [TARGET.REDDIT_POST, {
  selectData: data => data[1].data.children,
  columns: CSV_COLUMNS[TARGET.REDDIT_POST]
}], [TARGET.REDDIT_SUBREDDIT, {
  selectData: data => data.data.children,
  columns: CSV_COLUMNS[TARGET.REDDIT_SUBREDDIT]
}], [TARGET.REDDIT_USER, {
  selectData: data => data.data.children,
  columns: CSV_COLUMNS[TARGET.REDDIT_USER]
}]]);

var TASK_STATUS;
(function (TASK_STATUS) {
  TASK_STATUS["PENDING"] = "pending";
  TASK_STATUS["DONE"] = "done";
  TASK_STATUS["SCRAPING_DONE"] = "scraping_done";
  TASK_STATUS["DELIVERY_DONE"] = "delivery_done";
  TASK_STATUS["SCRAPING_FAILED"] = "scraping_failed";
  TASK_STATUS["DELIVERY_FAILED"] = "delivery_failed";
})(TASK_STATUS || (TASK_STATUS = {}));
var TASK_BATCH_STATUS;
(function (TASK_BATCH_STATUS) {
  TASK_BATCH_STATUS["PENDING"] = "pending";
  TASK_BATCH_STATUS["DONE"] = "done";
  TASK_BATCH_STATUS["DONE_WITH_ERRORS"] = "done_with_errors";
  TASK_BATCH_STATUS["FAILED"] = "failed";
})(TASK_BATCH_STATUS || (TASK_BATCH_STATUS = {}));

export { INPUT_TYPES, NO_SELECTION, PARAMETER_DEFAULT_VALUES, PARAM_GROUPS, PROXY_TYPE, ProductTargets, SCRAPER_REQUEST_PARAMS, SCRAPER_REQUEST_PARAM_GROUPS, SCRAPING_PRODUCT, TARGET, TASK_BATCH_STATUS, TASK_STATUS, categoryOptions, chinaDocs, deviceOptions, domainOptions, geoCodeOptions, getCSVString, getLocaleOptions, globalDocs, httpMethodOptions, jsRenderingOptions, languageOptions, localeDetails, localeOptions, locationOptions, paramsConfig, parserTypeOptions, playgroundDomainOptions, ratingOptions, resultLocaleOptions, scrapingCSVFormat, searchTypeOptions, targetConfig, targetParamMap, tbmOptions };
//# sourceMappingURL=main.mjs.map
